import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  CustomerProfileAnswer: { input: any; output: any; }
  NumberOrString: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
};

export type Accumulations = {
  __typename: 'Accumulations';
  purchaseCount?: Maybe<Scalars['Int']['output']>;
  returnAmount?: Maybe<Scalars['Float']['output']>;
  saleAmount?: Maybe<Scalars['Float']['output']>;
};

export type AddressForDeliveryRequestInput = {
  address: Scalars['String']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type AddressSuggestionFilterInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  maxResults?: InputMaybe<Scalars['Int']['input']>;
};

export type ApplyPromocodeResult = {
  __typename: 'ApplyPromocodeResult';
  info?: Maybe<PromocodeInfo>;
  promocode: Scalars['String']['output'];
  status?: Maybe<Scalars['Int']['output']>;
  used?: Maybe<Scalars['Boolean']['output']>;
};

export type BankDetails = {
  __typename: 'BankDetails';
  accountNumber?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bik?: Maybe<Scalars['String']['output']>;
};

export type BankDetailsInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  bik?: InputMaybe<Scalars['String']['input']>;
};

export type BannerInfo = {
  __typename: 'BannerInfo';
  bannerMobileSlide?: Maybe<File>;
  bannerSlide?: Maybe<File>;
  /** Button color */
  button_color?: Maybe<Scalars['String']['output']>;
  /** Button text */
  button_text?: Maybe<Scalars['String']['output']>;
  /** If banner has button */
  has_button?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Used only for administration purposes */
  name?: Maybe<Scalars['String']['output']>;
  /** (app-only) If true - always open in browser, prevent deep linking */
  optionOpenInBrowser?: Maybe<Scalars['Boolean']['output']>;
  /** If true - open link in new window */
  optionOpenInNewWindow?: Maybe<Scalars['Boolean']['output']>;
  /** 0 - disabled, 1 - active */
  status?: Maybe<Scalars['Int']['output']>;
  /** Url on click */
  url?: Maybe<Scalars['String']['output']>;
};


export type BannerInfoBannerMobileSlideArgs = {
  style?: InputMaybe<Scalars['String']['input']>;
};


export type BannerInfoBannerSlideArgs = {
  style?: InputMaybe<Scalars['String']['input']>;
};

export type BannersEdge = {
  __typename: 'BannersEdge';
  edges?: Maybe<Array<Maybe<BannerInfo>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type Barcode = {
  __typename: 'Barcode';
  code?: Maybe<Scalars['String']['output']>;
  /**  Type of dynamic code (enum): QR | BARCODE | CODE128 | UPC_A */
  type?: Maybe<Scalars['String']['output']>;
};

export type BonusCard = {
  __typename: 'BonusCard';
  barCode?: Maybe<Scalars['String']['output']>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /**  Status of bonus card (enum): notActivated | active | replaced | blocked  */
  status?: Maybe<Scalars['String']['output']>;
};

export type BonusOperation = {
  __typename: 'BonusOperation';
  /** Returns bonus OR token */
  accountType?: Maybe<Scalars['String']['output']>;
  /** Activation time */
  activationAt?: Maybe<Scalars['Timestamp']['output']>;
  /** operation amount */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Comment from shop for operation */
  comment?: Maybe<Scalars['String']['output']>;
  /** Expiration timestamp */
  expireAt?: Maybe<Scalars['Timestamp']['output']>;
  /** ID of operation */
  id?: Maybe<Scalars['ID']['output']>;
  /** Time of operation */
  operationAt?: Maybe<Scalars['Timestamp']['output']>;
  /** ID of purchase if exists */
  purchaseId?: Maybe<Scalars['String']['output']>;
  /** Time of sale for which operation applied */
  saledAt?: Maybe<Scalars['Timestamp']['output']>;
  /** Operation type (enum): charge | chargePaymentReturn | activate | cancel | block | unblock | writeOff | writeOffByReturn | writeOffBlocked | expire | prolong | unknown */
  type?: Maybe<Scalars['String']['output']>;
};

export type Brand = {
  __typename: 'Brand';
  defaultShop?: Maybe<Shop>;
  default_shop_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<File>;
  name: Scalars['String']['output'];
  primaryColorHex?: Maybe<Scalars['String']['output']>;
  primaryTextColorHex?: Maybe<Scalars['String']['output']>;
  shops?: Maybe<Array<Maybe<Shop>>>;
  /** Used if platform is using in multi-brand schema */
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};


export type BrandLogoArgs = {
  style?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessProfile = {
  __typename: 'BusinessProfile';
  accountRP?: Maybe<Scalars['Int']['output']>;
  accounts?: Maybe<Array<Maybe<BusinessProfileAccountInfo>>>;
  address?: Maybe<Scalars['String']['output']>;
  attorneyScan?: Maybe<File>;
  bankDetails?: Maybe<BankDetails>;
  country?: Maybe<Country>;
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  /** Used if company can have deferred payment */
  deferredInfo?: Maybe<BusinessProfileDeferredInfo>;
  director?: Maybe<Scalars['String']['output']>;
  directorConfirmScan?: Maybe<File>;
  id: Scalars['ID']['output'];
  monthlyRevenue?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  orders?: Maybe<Array<Maybe<Order>>>;
  owner?: Maybe<BusinessProfileAccountInfo>;
  phone_number?: Maybe<Scalars['String']['output']>;
  registrationScan?: Maybe<File>;
  require_invoice?: Maybe<Scalars['Boolean']['output']>;
  signAuthorizedPerson?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  tin: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['Timestamp']['output']>;
  vat_enabled?: Maybe<Scalars['Boolean']['output']>;
  xid?: Maybe<Scalars['String']['output']>;
};

export type BusinessProfileAccountInfo = {
  __typename: 'BusinessProfileAccountInfo';
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  manager_status: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
};

export type BusinessProfileDeferredInfo = {
  __typename: 'BusinessProfileDeferredInfo';
  deferred_payment_amount_limit?: Maybe<Scalars['Float']['output']>;
  deferred_payment_available_limit?: Maybe<Scalars['Float']['output']>;
  deferred_payment_days?: Maybe<Scalars['Int']['output']>;
  deferred_payment_status?: Maybe<Scalars['Int']['output']>;
};

export type BusinessProfileExistsResponse = {
  __typename: 'BusinessProfileExistsResponse';
  exists?: Maybe<Scalars['Boolean']['output']>;
};

export type BusinessProfileInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  attorney_scan_id?: InputMaybe<Scalars['ID']['input']>;
  bankDetails?: InputMaybe<BankDetailsInput>;
  company_registration_scan_id?: InputMaybe<Scalars['ID']['input']>;
  country_id: Scalars['Int']['input'];
  director?: InputMaybe<Scalars['String']['input']>;
  director_confirm_scan_id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
  require_invoice?: InputMaybe<Scalars['Boolean']['input']>;
  signAuthorizedPerson?: InputMaybe<Scalars['String']['input']>;
  tin: Scalars['String']['input'];
  type: Scalars['String']['input'];
  vat_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CancelReason = {
  __typename: 'CancelReason';
  canComment?: Maybe<Scalars['Boolean']['output']>;
  requireComment?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Cart = {
  __typename: 'Cart';
  amount?: Maybe<Scalars['Int']['output']>;
  delivery_cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  product_id?: Maybe<Scalars['ID']['output']>;
  shop_id?: Maybe<Scalars['ID']['output']>;
  usedPromocode?: Maybe<Scalars['String']['output']>;
};

export type CartDataInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  offer_id?: InputMaybe<Scalars['ID']['input']>;
  product_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CartDeliveryCostInfo = {
  __typename: 'CartDeliveryCostInfo';
  from?: Maybe<Scalars['Float']['output']>;
  maxSale?: Maybe<Scalars['Float']['output']>;
  promoPercent?: Maybe<Scalars['Float']['output']>;
  sale?: Maybe<Scalars['Float']['output']>;
  salePercent?: Maybe<Scalars['Float']['output']>;
  timeRestrictions?: Maybe<Array<Maybe<CartTimeRestriction>>>;
  total?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CartInfo = {
  __typename: 'CartInfo';
  delivery?: Maybe<CartDeliveryCostInfo>;
  /** Price group, that is used for this customer */
  priceGroup?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<ExtendedCartItem>>>;
  saleAddedPositions?: Maybe<Array<Maybe<SaleAddedPosition>>>;
  promocode?: Maybe<Scalars['String']['output']>;
  promocodeType?: Maybe<Scalars['String']['output']>;
  totals?: Maybe<CartInfoTotals>;
};

export type CartInfoInput = {
  customerGeoPoint?: InputMaybe<GeoPointInput>;
  deliveryType?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<CartDataInput>>>;
  promocode?: InputMaybe<Scalars['String']['input']>;
  shop_id: Scalars['ID']['input'];
  /** Required if using geo-based delivery (slot/express) */
  zone_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CartInfoOutput = {
  __typename: 'CartInfoOutput';
  items?: Maybe<Array<Maybe<CartInfoOutputProduct>>>;
  shop_id?: Maybe<Scalars['ID']['output']>;
};

export type CartInfoOutputProduct = {
  __typename: 'CartInfoOutputProduct';
  amount?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  offer_id?: Maybe<Scalars['ID']['output']>;
  product_id?: Maybe<Scalars['ID']['output']>;
};

export type CartInfoProducts = {
  __typename: 'CartInfoProducts';
  delivery?: Maybe<CartDeliveryCostInfo>;
  /** Price group, that is used for this customer */
  priceGroup?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<ExtendedCartItem>>>;
  saleAddedPositions?: Maybe<Array<Maybe<SaleAddedPosition>>>;
  promocode?: Maybe<Scalars['String']['output']>;
  promocodeType?: Maybe<Scalars['String']['output']>;
  saleErrors?: Maybe<Array<Maybe<CartSaleError>>>;
  /** Total weight of cart */
  totalWeight?: Maybe<Scalars['Int']['output']>;
  totals?: Maybe<CartInfoTotals>;
};

export type CartSaleErrorInputPart = {
  __typename: 'CartSaleErrorInputPart';
  promocodes?: Maybe<SalePromocodeInputPart>;
};

export type CartSaleError = {
  __typename: 'CartSaleError';
  inputPart?: Maybe<CartSaleErrorInputPart>;
  internalCode?: Maybe<Scalars['String']['output']>;
  internalIssuer?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SalePromocodeInputPart = {
  __typename: 'SalePromocodeInputPart';
  code?: Maybe<Scalars['String']['output']>;
};

export type CartInfoTotals = {
  __typename: 'CartInfoTotals';
  /** Sum of catalog sales */
  baseSale?: Maybe<Scalars['Float']['output']>;
  /** Basic cost of products in cart */
  baseTotal?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  /** Max allowed sale */
  maxSale?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Legacy purposes */
  promoPercent?: Maybe<Scalars['Float']['output']>;
  /** Sale total from non-catalog sales(promocodes, loyalty program and other sources) */
  sale?: Maybe<Scalars['Float']['output']>;
  /** Sale percent from non-catalog sales */
  salePercent?: Maybe<Scalars['Float']['output']>;
  /** Cost of products with catalog discounts */
  total?: Maybe<Scalars['Float']['output']>;
};

export type CartTimeRestriction = {
  __typename: 'CartTimeRestriction';
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type CategoriesBranch = {
  __typename: 'CategoriesBranch';
  altIcon?: Maybe<File>;
  childrens?: Maybe<Array<Maybe<CategoriesBranch>>>;
  icon?: Maybe<File>;
  id?: Maybe<Scalars['ID']['output']>;
  is_alcohol?: Maybe<Scalars['Boolean']['output']>;
  miniIcon?: Maybe<File>;
  name?: Maybe<Scalars['String']['output']>;
  preview_size?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};


export type CategoriesBranchAltIconArgs = {
  style?: InputMaybe<Scalars['String']['input']>;
};


export type CategoriesBranchIconArgs = {
  style?: InputMaybe<Scalars['String']['input']>;
};


export type CategoriesBranchMiniIconArgs = {
  style?: InputMaybe<Scalars['String']['input']>;
};

export type Category = {
  __typename: 'Category';
  altIcon?: Maybe<File>;
  icon?: Maybe<File>;
  id?: Maybe<Scalars['ID']['output']>;
  is_alcohol?: Maybe<Scalars['Boolean']['output']>;
  miniIcon?: Maybe<File>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Category>;
  parent_id?: Maybe<Scalars['Int']['output']>;
  preview_size?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<Product>>>;
  slug?: Maybe<Scalars['String']['output']>;
};


export type CategoryAltIconArgs = {
  style?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryIconArgs = {
  style?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryMiniIconArgs = {
  style?: InputMaybe<Scalars['String']['input']>;
};

export type ChoosePaymentMethodForOrderResult = {
  __typename: 'ChoosePaymentMethodForOrderResult';
  affectedOrdersAmount?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<UserOrder>;
  paymentMethod?: Maybe<CustomerPaymentMethod>;
};

export type City = {
  __typename: 'City';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  region?: Maybe<Region>;
  region_id: Scalars['ID']['output'];
  shops?: Maybe<Array<Maybe<Shop>>>;
};

export type CommonListControlsInput = {
  _limit?: InputMaybe<Scalars['Int']['input']>;
  _page?: InputMaybe<Scalars['Int']['input']>;
};

export type CommonPagerInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type CommonSortInput = {
  /** 0 - desc, 1 - asc */
  direction?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the field, which we are using for sort */
  fieldName?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmationToken = {
  __typename: 'ConfirmationToken';
  token: Scalars['String']['output'];
};

export type Country = {
  __typename: 'Country';
  ISO2: Scalars['String']['output'];
  ISO3: Scalars['String']['output'];
  currency_name?: Maybe<Scalars['String']['output']>;
  currency_symbol?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  iso_numeric?: Maybe<Scalars['Int']['output']>;
  language_codes?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone_code?: Maybe<Scalars['Int']['output']>;
  regions?: Maybe<Array<Maybe<Region>>>;
  web_domain?: Maybe<Scalars['String']['output']>;
};

export type CouponInfo = {
  __typename: 'CouponInfo';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  localInfo?: Maybe<LocalCouponInfo>;
  name?: Maybe<Scalars['String']['output']>;
  qrCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['Timestamp']['output']>;
  validTo?: Maybe<Scalars['Timestamp']['output']>;
};

export type CourierContact = {
  __typename: 'CourierContact';
  phone?: Maybe<Scalars['String']['output']>;
  phoneExt?: Maybe<Scalars['String']['output']>;
  position?: Maybe<CourierContactPosition>;
};

export type CourierContactPosition = {
  __typename: 'CourierContactPosition';
  direction?: Maybe<Scalars['Int']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
  timestamp?: Maybe<Scalars['Timestamp']['output']>;
};

export type CreateBusinessProfileResponse = {
  __typename: 'CreateBusinessProfileResponse';
  businessProfile?: Maybe<BusinessProfile>;
  created?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerAddress = {
  __typename: 'CustomerAddress';
  address?: Maybe<Scalars['String']['output']>;
  address_appartments?: Maybe<Scalars['String']['output']>;
  address_floor?: Maybe<Scalars['String']['output']>;
  address_intercom?: Maybe<Scalars['String']['output']>;
  address_porch?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  customerGeoPoint?: Maybe<GeoPoint>;
  door_delivery?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  no_door_call?: Maybe<Scalars['Boolean']['output']>;
  other_recipient?: Maybe<Scalars['Boolean']['output']>;
  recipient_last_name?: Maybe<Scalars['String']['output']>;
  recipient_name?: Maybe<Scalars['String']['output']>;
  recipient_phone?: Maybe<Scalars['String']['output']>;
  shop?: Maybe<Shop>;
  shop_id?: Maybe<Scalars['ID']['output']>;
};

export type CustomerAddressInput = {
  /**  address in free format, for pickup points this is the address of the pickup point */
  address: Scalars['String']['input'];
  /**  address appartments, for example: 12, 34 */
  address_appartments?: InputMaybe<Scalars['String']['input']>;
  /**  address floor, for example: 1, 2, 3 */
  address_floor?: InputMaybe<Scalars['String']['input']>;
  /**  address intercom, for example: B1234, 0099 */
  address_intercom?: InputMaybe<Scalars['String']['input']>;
  /**  address porch/entrance, for example: 1, 2, A, B. Note! Could be a string with letters and numbers. */
  address_porch?: InputMaybe<Scalars['String']['input']>;
  /**  customer comment, for example: 'leave at the door', 'call me when you arrive' */
  comment?: InputMaybe<Scalars['String']['input']>;
  /**  geo point of the address, used for delivery. For pickup points this is the geo point of the pickup point */
  customerGeoPoint: GeoPointInput;
  /**  if courier should leave the order at the door */
  door_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /**  if courier shouldn't call to intercom or use doorbell */
  no_door_call?: InputMaybe<Scalars['Boolean']['input']>;
  /**  if order will be delivered to another person */
  other_recipient?: InputMaybe<Scalars['Boolean']['input']>;
  /**  recipient's last name */
  recipient_last_name?: InputMaybe<Scalars['String']['input']>;
  /**  recipient's name, required if other_recipient is true */
  recipient_name?: InputMaybe<Scalars['String']['input']>;
  /**  recipient's phone number, required if other_recipient is true */
  recipient_phone?: InputMaybe<Scalars['String']['input']>;
  /**  ID of the shop. Used for pickup points */
  shop_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CustomerBonusInfo = {
  __typename: 'CustomerBonusInfo';
  /** Accumulations */
  accumulations?: Maybe<Accumulations>;
  /** Customer can use this bonuses */
  activeBonuses?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use `bonusCards` array of cards */
  barCode?: Maybe<Scalars['String']['output']>;
  bonusBalance?: Maybe<Scalars['Float']['output']>;
  bonusCards?: Maybe<Array<Maybe<BonusCard>>>;
  /** @deprecated use `bonusCards` array of cards */
  cardNumber?: Maybe<Scalars['String']['output']>;
  haveBonusCard?: Maybe<Scalars['Boolean']['output']>;
  /** Information about loyalty level */
  loyaltyLevelInfo?: Maybe<LoyaltyLevel>;
  /** Expiring bonuses */
  nearestExpiringBonus?: Maybe<NearestExpiringBonus>;
  /** Information about not activated bonuses */
  pendingBonuses?: Maybe<Array<Maybe<PendingBonus>>>;
  supportsDynamicCode?: Maybe<Scalars['Boolean']['output']>;
  /** Token accounts */
  tokenAccounts?: Maybe<Array<Maybe<TokenAccountInfo>>>;
};

export type CustomerDeletionResult = {
  __typename: 'CustomerDeletionResult';
  customerInfo?: Maybe<UserInfo>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerInfoInput = {
  birthday?: InputMaybe<Scalars['Timestamp']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  receipt_email?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerMobileAppConfig = {
  __typename: 'CustomerMobileAppConfig';
  alerts?: Maybe<Array<Maybe<MobileAppAlert>>>;
  inAppMessages?: Maybe<Array<Maybe<MobileAppInAppMessage>>>;
  minimalVersion?: Maybe<Scalars['String']['output']>;
  orderCancelReasons?: Maybe<Array<Maybe<CancelReason>>>;
  recommendedVersion?: Maybe<Scalars['String']['output']>;
};

export type CustomerPaymentMethod = {
  __typename: 'CustomerPaymentMethod';
  card?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['String']['output']>;
  pluginId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CustomerPaymentMethodRemoveResult = {
  __typename: 'CustomerPaymentMethodRemoveResult';
  id: Scalars['ID']['output'];
  removed: Scalars['Boolean']['output'];
};

export type CustomerProfileField = {
  __typename: 'CustomerProfileField';
  /**  Provide earlier answer on this question by customer */
  answer?: Maybe<Scalars['CustomerProfileAnswer']['output']>;
  /** Default value for types */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Internal name of the field */
  fieldName: Scalars['String']['output'];
  /** List of possible answers for select type */
  fixedAnswers?: Maybe<Array<Maybe<FixedAnswer>>>;
  /** ID of the field */
  id: Scalars['ID']['output'];
  /** Is this field read only */
  isReadOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Is this field visible in profile form */
  isVisibleInProfile?: Maybe<Scalars['Boolean']['output']>;
  /** Is this field visible in registration form */
  isVisibleInRegistration?: Maybe<Scalars['Boolean']['output']>;
  /** Label of the field for showing in UI */
  label: Scalars['String']['output'];
  /** Sort order of the field */
  order: Scalars['Int']['output'];
  /** Payload for custom select types. Check docs for details */
  payload?: Maybe<Scalars['String']['output']>;
  /** regex for validating field value */
  regex?: Maybe<Scalars['String']['output']>;
  /** Error message for regex validation */
  regexErrorMessage?: Maybe<Scalars['String']['output']>;
  /** Is this field required */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** Type of the field (enum): string | date | select | boolean */
  type: Scalars['String']['output'];
};

export type CustomerProfileFieldInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerRestoreResult = {
  __typename: 'CustomerRestoreResult';
  customerInfo?: Maybe<UserInfo>;
  restored?: Maybe<Scalars['Boolean']['output']>;
};

export type DeliveryProvider = {
  __typename: 'DeliveryProvider';
  firstTimePrice?: Maybe<Scalars['Float']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  usingSlot?: Maybe<Scalars['Boolean']['output']>;
};

export type DeliveryProviderConfigInput = {
  configJSON?: InputMaybe<Scalars['String']['input']>;
  deliveryProviderId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeliveryType = {
  __typename: 'DeliveryType';
  firstTimePrice?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  usingSlot?: Maybe<Scalars['Boolean']['output']>;
};

export type DeliveryZone = {
  __typename: 'DeliveryZone';
  delivery_cost?: Maybe<Scalars['Int']['output']>;
  /** Average shipping time in minutes */
  expressDeliveryMaxShippingTime?: Maybe<Scalars['Int']['output']>;
  firstAvailableSlot?: Maybe<Slot>;
  first_delivery_cost?: Maybe<Scalars['Int']['output']>;
  freeExpressDeliveryCostFrom?: Maybe<Scalars['Float']['output']>;
  freeSlotDeliveryCostFrom?: Maybe<Scalars['Float']['output']>;
  geo_delivery_zone?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isExpressDeliveryAvailable?: Maybe<Scalars['Boolean']['output']>;
  minOrderCost?: Maybe<Scalars['Float']['output']>;
  min_price?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  shop?: Maybe<Shop>;
  shop_id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  tzOffset?: Maybe<Scalars['Int']['output']>;
  zoneExpressDeliveryCost?: Maybe<Scalars['Float']['output']>;
  zoneExpressMaxWeight?: Maybe<Scalars['Int']['output']>;
  zoneGeoDeliveryZone?: Maybe<Array<Maybe<GeoPoint>>>;
  zoneSlotMaxWeight?: Maybe<Scalars['Int']['output']>;
  zoneTsExpressDeliveryFinish?: Maybe<Scalars['Int']['output']>;
  zoneTsExpressDeliveryStart?: Maybe<Scalars['Int']['output']>;
};

export type DeliveryZoneGeopointCheckResult = {
  __typename: 'DeliveryZoneGeopointCheckResult';
  isAvailable: Scalars['Boolean']['output'];
  otherZones: Array<Maybe<DeliveryZone>>;
  point: GeoPoint;
  shop_id: Scalars['ID']['output'];
  zone_id: Scalars['ID']['output'];
};

export type ExtendedCartItem = {
  __typename: 'ExtendedCartItem';
  amount?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  info?: Maybe<Product>;
  shop_id?: Maybe<Scalars['ID']['output']>;
};

export type SaleAddedPosition = {
  __typename: 'SaleAddedPosition';
  amount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  info?: Maybe<Product>;
  positionKey?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type Feedback = {
  __typename: 'Feedback';
  /** Usage restricted */
  assemble_rating?: Maybe<Scalars['Int']['output']>;
  brand_id?: Maybe<Scalars['ID']['output']>;
  general_rating?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  images?: Maybe<Array<Maybe<File>>>;
  need_call?: Maybe<Scalars['Boolean']['output']>;
  order_id?: Maybe<Scalars['ID']['output']>;
  /** Usage restricted */
  product_rating?: Maybe<Scalars['Int']['output']>;
  review?: Maybe<Scalars['String']['output']>;
  /** Usage restricted */
  shipping_rating?: Maybe<Scalars['Int']['output']>;
  shop?: Maybe<Shop>;
  shop_id?: Maybe<Scalars['ID']['output']>;
};


export type FeedbackImagesArgs = {
  style?: InputMaybe<Scalars['String']['input']>;
};

export type FeedbackInput = {
  assemble_rating?: InputMaybe<Scalars['Int']['input']>;
  brand_id: Scalars['ID']['input'];
  general_rating?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  images: Array<InputMaybe<Scalars['ID']['input']>>;
  need_call?: InputMaybe<Scalars['Boolean']['input']>;
  order_id?: InputMaybe<Scalars['ID']['input']>;
  product_rating?: InputMaybe<Scalars['Int']['input']>;
  review?: InputMaybe<Scalars['String']['input']>;
  shipping_rating?: InputMaybe<Scalars['Int']['input']>;
  shop_id?: InputMaybe<Scalars['ID']['input']>;
};

export type File = {
  __typename: 'File';
  url?: Maybe<Scalars['String']['output']>;
};

export type FixedAnswer = {
  __typename: 'FixedAnswer';
  /** Name of the fixed answer */
  name?: Maybe<Scalars['String']['output']>;
  /** Value of the fixed answer for providing in `registerCustomer` mutation */
  value?: Maybe<Scalars['String']['output']>;
};

export type GeoDataResponse = {
  __typename: 'GeoDataResponse';
  suggestions?: Maybe<Array<Maybe<GeoDataSuggestion>>>;
};

export type GeoDataSuggestion = {
  __typename: 'GeoDataSuggestion';
  data?: Maybe<GeoDataSuggestionData>;
  unrestricted_value: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GeoDataSuggestionData = {
  __typename: 'GeoDataSuggestionData';
  area?: Maybe<Scalars['String']['output']>;
  area_fias_id?: Maybe<Scalars['String']['output']>;
  area_kladr_id?: Maybe<Scalars['String']['output']>;
  area_type?: Maybe<Scalars['String']['output']>;
  area_type_full?: Maybe<Scalars['String']['output']>;
  area_with_type?: Maybe<Scalars['String']['output']>;
  block?: Maybe<Scalars['String']['output']>;
  block_type?: Maybe<Scalars['String']['output']>;
  block_type_full?: Maybe<Scalars['String']['output']>;
  capital_marker?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  city_district?: Maybe<Scalars['String']['output']>;
  city_district_fias_id?: Maybe<Scalars['String']['output']>;
  city_district_kladr_id?: Maybe<Scalars['String']['output']>;
  city_district_type?: Maybe<Scalars['String']['output']>;
  city_district_type_full?: Maybe<Scalars['String']['output']>;
  city_district_with_type?: Maybe<Scalars['String']['output']>;
  city_fias_id?: Maybe<Scalars['String']['output']>;
  city_kladr_id?: Maybe<Scalars['String']['output']>;
  city_type?: Maybe<Scalars['String']['output']>;
  city_type_full?: Maybe<Scalars['String']['output']>;
  city_with_type?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  country_iso_code?: Maybe<Scalars['String']['output']>;
  federal_district?: Maybe<Scalars['String']['output']>;
  fias_id?: Maybe<Scalars['String']['output']>;
  fias_level?: Maybe<Scalars['String']['output']>;
  flat?: Maybe<Scalars['String']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  flat_type_full?: Maybe<Scalars['String']['output']>;
  geo_lat?: Maybe<Scalars['String']['output']>;
  geo_lon?: Maybe<Scalars['String']['output']>;
  geoname_id?: Maybe<Scalars['String']['output']>;
  house?: Maybe<Scalars['String']['output']>;
  house_fias_id?: Maybe<Scalars['String']['output']>;
  house_kladr_id?: Maybe<Scalars['String']['output']>;
  house_type?: Maybe<Scalars['String']['output']>;
  house_type_full?: Maybe<Scalars['String']['output']>;
  kladr_id?: Maybe<Scalars['String']['output']>;
  okato?: Maybe<Scalars['String']['output']>;
  oktmo?: Maybe<Scalars['String']['output']>;
  postal_box?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  qc_geo?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  region_fias_id?: Maybe<Scalars['String']['output']>;
  region_iso_code?: Maybe<Scalars['String']['output']>;
  region_kladr_id?: Maybe<Scalars['String']['output']>;
  region_type?: Maybe<Scalars['String']['output']>;
  region_type_full?: Maybe<Scalars['String']['output']>;
  region_with_type?: Maybe<Scalars['String']['output']>;
  settlement?: Maybe<Scalars['String']['output']>;
  settlement_fias_id?: Maybe<Scalars['String']['output']>;
  settlement_kladr_id?: Maybe<Scalars['String']['output']>;
  settlement_type?: Maybe<Scalars['String']['output']>;
  settlement_type_full?: Maybe<Scalars['String']['output']>;
  settlement_with_type?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street_fias_id?: Maybe<Scalars['String']['output']>;
  street_kladr_id?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
  street_type_full?: Maybe<Scalars['String']['output']>;
  street_with_type?: Maybe<Scalars['String']['output']>;
  tax_office?: Maybe<Scalars['String']['output']>;
  tax_office_legal?: Maybe<Scalars['String']['output']>;
};

export type GeoPoint = {
  __typename: 'GeoPoint';
  /**
   * DEPRECATED, USE latitude/longitude fields
   * @deprecated Use `latitude` field
   */
  geo_lat?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `longitude` field */
  geo_lon?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type GeoPointInput = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type LocalCouponInfo = {
  __typename: 'LocalCouponInfo';
  canBeActivated?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<File>;
  title?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['Timestamp']['output']>;
  validTo?: Maybe<Scalars['Timestamp']['output']>;
};

export type LoyaltyLevel = {
  __typename: 'LoyaltyLevel';
  name?: Maybe<Scalars['String']['output']>;
  nextLevel?: Maybe<NextLoyaltyLevel>;
  returnAmount?: Maybe<Scalars['Float']['output']>;
  saleAmount?: Maybe<Scalars['Float']['output']>;
};

export type MainPageBlock = {
  __typename: 'MainPageBlock';
  order?: Maybe<Scalars['Int']['output']>;
  /**  JSON string  */
  payload?: Maybe<Scalars['String']['output']>;
  subtype?: Maybe<Scalars['String']['output']>;
  /**  Possible types: 'banner', 'bannerGallery', 'products', 'textMaterials', 'categories', 'menu'  */
  type?: Maybe<Scalars['String']['output']>;
};

export type MainPageConfig = {
  __typename: 'MainPageConfig';
  blocks?: Maybe<Array<Maybe<MainPageBlock>>>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MarketingLabel = {
  __typename: 'MarketingLabel';
  activeFrom?: Maybe<Scalars['Timestamp']['output']>;
  activeUntil?: Maybe<Scalars['Timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<File>;
  optionBackgroundColor?: Maybe<Scalars['String']['output']>;
  optionColor?: Maybe<Scalars['String']['output']>;
  optionLink?: Maybe<Scalars['String']['output']>;
  optionLinkLabel?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type MarketingLabelImageArgs = {
  style?: InputMaybe<Scalars['String']['input']>;
};

export type MarketingStory = {
  __typename: 'MarketingStory';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<File>;
  slides?: Maybe<Array<Maybe<MarketingStorySlide>>>;
};


export type MarketingStoryPreviewArgs = {
  style?: InputMaybe<Scalars['String']['input']>;
};

export type MarketingStoryEdge = {
  __typename: 'MarketingStoryEdge';
  edges?: Maybe<Array<Maybe<MarketingStory>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type MarketingStorySlide = {
  __typename: 'MarketingStorySlide';
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<File>;
  name?: Maybe<Scalars['String']['output']>;
  /** (app-only) If true - always open in browser, prevent deep linking */
  optionOpenInBrowser?: Maybe<Scalars['Boolean']['output']>;
  /** If true - open link in new window */
  optionOpenInNewWindow?: Maybe<Scalars['Boolean']['output']>;
  optionUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


export type MarketingStorySlideImageArgs = {
  style?: InputMaybe<Scalars['String']['input']>;
};

export type Menu = {
  __typename: 'Menu';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  menuItems?: Maybe<Array<Maybe<MenuItem>>>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type MenuItem = {
  __typename: 'MenuItem';
  bold?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  icon_code?: Maybe<Scalars['String']['output']>;
  icon_color?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<File>;
  image_file_id?: Maybe<Scalars['ID']['output']>;
  internal_name?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  link_type?: Maybe<Scalars['String']['output']>;
  link_url?: Maybe<Scalars['String']['output']>;
  menu_id?: Maybe<Scalars['ID']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  text_color?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type MobileAppAlert = {
  __typename: 'MobileAppAlert';
  button?: Maybe<MobileAppAlertButton>;
  restrictAccessToApp?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type MobileAppAlertButton = {
  __typename: 'MobileAppAlertButton';
  action?: Maybe<Scalars['String']['output']>;
  actionData?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type MobileAppInAppMessage = {
  __typename: 'MobileAppInAppMessage';
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename: 'Mutation';
  _?: Maybe<Scalars['String']['output']>;
  /** (Authorized only) Activate coupon */
  activateCoupon?: Maybe<Scalars['Boolean']['output']>;
  /** (Authorized only) Add favorite product */
  addFavoriteProduct?: Maybe<Scalars['Boolean']['output']>;
  /** (Authorized only) apply promocode to cart */
  applyPromocode?: Maybe<ApplyPromocodeResult>;
  arrivedForOrder?: Maybe<UserOrder>;
  /** Authorize by sms code */
  authBySmsCode?: Maybe<UserInfo>;
  /** (Authorized only) Bind loyalty card */
  bindLoyaltyCard?: Maybe<CustomerBonusInfo>;
  /** (Authorized only) Block loyalty card */
  blockLoyaltyCard?: Maybe<CustomerBonusInfo>;
  /** (Authorized only) Reset sms timeout and cancel account deletion process */
  cancelAccountDeletion: Scalars['Boolean']['output'];
  /**
   * (Authorized only) Cancel order
   * Order can be cancelled by order owner
   * Cancellable order statuses are:
   *   INITIAL,
   *   PLACED,
   *   PAID,
   *   WAITING_FOR_PAYMENT,
   *   DELIVERY_IN_PROGRESS,
   *   RECALL_CLIENT,
   *   WAIT_FOR_SLOT_CHANGE
   */
  cancelOrder?: Maybe<Order>;
  /** (Authorized only) Cancel phone change */
  cancelUpdatePhone: Scalars['Boolean']['output'];
  /** @deprecated USE choosePaymentMethodForOrder instead */
  changeOrderPaymentToken?: Maybe<UserOrder>;
  changeOrderSlot?: Maybe<UserOrder>;
  /** Check card number is free */
  checkCardNumberIsFree?: Maybe<Scalars['Boolean']['output']>;
  /** Check if email is used */
  checkIsEmailUsed?: Maybe<Scalars['Boolean']['output']>;
  /** (Authorized only) Mark payment method as default */
  chooseDefaultPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /**
   * (Authorized only)
   * Set order payment method
   * Using useAsDefault: true will also update all other pending orders which are
   * missing payment methods
   */
  choosePaymentMethodForOrder?: Maybe<ChoosePaymentMethodForOrderResult>;
  /** (Authorized only) Choose payment plugin for order and prepare integration info */
  choosePaymentPlugin?: Maybe<PaymentPluginIntegrationInfo>;
  /** (Authorized only) clear shopping cart for shop */
  clearCart?: Maybe<Scalars['Boolean']['output']>;
  confirmReceivingPush?: Maybe<Scalars['Boolean']['output']>;
  /** (Authorized only) create new business profile */
  createBusinessProfile?: Maybe<BusinessProfile>;
  /** (Authorized only) Delete customer address */
  deleteAddress?: Maybe<Scalars['Boolean']['output']>;
  /** (Authorized only) Delete account */
  deleteMyAccount?: Maybe<CustomerDeletionResult>;
  /** (Authorized only) drop product from cart */
  dropCartItem?: Maybe<Scalars['Boolean']['output']>;
  forgetPushNotificationToken?: Maybe<PushNotificationToken>;
  /** (Authorized only) synchronize local cart info and backend */
  initialSyncCarts?: Maybe<Array<Maybe<Cart>>>;
  /** Universal auth/register method */
  loginOrRegister: SmsRequestedResponse;
  /** (Authorized only) Logout from system */
  logout?: Maybe<Scalars['Boolean']['output']>;
  /** (Authorized only) Move owner access to another customer */
  moveOwnerAccessForBusinessProfile?: Maybe<Scalars['Boolean']['output']>;
  /** (Authorized only) Place initialized order */
  placeOrder: PlaceOrderInfo;
  /** (Authorized only) Register customer in loyalty program */
  registerCustomer?: Maybe<Scalars['Boolean']['output']>;
  registerNewPushNotificationToken?: Maybe<PushNotificationToken>;
  /** (Authorized only) Remove favorite product */
  removeFavoriteProduct?: Maybe<Scalars['Boolean']['output']>;
  /** (Authorized only) Remove payment method by id */
  removePaymentMethod: CustomerPaymentMethodRemoveResult;
  /**
   * (Authorized only) Remove customer payment token
   * @deprecated USE removePaymentMethod(id: ID!) instead!
   */
  removePaymentToken: Scalars['Boolean']['output'];
  /** (Authorized only) Remove own access from business profile */
  removeSelfAccessFromBusinessProfile?: Maybe<Scalars['Boolean']['output']>;
  /** (Authorized only) Replace loyalty card */
  replaceLoyaltyCard?: Maybe<CustomerBonusInfo>;
  /** (Authorized only) Request account deletion */
  requestAccountDeletion: SmsRequestedResponse;
  /** Send request to company to start delivery in specific geopoint */
  requestAddressForDelivery?: Maybe<Scalars['Boolean']['output']>;
  /** Request new sms */
  requestNewSms: SmsRequestedResponse;
  /** (Authorized only) Request new sms */
  requestNewSmsForUpdatePhone: SmsRequestedResponse;
  /** (Authorized only) Request sms to restore deleted customer account */
  requestRestoreAccount: SmsRequestedResponse;
  /** (Authorized only) Request change phone number sms */
  requestUpdatePhone: SmsRequestedResponse;
  /** (Authorized only) Restore customer account using sms code */
  restoreDeletedAccount?: Maybe<CustomerRestoreResult>;
  /**
   * (Authorized only) Create payment token for current user
   * @deprecated USE choosePaymentPlugin
   */
  retrieveConfirmationToken: ConfirmationToken;
  /**
   * (Authorized only) Create payment token for current user
   * @deprecated USE choosePaymentPlugin
   */
  retrieveRecurrentToken: ConfirmationToken;
  /** (Authorized only) Save customer address */
  saveAddress?: Maybe<CustomerAddress>;
  /**
   * (Authorized only) save full cart
   * @deprecated USE syncCart instead, this will be deleted soon
   */
  saveCart?: Maybe<Array<Maybe<Cart>>>;
  /** (Authorized only) save feedback for order */
  saveFeedback?: Maybe<Feedback>;
  /** (Authorized only) save product review */
  saveProductReview?: Maybe<ProductReview>;
  /** (Authorized only) save feedback for shop */
  saveShopFeedback?: Maybe<Feedback>;
  /**
   * Legacy handle. It does nothing but returns shop info by its id
   * @deprecated STOP using this, it does nothing but returns shop info by its id
   */
  selectShop?: Maybe<Shop>;
  /** (Authorized only) request access to business profile if it is exists */
  sendBusinessProfileAccessRequest?: Maybe<SendBusinessProfileAccessRequestResponse>;
  /** (Authorized only) Send email verification code */
  sendEmailVerificationCode?: Maybe<Scalars['Boolean']['output']>;
  setReviewInvite?: Maybe<Scalars['Boolean']['output']>;
  /** (Authorized only) save/load carts */
  syncCart?: Maybe<Array<Maybe<Cart>>>;
  /** (Authorized only) remove promocode from cart */
  unapplyPromocode?: Maybe<UnapplyPromocodeResponse>;
  /** (Authorized only) Unblock loyalty card */
  unblockLoyaltyCard?: Maybe<CustomerBonusInfo>;
  /** (Authorized only) Grant access to customer to business profile */
  updateAccessToBusinessProfile?: Maybe<BusinessProfileAccountInfo>;
  /** (Rest mode only) refresh auth token */
  updateAccessTokenFromRefreshToken?: Maybe<UserAuthTokens>;
  /** (Authorized only) update business profile */
  updateBusinessProfile?: Maybe<BusinessProfile>;
  /** (Authorized only) update product amount */
  updateCartProductAmount: Array<Maybe<StockProductResult>>;
  /** (Authorized only) Update customer in loyalty program */
  updateCustomer?: Maybe<Scalars['Boolean']['output']>;
  /**
   * (Authorized only) Update customer profile data
   * @deprecated USE `updateCustomer` mutation instead
   */
  updateCustomerInfo?: Maybe<UserInfo>;
  /** (Authorized only) Verify and update phone number */
  updateCustomerPhone?: Maybe<UserInfo>;
  /**
   * (Authorized only) Add order info
   * @deprecated USE updateOrderInfoWithSlotCheck(order_id: ID!, orderInfo: OrderInfoInput)
   */
  updateOrderInfo?: Maybe<Scalars['Boolean']['output']>;
  /** (Authorized only) Add order info (v1.2) */
  updateOrderInfoWithSlotCheck?: Maybe<UpdateOrderInfoResponse>;
  uploadPaymentOrderFile?: Maybe<Scalars['Boolean']['output']>;
  /** Verify email */
  verifyEmail?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationActivateCouponArgs = {
  coupon: Scalars['String']['input'];
};


export type MutationAddFavoriteProductArgs = {
  product_id: Scalars['ID']['input'];
};


export type MutationApplyPromocodeArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  promocode: Scalars['String']['input'];
  shop_id: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationArrivedForOrderArgs = {
  order_id: Scalars['ID']['input'];
};


export type MutationAuthBySmsCodeArgs = {
  id: Scalars['ID']['input'];
  smsCode: Scalars['String']['input'];
};


export type MutationBindLoyaltyCardArgs = {
  cardNumber: Scalars['String']['input'];
};


export type MutationBlockLoyaltyCardArgs = {
  cardNumber: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelOrderArgs = {
  order_id: Scalars['ID']['input'];
};


export type MutationChangeOrderPaymentTokenArgs = {
  order_id: Scalars['ID']['input'];
  paymentTokenId: Scalars['ID']['input'];
};


export type MutationChangeOrderSlotArgs = {
  order_id: Scalars['ID']['input'];
  slot_id: Scalars['ID']['input'];
};


export type MutationCheckCardNumberIsFreeArgs = {
  cardNumber: Scalars['String']['input'];
};


export type MutationCheckIsEmailUsedArgs = {
  email: Scalars['String']['input'];
};


export type MutationChooseDefaultPaymentMethodArgs = {
  paymentMethodId: Scalars['ID']['input'];
};


export type MutationChoosePaymentMethodForOrderArgs = {
  orderId: Scalars['ID']['input'];
  paymentMethodId: Scalars['ID']['input'];
  useAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationChoosePaymentPluginArgs = {
  orderId?: InputMaybe<Scalars['ID']['input']>;
  paymentPluginId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};


export type MutationClearCartArgs = {
  shop_id: Scalars['ID']['input'];
};


export type MutationConfirmReceivingPushArgs = {
  pushInfo?: InputMaybe<PushNotificationInfo>;
};


export type MutationCreateBusinessProfileArgs = {
  businessProfileInfo: BusinessProfileInput;
};


export type MutationDeleteAddressArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMyAccountArgs = {
  smsCode: Scalars['String']['input'];
};


export type MutationDropCartItemArgs = {
  product_id: Scalars['ID']['input'];
  shop_id: Scalars['ID']['input'];
};


export type MutationForgetPushNotificationTokenArgs = {
  tokenInfo: PushNotificationInfoInput;
};


export type MutationInitialSyncCartsArgs = {
  carts: Array<InputMaybe<CartInfoInput>>;
};


export type MutationLoginOrRegisterArgs = {
  phone: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationMoveOwnerAccessForBusinessProfileArgs = {
  accountId: Scalars['ID']['input'];
  businessProfileId: Scalars['ID']['input'];
};


export type MutationPlaceOrderArgs = {
  order_id: Scalars['ID']['input'];
};


export type MutationRegisterCustomerArgs = {
  answers?: InputMaybe<Array<InputMaybe<CustomerProfileFieldInput>>>;
};


export type MutationRegisterNewPushNotificationTokenArgs = {
  tokenInfo: PushNotificationInfoInput;
};


export type MutationRemoveFavoriteProductArgs = {
  product_id: Scalars['ID']['input'];
};


export type MutationRemovePaymentMethodArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveSelfAccessFromBusinessProfileArgs = {
  businessProfileId: Scalars['ID']['input'];
};


export type MutationReplaceLoyaltyCardArgs = {
  cardNumber: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestAddressForDeliveryArgs = {
  request: AddressForDeliveryRequestInput;
};


export type MutationRequestNewSmsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRequestUpdatePhoneArgs = {
  phone: Scalars['String']['input'];
};


export type MutationRestoreDeletedAccountArgs = {
  smsCode: Scalars['String']['input'];
};


export type MutationRetrieveConfirmationTokenArgs = {
  order_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRetrieveRecurrentTokenArgs = {
  order_id?: InputMaybe<Scalars['ID']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveAddressArgs = {
  addressInfo: CustomerAddressInput;
};


export type MutationSaveCartArgs = {
  cartData: Array<InputMaybe<CartDataInput>>;
};


export type MutationSaveFeedbackArgs = {
  feedbackInfo: FeedbackInput;
};


export type MutationSaveProductReviewArgs = {
  newData?: InputMaybe<ProductReviewInput>;
  upsert?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSaveShopFeedbackArgs = {
  feedbackInfo: FeedbackInput;
};


export type MutationSelectShopArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSendBusinessProfileAccessRequestArgs = {
  tin: Scalars['String']['input'];
};


export type MutationSendEmailVerificationCodeArgs = {
  email: Scalars['String']['input'];
};


export type MutationSetReviewInviteArgs = {
  order_id: Scalars['ID']['input'];
  reviewInvite: Scalars['Boolean']['input'];
};


export type MutationSyncCartArgs = {
  cart: CartInfoInput;
};


export type MutationUnapplyPromocodeArgs = {
  shop_id: Scalars['ID']['input'];
};


export type MutationUnblockLoyaltyCardArgs = {
  cardNumber: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAccessToBusinessProfileArgs = {
  updateAccessInfo?: InputMaybe<UpdateAccessInput>;
};


export type MutationUpdateAccessTokenFromRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationUpdateBusinessProfileArgs = {
  businessProfileInfo: UpdateBusinessProfileInput;
};


export type MutationUpdateCartProductAmountArgs = {
  itemData: CartDataInput;
  shop_id: Scalars['ID']['input'];
};


export type MutationUpdateCustomerArgs = {
  answers?: InputMaybe<Array<InputMaybe<CustomerProfileFieldInput>>>;
};


export type MutationUpdateCustomerInfoArgs = {
  info: CustomerInfoInput;
};


export type MutationUpdateCustomerPhoneArgs = {
  smsCode: Scalars['String']['input'];
};


export type MutationUpdateOrderInfoArgs = {
  orderInfo?: InputMaybe<OrderInfoInput>;
  order_id: Scalars['ID']['input'];
};


export type MutationUpdateOrderInfoWithSlotCheckArgs = {
  orderInfo?: InputMaybe<OrderInfoInput>;
  order_id: Scalars['ID']['input'];
};


export type MutationUploadPaymentOrderFileArgs = {
  file_id: Scalars['ID']['input'];
  order_id: Scalars['ID']['input'];
};


export type MutationVerifyEmailArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type NearestExpiringBonus = {
  __typename: 'NearestExpiringBonus';
  expireAmount?: Maybe<Scalars['Float']['output']>;
  expireAt?: Maybe<Scalars['Timestamp']['output']>;
};

/** Nested filter allow to create infinite nest with and/or operations */
export type NestedFilterInput = {
  /** Array of filters, that should all be true */
  and?: InputMaybe<Array<NestedFilterInput>>;
  /** Fields to filter */
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Operation type: unwrap - no check, eq/not_eq - equal/not equal, starts_with - check string starts with, includes - check string includes substring, ends_with - check string ends with substring, contains - check if exists in array, not_contains - not exists in array, gt - greater than, gte - greater than or equal, lt/lte (less...), between, not_null, is_null, relatedWhere - check relation */
  op?: InputMaybe<Scalars['String']['input']>;
  /** Array of filters, where one of them should be true */
  or?: InputMaybe<Array<NestedFilterInput>>;
  /** Value to filter, multiple values for between, contains filters */
  value?: InputMaybe<Array<InputMaybe<Scalars['NumberOrString']['input']>>>;
};

export type NextLoyaltyLevel = {
  __typename: 'NextLoyaltyLevel';
  name?: Maybe<Scalars['String']['output']>;
  needToNextLevel?: Maybe<Scalars['Float']['output']>;
  nextCalcDate?: Maybe<Scalars['Timestamp']['output']>;
};

export type OfflineLoyaltyPromotionInfo = {
  __typename: 'OfflineLoyaltyPromotionInfo';
  amount?: Maybe<Scalars['Float']['output']>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  positionId?: Maybe<Scalars['ID']['output']>;
  totalDiscount?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  xid?: Maybe<Scalars['String']['output']>;
};

export type OfflinePurchase = {
  __typename: 'OfflinePurchase';
  address?: Maybe<Scalars['String']['output']>;
  assembled_total?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  customerFinalCost?: Maybe<Scalars['Float']['output']>;
  deliveryCost?: Maybe<Scalars['Float']['output']>;
  deliveryType?: Maybe<Scalars['String']['output']>;
  discounts?: Maybe<Array<Maybe<OfflineLoyaltyPromotionInfo>>>;
  id?: Maybe<Scalars['ID']['output']>;
  payment_status?: Maybe<Scalars['Int']['output']>;
  payment_type?: Maybe<Scalars['String']['output']>;
  placedAt?: Maybe<Scalars['Timestamp']['output']>;
  placed_at?: Maybe<Scalars['Timestamp']['output']>;
  positions?: Maybe<Array<Maybe<OfflinePurchasePosition>>>;
  reviewInvite?: Maybe<Scalars['Boolean']['output']>;
  saledCost?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  totalCashback?: Maybe<Scalars['Float']['output']>;
  totalDiscount?: Maybe<Scalars['Float']['output']>;
};

export type OfflinePurchasePosition = {
  __typename: 'OfflinePurchasePosition';
  barCode?: Maybe<Scalars['String']['output']>;
  basePrice?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  discounts?: Maybe<Array<Maybe<OfflineLoyaltyPromotionInfo>>>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Product>;
  total?: Maybe<Scalars['Float']['output']>;
  xid?: Maybe<Scalars['String']['output']>;
};

export type OperationCompletedResponse = {
  __typename: 'OperationCompletedResponse';
  isOk?: Maybe<Scalars['Boolean']['output']>;
};

export type Order = {
  __typename: 'Order';
  courier_phone?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  slot_id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type OrderInfoInput = {
  /** Address in free format, for pickup points this is the address of the pickup point */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Address appartments, for example: 12, 34 */
  address_appartments?: InputMaybe<Scalars['String']['input']>;
  /** Address floor, for example: 1, 2, 3 */
  address_floor?: InputMaybe<Scalars['String']['input']>;
  /** Address intercom, for example: B1234, 0099 */
  address_intercom?: InputMaybe<Scalars['String']['input']>;
  /** Address porch/entrance, for example: 1, 2, A, B. Note! Could be a string with letters and numbers. */
  address_porch?: InputMaybe<Scalars['String']['input']>;
  /** Should picker call if there is no products in stock and could pick another product? */
  assembly_method?: InputMaybe<Scalars['Int']['input']>;
  /** Cash change amount, used for cash on delivery orders */
  cash_change?: InputMaybe<Scalars['String']['input']>;
  /** customer comment for picker, for example: 'take the best products', 'check the expiration date' */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Comment for the courier, for example: 'call me when you arrive', 'leave at the door' */
  customerCourierMessage?: InputMaybe<Scalars['String']['input']>;
  /** Geo point of the address, used for delivery. For pickup points this is the geo point of the pickup point */
  customer_geoposition?: InputMaybe<GeoPointInput>;
  /** Phone number of the customer, required for delivery orders */
  customer_phone?: InputMaybe<Scalars['String']['input']>;
  /** Type of delivery, for example: 'slot', 'pickup', 'express' */
  deliveryType?: InputMaybe<Scalars['String']['input']>;
  /** If courier should leave the order at the door */
  door_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** If courier shouldn't call to intercom or use doorbell */
  no_door_call?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the token for payment, used for payment systems that require tokenization */
  paymentToken?: InputMaybe<Scalars['ID']['input']>;
  /** Payment system type */
  payment_type?: InputMaybe<Scalars['String']['input']>;
  /** Email for receipt */
  receipt_email?: InputMaybe<Scalars['String']['input']>;
  /** Information about the recipient of the order, used for delivery orders */
  recipientInfo?: InputMaybe<OrderRecipientInfoInput>;
  /** ID of the slot for the order, used for delivery scheduling */
  slot_id?: InputMaybe<Scalars['Int']['input']>;
  /** If UI requires several steps to place an order, this field is used to track the current step. */
  step?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the zone of delivery */
  zone_id?: InputMaybe<Scalars['ID']['input']>;
};

export type OrderInfoOutput = {
  __typename: 'OrderInfoOutput';
  address?: Maybe<Scalars['String']['output']>;
  address_appartments?: Maybe<Scalars['String']['output']>;
  address_floor?: Maybe<Scalars['String']['output']>;
  address_intercom?: Maybe<Scalars['String']['output']>;
  address_porch?: Maybe<Scalars['String']['output']>;
  assembly_method?: Maybe<Scalars['Int']['output']>;
  businessProfile?: Maybe<BusinessProfile>;
  business_profile_id?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  customerCourierMessage?: Maybe<Scalars['String']['output']>;
  customer_geoposition?: Maybe<GeoPoint>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  deliveryType?: Maybe<Scalars['String']['output']>;
  delivery_total?: Maybe<Scalars['Float']['output']>;
  door_delivery?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  no_door_call?: Maybe<Scalars['Boolean']['output']>;
  paymentMethod?: Maybe<CustomerPaymentMethod>;
  /** @deprecated USE paymentMethod.id instead */
  paymentToken?: Maybe<Scalars['ID']['output']>;
  payment_id?: Maybe<Scalars['ID']['output']>;
  receipt_email?: Maybe<Scalars['String']['output']>;
  recipientInfo?: Maybe<OrderRecipientInfo>;
  shop_id: Scalars['ID']['output'];
  slot_id?: Maybe<Scalars['ID']['output']>;
  status: Scalars['Int']['output'];
  step: Scalars['Int']['output'];
  total?: Maybe<Scalars['Float']['output']>;
  totalCashback?: Maybe<Scalars['Float']['output']>;
  totalDiscount?: Maybe<Scalars['Float']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type OrderProductInput = {
  amount: Scalars['Int']['input'];
  product_id: Scalars['ID']['input'];
};

export type OrderRecipientInfo = {
  __typename: 'OrderRecipientInfo';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type OrderRecipientInfoInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type OrderSaleInfo = {
  __typename: 'OrderSaleInfo';
  discount?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type OrdersEdge = {
  __typename: 'OrdersEdge';
  edges?: Maybe<Array<Maybe<UserOrder>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PageInfo = {
  __typename: 'PageInfo';
  lastPage?: Maybe<Scalars['Int']['output']>;
  next?: Maybe<Scalars['Int']['output']>;
  /** Current page */
  page?: Maybe<Scalars['Int']['output']>;
  /** Limit per page */
  perPage?: Maybe<Scalars['Int']['output']>;
  /** Total elements in query */
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaymentPluginInfo = {
  __typename: 'PaymentPluginInfo';
  description?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  integrationType?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** Payment integration settings definition */
export type PaymentPluginIntegrationInfo = {
  __typename: 'PaymentPluginIntegrationInfo';
  operationId?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<PaymentPluginIntegrationInfoPayload>;
  pluginId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** This is container for payment plugin integration type with JSON encoded values */
export type PaymentPluginIntegrationInfoPayload = {
  __typename: 'PaymentPluginIntegrationInfoPayload';
  controllable?: Maybe<Scalars['String']['output']>;
  embed?: Maybe<Scalars['String']['output']>;
  redirect?: Maybe<Scalars['String']['output']>;
};

export type PendingBonus = {
  __typename: 'PendingBonus';
  activationDate?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  nextActivationAmount?: Maybe<Scalars['Float']['output']>;
};

export type PlaceOrderInfo = {
  __typename: 'PlaceOrderInfo';
  error_code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  order_id: Scalars['ID']['output'];
  placed: Scalars['Boolean']['output'];
};

export type PossibleOrderBonusAmount = {
  __typename: 'PossibleOrderBonusAmount';
  total?: Maybe<Scalars['Float']['output']>;
};

export type PossibleOrderCashback = {
  __typename: 'PossibleOrderCashback';
  items?: Maybe<Array<Maybe<PossibleOrderPositionCashback>>>;
  maxSaleAmount?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PossibleOrderPositionCashback = {
  __typename: 'PossibleOrderPositionCashback';
  cashback?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['ID']['output']>;
};

export type PriceOffer = {
  __typename: 'PriceOffer';
  count_multiplier?: Maybe<Scalars['Int']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  oldPrice?: Maybe<Scalars['Float']['output']>;
  price: Scalars['Float']['output'];
  quant?: Maybe<Scalars['Int']['output']>;
  quantAmount?: Maybe<Scalars['Float']['output']>;
  salePeriod?: Maybe<SalePeriod>;
  step?: Maybe<Scalars['Int']['output']>;
  uiQuant?: Maybe<Scalars['String']['output']>;
};

export type Product = {
  __typename: 'Product';
  attributes?: Maybe<Array<Maybe<ProductAttribute>>>;
  average_rating?: Maybe<Scalars['Float']['output']>;
  brand?: Maybe<ProductBrand>;
  canBeReviewed?: Maybe<Scalars['Boolean']['output']>;
  categories?: Maybe<Array<Maybe<Category>>>;
  count?: Maybe<Scalars['Int']['output']>;
  count_multiplier?: Maybe<Scalars['Int']['output']>;
  fullPreview?: Maybe<File>;
  galleryImages?: Maybe<Array<Maybe<File>>>;
  h?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Maybe<File>>>;
  ingredients?: Maybe<Scalars['String']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isWeightProduct?: Maybe<Scalars['Boolean']['output']>;
  is_alcohol?: Maybe<Scalars['Boolean']['output']>;
  min_age?: Maybe<Scalars['Int']['output']>;
  l?: Maybe<Scalars['Int']['output']>;
  markable?: Maybe<Scalars['Boolean']['output']>;
  marketingLabels?: Maybe<Array<Maybe<MarketingLabel>>>;
  max_amount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use `min` in `priceOffers` */
  min_count?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nutval?: Maybe<Scalars['String']['output']>;
  oldPrice?: Maybe<Scalars['Float']['output']>;
  pkg?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<File>;
  price?: Maybe<Scalars['Float']['output']>;
  priceOffer?: Maybe<PriceOffer>;
  priceOffers: Array<Maybe<ProductPriceOffer>>;
  price_type: Scalars['String']['output'];
  productProperties?: Maybe<ProductProperties>;
  productReview?: Maybe<Array<Maybe<ProductReview>>>;
  review_count?: Maybe<Scalars['Int']['output']>;
  salePeriod: ProductPriceSalePeriod;
  short_description?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  stock?: Maybe<ProductStock>;
  timeRestrictions?: Maybe<Array<Maybe<ProductTimeRestriction>>>;
  w?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
  weight_multiplier?: Maybe<Scalars['Int']['output']>;
  weight_netto?: Maybe<Scalars['Int']['output']>;
  xid?: Maybe<Scalars['String']['output']>;
};


export type ProductImagesArgs = {
  style?: InputMaybe<Scalars['String']['input']>;
};


export type ProductPreviewArgs = {
  style?: InputMaybe<Scalars['String']['input']>;
};

export type ProductAttribute = {
  __typename: 'ProductAttribute';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ProductBrand = {
  __typename: 'ProductBrand';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ProductEdge = {
  __typename: 'ProductEdge';
  edges?: Maybe<Array<Maybe<Product>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ProductFilter = {
  __typename: 'ProductFilter';
  filterInputFieldName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  op?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<ProductFilterValue>>>;
};

export type ProductFilterValue = {
  __typename: 'ProductFilterValue';
  gid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ProductGroupInfo = {
  __typename: 'ProductGroupInfo';
  brand?: Maybe<Brand>;
  brand_id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  customer_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<Product>>>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Timestamp']['output']>;
};

export type ProductGroupsEdge = {
  __typename: 'ProductGroupsEdge';
  edges?: Maybe<Array<Maybe<ProductGroupInfo>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ProductPriceOffer = {
  __typename: 'ProductPriceOffer';
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  oldPrice?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quant?: Maybe<Scalars['String']['output']>;
  quantAmount?: Maybe<Scalars['Float']['output']>;
  salePeriod: ProductPriceSalePeriod;
  step?: Maybe<Scalars['Int']['output']>;
  uiQuant?: Maybe<Scalars['String']['output']>;
};

export type ProductPriceSalePeriod = {
  __typename: 'ProductPriceSalePeriod';
  finish?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type ProductProperties = {
  __typename: 'ProductProperties';
  calories?: Maybe<Scalars['String']['output']>;
  carbohydrate?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  fats?: Maybe<Scalars['String']['output']>;
  manufacturerName?: Maybe<Scalars['String']['output']>;
  proteins?: Maybe<Scalars['String']['output']>;
  shelfLife?: Maybe<Scalars['String']['output']>;
  storageMinTemperature?: Maybe<Scalars['String']['output']>;
  storageMaxTemperature?: Maybe<Scalars['String']['output']>;
};

export type ProductReview = {
  __typename: 'ProductReview';
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  customer?: Maybe<ProductReviewCustomerInfo>;
  customer_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Maybe<File>>>;
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['ID']['output']>;
  rating: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
};


export type ProductReviewImagesArgs = {
  style?: InputMaybe<Scalars['String']['input']>;
};

export type ProductReviewCustomerInfo = {
  __typename: 'ProductReviewCustomerInfo';
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maskedLastName?: Maybe<Scalars['String']['output']>;
};

export type ProductReviewInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  /**  Use uploader `product-review-image` to upload image and get `ID`  */
  images: Array<InputMaybe<Scalars['ID']['input']>>;
  product_id: Scalars['ID']['input'];
  rating: Scalars['Int']['input'];
};

export type ProductReviewsEdge = {
  __typename: 'ProductReviewsEdge';
  edges?: Maybe<Array<Maybe<ProductReview>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ProductStock = {
  __typename: 'ProductStock';
  amount?: Maybe<Scalars['Int']['output']>;
};

export type ProductTimeRestriction = {
  __typename: 'ProductTimeRestriction';
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type PromocodeInfo = {
  __typename: 'PromocodeInfo';
  active?: Maybe<Scalars['Boolean']['output']>;
  active_from?: Maybe<Scalars['String']['output']>;
  active_until?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PushNotificationInfo = {
  id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PushNotificationInfoInput = {
  deviceToken: Scalars['String']['input'];
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type PushNotificationToken = {
  __typename: 'PushNotificationToken';
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename: 'Query';
  _?: Maybe<Scalars['String']['output']>;
  /** List banners */
  allBanners?: Maybe<BannersEdge>;
  allMarketingStories?: Maybe<MarketingStoryEdge>;
  /** (Authorized only) get customer order */
  allMyOrders?: Maybe<OrdersEdge>;
  /** All product groups */
  allProductGroups?: Maybe<ProductGroupsEdge>;
  allProductReviews?: Maybe<ProductReviewsEdge>;
  /** Customer filterable products query */
  allProducts?: Maybe<ProductEdge>;
  /** List filtered shops edge */
  allShops?: Maybe<ShopEdges>;
  /** Get all text materials */
  allTextMaterials?: Maybe<TextMaterialEdge>;
  availableDeliveryTypes?: Maybe<Array<Maybe<DeliveryType>>>;
  /**
   * (Authorized only) get list of available payment plugins
   * Pass shopId or orderId
   */
  availablePaymentPlugins?: Maybe<Array<Maybe<PaymentPluginInfo>>>;
  /** List available slots for shop with id passed in args */
  availableSlots?: Maybe<Array<Maybe<Slot>>>;
  /** (Authorized only) get customer bonus history */
  bonusHistory?: Maybe<Array<Maybe<BonusOperation>>>;
  /** Details about shop brand, use id or slug */
  brand?: Maybe<Brand>;
  /** List available shop brands */
  brands?: Maybe<Array<Maybe<Brand>>>;
  /** (Authorized only) check if current customer can use promocode */
  canIUsePromocode?: Maybe<Scalars['Int']['output']>;
  /** (Authorized only) get current customer cart info */
  cartInfo?: Maybe<CartInfoProducts>;
  /**
   * Deprecated, use cartInfo instead
   * @deprecated USE cartInfo(cartInfo: CartInfoInput!, business_profile_id: ID) query instead
   */
  cartInfoProducts?: Maybe<CartInfoProducts>;
  /** Grab metainfo for products in cart */
  cartProducts?: Maybe<Array<Maybe<Product>>>;
  /** List categories */
  categories?: Maybe<Array<Maybe<Category>>>;
  /** List categories with leveling */
  categoriesBranch?: Maybe<Array<Maybe<CategoriesBranch>>>;
  /** Single category info */
  category?: Maybe<Category>;
  /** (Authorized only)Check if business profile exists */
  checkBusinessProfileExists?: Maybe<BusinessProfileExistsResponse>;
  /** @deprecated Use `checkIsZoneAvailableForGeoPoint` instead */
  checkIsShopAvailableForGeoPoint?: Maybe<ShopGeopointCheckResult>;
  /** Check if zone is available for current customer geoPoint. */
  checkIsZoneAvailableForGeoPoint?: Maybe<DeliveryZoneGeopointCheckResult>;
  /** Check products is in stock */
  checkProductsInStock?: Maybe<Array<Maybe<StockProductResult>>>;
  /** (Authorized only) Get courier info */
  courierContact?: Maybe<CourierContact>;
  /** (Authorized only) customer connected payment methods */
  customerActivePaymentMethods?: Maybe<Array<Maybe<CustomerPaymentMethod>>>;
  /** (Authorized only)Get customer business profiles */
  customerBusinessProfiles?: Maybe<Array<Maybe<BusinessProfile>>>;
  /** (Authorized only) get customer coupons */
  customerCoupons?: Maybe<Array<Maybe<CouponInfo>>>;
  /** Get customer mobile app config */
  customerMobileAppConfig?: Maybe<CustomerMobileAppConfig>;
  /** (Authorized only) get fields for customer registration */
  customerProfileFields?: Maybe<Array<Maybe<CustomerProfileField>>>;
  /** (Authorized only) get delivery cost */
  deliveryCost?: Maybe<CartDeliveryCostInfo>;
  /** Favorite products */
  favoriteProducts?: Maybe<ProductEdge>;
  /** List featured categories */
  featuredCategories?: Maybe<Array<Maybe<Category>>>;
  /** Get single feedback */
  feedback?: Maybe<Feedback>;
  /**
   * Find brand shops by geopoint
   * @deprecated USE zonesForGeopoint query instead
   */
  findBrandShopByGeoPoint?: Maybe<Shop>;
  /** Get suggestions for address input */
  getAddressSuggestions?: Maybe<GeoDataResponse>;
  /** (Authorized only) Generate dynamic code */
  getBarcode?: Maybe<Barcode>;
  /** (Authorized only) check if customer have payment token */
  havePaymentToken?: Maybe<Scalars['Boolean']['output']>;
  /** (Authorized only) Create new order */
  initializeOrder?: Maybe<OrderInfoOutput>;
  /** (Authorized only, Experimental) create new order with cart */
  initializeOrderWithCart?: Maybe<OrderInfoOutput>;
  /** (Authorized only) Get last delivered order */
  lastDeliveredOrder?: Maybe<UserOrder>;
  /** (Authorized only) load customer carts */
  loadCart?: Maybe<CartInfoOutput>;
  /** (Authorized only) load all customer carts */
  loadCarts?: Maybe<Array<Maybe<CartInfoOutput>>>;
  /**  Get main page config  */
  mainPageConfig?: Maybe<MainPageConfig>;
  /** (Authorized only) customer main profile info */
  me?: Maybe<UserInfo>;
  /** Get menu by code */
  menu?: Maybe<Menu>;
  /** (Authorized only) get customer addresses */
  myAddresses?: Maybe<Array<Maybe<CustomerAddress>>>;
  /** (Authorized only) get customer bonus info */
  myBonus?: Maybe<CustomerBonusInfo>;
  /** (Authorized only) customer connected payment methods */
  myCards?: Maybe<Array<Maybe<CustomerPaymentMethod>>>;
  /**
   * (Authorized only) get customer orders
   * @deprecated USE `allMyOrders` query instead
   */
  myOrders?: Maybe<Array<Maybe<UserOrder>>>;
  /** (Authorized only) get customer product review data */
  myProductReview?: Maybe<ProductReview>;
  /** (Authorized only) get customer shops */
  myShops?: Maybe<Array<Maybe<Shop>>>;
  /** (Authorized only) get customer address */
  mySingleAddress?: Maybe<CustomerAddress>;
  /** (Authorized only) get customer offline history */
  offlinePurchases?: Maybe<Array<Maybe<UserOrder>>>;
  /** (Authorized only) Get order info */
  orderInfo?: Maybe<OrderInfoOutput>;
  /** (Authorized only) get details about single payment plugin */
  paymentPluginDetails?: Maybe<PaymentPluginInfo>;
  /** (Authorized only) check is new phone need to be activated */
  phoneChangeStatus?: Maybe<UserPhoneActivationInfo>;
  /** Check is user authorized */
  pingAuth?: Maybe<UserInfo>;
  /** Popular products */
  popularProducts?: Maybe<ProductEdge>;
  /** (Authorized only) Get possible bonuses to be accepted for order */
  possibleOrderBonusAmount?: Maybe<PossibleOrderBonusAmount>;
  /** (Authorized only) Get possible order cashback from order loyalty system */
  possibleOrderCashback?: Maybe<PossibleOrderCashback>;
  /** Customer previously ordered products */
  previouslyOrderedProducts?: Maybe<ProductEdge>;
  /** Product detail info */
  product?: Maybe<Product>;
  /** Product filters */
  productFilters?: Maybe<Array<Maybe<ProductFilter>>>;
  /** Products edge */
  products?: Maybe<ProductEdge>;
  /** Sale products */
  saleProducts?: Maybe<ProductEdge>;
  searchForAddressSuggestions?: Maybe<GeoDataResponse>;
  /** Customer search product by ean */
  searchProductByEan?: Maybe<Product>;
  /** Search products */
  searchProducts?: Maybe<SearchProductEdge>;
  /** Get shop info details. Use id or slug */
  shop?: Maybe<Shop>;
  /**
   * List available shops
   * @deprecated Use `allShops` query instead
   */
  shops?: Maybe<Array<Maybe<Shop>>>;
  /**
   * Get shops available for geopoint
   * @deprecated Use `zonesForGeoPoint` query instead
   */
  shopsForGeoPoint?: Maybe<Array<Maybe<Shop>>>;
  /** Get shops in geo polygon */
  shopsInGeoPolygon?: Maybe<Array<Maybe<Shop>>>;
  /** Show shops in which product is available */
  shopsWithProductInStock?: Maybe<Array<Maybe<ShopsWithProductInStock>>>;
  /** Find similar products */
  similarProducts?: Maybe<Array<Maybe<Product>>>;
  /** (Authorized only)Get single businessProfile */
  singleBusinessProfile?: Maybe<BusinessProfile>;
  /** Get single delivery zone info */
  singleDeliveryZone?: Maybe<DeliveryZone>;
  /** (Authorized only) get single customer offline purchase */
  singleOfflinePurchase?: Maybe<OfflinePurchase>;
  /** Single product group */
  singleProductGroup?: Maybe<ProductGroupInfo>;
  /** Get text material by id */
  singleTextMaterial?: Maybe<TextMaterial>;
  supportedMarkCodeTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Get articles categories */
  textMaterialCategories?: Maybe<Array<Maybe<TextMaterialCategory>>>;
  /** Get articles themes */
  textMaterialThemes?: Maybe<Array<Maybe<TextMaterialTheme>>>;
  topology?: Maybe<TopologyEdge>;
  /** (Authorized only) Get order info. Set shop_id to get stock info */
  userOrder?: Maybe<UserOrder>;
  /** Get zones available for geopoint */
  zonesForGeoPoint?: Maybe<Array<Maybe<DeliveryZone>>>;
  /** Get zones in geo polygon */
  zonesInGeoPolygon?: Maybe<Array<Maybe<DeliveryZone>>>;
};


export type QueryAllBannersArgs = {
  filter?: InputMaybe<NestedFilterInput>;
  pager?: InputMaybe<CommonPagerInput>;
  sort?: InputMaybe<CommonSortInput>;
};


export type QueryAllMarketingStoriesArgs = {
  filter?: InputMaybe<NestedFilterInput>;
  pager?: InputMaybe<CommonPagerInput>;
  sort?: InputMaybe<CommonSortInput>;
};


export type QueryAllMyOrdersArgs = {
  business_profile_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<NestedFilterInput>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  pager?: InputMaybe<CommonPagerInput>;
  shop_id?: InputMaybe<Scalars['ID']['input']>;
  sort?: InputMaybe<CommonSortInput>;
};


export type QueryAllProductGroupsArgs = {
  filter?: InputMaybe<NestedFilterInput>;
  pager?: InputMaybe<CommonPagerInput>;
  sort?: InputMaybe<CommonSortInput>;
};


export type QueryAllProductReviewsArgs = {
  filter?: InputMaybe<NestedFilterInput>;
  pager?: InputMaybe<CommonPagerInput>;
  sort?: InputMaybe<CommonSortInput>;
};


export type QueryAllProductsArgs = {
  filter?: InputMaybe<NestedFilterInput>;
  pager?: InputMaybe<CommonPagerInput>;
  shop_id: Scalars['ID']['input'];
  sort?: InputMaybe<CommonSortInput>;
};


export type QueryAllShopsArgs = {
  customerPosition?: InputMaybe<GeoPointInput>;
  filter?: InputMaybe<NestedFilterInput>;
  pager?: InputMaybe<CommonPagerInput>;
  sort?: InputMaybe<CommonSortInput>;
};


export type QueryAllTextMaterialsArgs = {
  filter?: InputMaybe<NestedFilterInput>;
  pager?: InputMaybe<CommonPagerInput>;
  sort?: InputMaybe<CommonSortInput>;
};


export type QueryAvailableDeliveryTypesArgs = {
  shop_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAvailablePaymentPluginsArgs = {
  orderId?: InputMaybe<Scalars['ID']['input']>;
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAvailableSlotsArgs = {
  shop_id?: InputMaybe<Scalars['ID']['input']>;
  zone_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBonusHistoryArgs = {
  from?: InputMaybe<Scalars['Timestamp']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Timestamp']['input']>;
};


export type QueryBrandArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCanIUsePromocodeArgs = {
  promo: Scalars['String']['input'];
};


export type QueryCartInfoArgs = {
  business_profile_id?: InputMaybe<Scalars['ID']['input']>;
  cartInfo: CartInfoInput;
};


export type QueryCartInfoProductsArgs = {
  cartInfo: CartInfoInput;
  style?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCartProductsArgs = {
  cart: CartInfoInput;
};


export type QueryCategoriesArgs = {
  _limit?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  parent_id?: InputMaybe<Scalars['ID']['input']>;
  shop_id: Scalars['ID']['input'];
};


export type QueryCategoriesBranchArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['ID']['input']>;
  shop_id: Scalars['ID']['input'];
};


export type QueryCategoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  shop_id: Scalars['ID']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckBusinessProfileExistsArgs = {
  tin?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckIsShopAvailableForGeoPointArgs = {
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  point: GeoPointInput;
  shop_id: Scalars['ID']['input'];
};


export type QueryCheckIsZoneAvailableForGeoPointArgs = {
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  customerType?: InputMaybe<Scalars['String']['input']>;
  point: GeoPointInput;
  shop_id: Scalars['ID']['input'];
  zone_id: Scalars['ID']['input'];
};


export type QueryCheckProductsInStockArgs = {
  productData: StockProductInput;
};


export type QueryCourierContactArgs = {
  order_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCustomerActivePaymentMethodsArgs = {
  paymentPluginId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomerMobileAppConfigArgs = {
  brand_id: Scalars['ID']['input'];
};


export type QueryCustomerProfileFieldsArgs = {
  isRegistration?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDeliveryCostArgs = {
  shop_id: Scalars['ID']['input'];
};


export type QueryFavoriteProductsArgs = {
  filter?: InputMaybe<NestedFilterInput>;
  pager?: InputMaybe<CommonPagerInput>;
  shop_id: Scalars['ID']['input'];
  sort?: InputMaybe<CommonSortInput>;
};


export type QueryFeaturedCategoriesArgs = {
  _limit?: InputMaybe<Scalars['Int']['input']>;
  _limitProducts?: InputMaybe<Scalars['Int']['input']>;
  _page?: InputMaybe<Scalars['Int']['input']>;
  shop_id: Scalars['ID']['input'];
};


export type QueryFeedbackArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  order_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFindBrandShopByGeoPointArgs = {
  id: Scalars['ID']['input'];
  point: GeoPointInput;
};


export type QueryGetAddressSuggestionsArgs = {
  address: Scalars['String']['input'];
};


export type QueryInitializeOrderArgs = {
  business_profile_id?: InputMaybe<Scalars['ID']['input']>;
  shop_id: Scalars['ID']['input'];
};


export type QueryInitializeOrderWithCartArgs = {
  business_profile_id?: InputMaybe<Scalars['ID']['input']>;
  cart?: InputMaybe<CartInfoInput>;
  shop_id: Scalars['ID']['input'];
};


export type QueryLastDeliveredOrderArgs = {
  shop_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLoadCartArgs = {
  shop_id: Scalars['ID']['input'];
};


export type QueryMenuArgs = {
  code: Scalars['String']['input'];
};


export type QueryMyAddressesArgs = {
  showPickupShops?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMyOrdersArgs = {
  business_profile_id?: InputMaybe<Scalars['ID']['input']>;
  controls?: InputMaybe<CommonListControlsInput>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  shop_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMyProductReviewArgs = {
  filter?: InputMaybe<NestedFilterInput>;
  product_id: Scalars['ID']['input'];
};


export type QueryMySingleAddressArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOfflinePurchasesArgs = {
  from?: InputMaybe<Scalars['Timestamp']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Timestamp']['input']>;
};


export type QueryOrderInfoArgs = {
  order_id: Scalars['ID']['input'];
};


export type QueryPaymentPluginDetailsArgs = {
  paymentPluginId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPopularProductsArgs = {
  filter?: InputMaybe<NestedFilterInput>;
  pager?: InputMaybe<CommonPagerInput>;
  shop_id: Scalars['ID']['input'];
};


export type QueryPossibleOrderBonusAmountArgs = {
  order_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPossibleOrderCashbackArgs = {
  order_id: Scalars['ID']['input'];
};


export type QueryPreviouslyOrderedProductsArgs = {
  pager?: InputMaybe<CommonPagerInput>;
  shop_id: Scalars['ID']['input'];
};


export type QueryProductArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  shop_id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  xid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductFiltersArgs = {
  category_id?: InputMaybe<Scalars['ID']['input']>;
  shop_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProductsArgs = {
  category_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<NestedFilterInput>;
  pager?: InputMaybe<CommonPagerInput>;
  shop_id: Scalars['ID']['input'];
  sort?: InputMaybe<CommonSortInput>;
};


export type QuerySaleProductsArgs = {
  pager?: InputMaybe<CommonPagerInput>;
  shop_id: Scalars['ID']['input'];
};


export type QuerySearchForAddressSuggestionsArgs = {
  addressFilter: AddressSuggestionFilterInput;
};


export type QuerySearchProductByEanArgs = {
  ean: Scalars['String']['input'];
  shop_id: Scalars['ID']['input'];
};


export type QuerySearchProductsArgs = {
  category_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<NestedFilterInput>;
  pager?: InputMaybe<CommonPagerInput>;
  searchQuery: SearchQuery;
  shop_id: Scalars['ID']['input'];
};


export type QueryShopArgs = {
  brandSlug?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShopsForGeoPointArgs = {
  point: GeoPointInput;
};


export type QueryShopsInGeoPolygonArgs = {
  corners: Array<InputMaybe<GeoPointInput>>;
  customerType?: InputMaybe<Scalars['String']['input']>;
  useZone?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryShopsWithProductInStockArgs = {
  customerPosition?: InputMaybe<GeoPointInput>;
  product_id: Scalars['ID']['input'];
};


export type QuerySimilarProductsArgs = {
  product_id: Scalars['ID']['input'];
  shop_id: Scalars['ID']['input'];
};


export type QuerySingleBusinessProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySingleDeliveryZoneArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySingleOfflinePurchaseArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySingleProductGroupArgs = {
  id: Scalars['ID']['input'];
  shop_id: Scalars['ID']['input'];
};


export type QuerySingleTextMaterialArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserOrderArgs = {
  order_id: Scalars['ID']['input'];
  shop_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryZonesForGeoPointArgs = {
  customerType?: InputMaybe<Scalars['String']['input']>;
  point: GeoPointInput;
};


export type QueryZonesInGeoPolygonArgs = {
  corners: Array<InputMaybe<GeoPointInput>>;
  customerType?: InputMaybe<Scalars['String']['input']>;
};

export type Region = {
  __typename: 'Region';
  cities?: Maybe<Array<Maybe<City>>>;
  country?: Maybe<Country>;
  country_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SalePeriod = {
  __typename: 'SalePeriod';
  finish: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type SearchCategory = {
  __typename: 'SearchCategory';
  count?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type SearchProductEdge = {
  __typename: 'SearchProductEdge';
  categories?: Maybe<Array<Maybe<SearchCategory>>>;
  edges?: Maybe<Array<Maybe<Product>>>;
  filters?: Maybe<Array<Maybe<ProductFilter>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type SearchQuery = {
  filters?: InputMaybe<SearchQueryFilter>;
  search: Scalars['String']['input'];
};

export type SearchQueryFilter = {
  category_id?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<SearchQueryPriceFilter>;
  saledOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchQueryPriceFilter = {
  gt?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
};

export type SendBusinessProfileAccessRequestResponse = {
  __typename: 'SendBusinessProfileAccessRequestResponse';
  sent?: Maybe<Scalars['Boolean']['output']>;
};

export type Shop = {
  __typename: 'Shop';
  address?: Maybe<Scalars['String']['output']>;
  appStyle?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Brand>;
  brand_id?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<City>;
  city_id?: Maybe<Scalars['ID']['output']>;
  close_time?: Maybe<Scalars['Int']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  deliveryZones?: Maybe<DeliveryZone>;
  delivery_cost?: Maybe<Scalars['Int']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  /** Average shipping time in minutes */
  expressDeliveryMaxShippingTime?: Maybe<Scalars['Int']['output']>;
  firstAvailableSlot?: Maybe<Slot>;
  first_delivery_cost?: Maybe<Scalars['Int']['output']>;
  geo_delivery_zone?: Maybe<Scalars['String']['output']>;
  geo_point?: Maybe<GeoPoint>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Maybe<File>>>;
  isExpressDeliveryAvailable?: Maybe<Scalars['Boolean']['output']>;
  isPickupDeliveryAvailable?: Maybe<Scalars['Boolean']['output']>;
  minOrderCost?: Maybe<Scalars['Float']['output']>;
  min_price?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  open_time?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  shopExpressDeliveryCost?: Maybe<Scalars['Float']['output']>;
  shopGeoPoint?: Maybe<GeoPoint>;
  /** @deprecated USE `isExpressDeliveryAvailable` instead */
  shopHasExpressDelivery?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated USE `isExpressDeliveryAvailable` instead */
  shopHasPickupDelivery?: Maybe<Scalars['Boolean']['output']>;
  shopPickupDeliveryCost?: Maybe<Scalars['Float']['output']>;
  shopTags?: Maybe<Array<Maybe<ShopTag>>>;
  shopTsExpressDeliveryFinish?: Maybe<Scalars['Int']['output']>;
  shopTsExpressDeliveryStart?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  tzOffset?: Maybe<Scalars['Int']['output']>;
};


export type ShopImagesArgs = {
  style?: InputMaybe<Scalars['String']['input']>;
};

export type ShopEdges = {
  __typename: 'ShopEdges';
  edges?: Maybe<Array<Maybe<Shop>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ShopGeopointCheckResult = {
  __typename: 'ShopGeopointCheckResult';
  isAvailable: Scalars['Boolean']['output'];
  otherShops: Array<Maybe<Shop>>;
  point: GeoPoint;
  shop?: Maybe<Shop>;
  shop_id: Scalars['ID']['output'];
};

export type ShopTag = {
  __typename: 'ShopTag';
  icon?: Maybe<File>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};


export type ShopTagIconArgs = {
  style?: InputMaybe<Scalars['String']['input']>;
};

export type ShopsWithProductInStock = {
  __typename: 'ShopsWithProductInStock';
  amount: Scalars['Int']['output'];
  shop?: Maybe<Shop>;
  shop_id: Scalars['ID']['output'];
};

export type Slot = {
  __typename: 'Slot';
  availableUntil?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  period: SlotPeriod;
  shop?: Maybe<Shop>;
  shop_id?: Maybe<Scalars['ID']['output']>;
  slotDate?: Maybe<Scalars['String']['output']>;
  slotTime?: Maybe<Scalars['String']['output']>;
  zone_id?: Maybe<Scalars['ID']['output']>;
};

export type SlotPeriod = {
  __typename: 'SlotPeriod';
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type SmsRequestedResponse = {
  __typename: 'SmsRequestedResponse';
  /** Error description */
  error?: Maybe<Scalars['String']['output']>;
  /** Id of the customer */
  id?: Maybe<Scalars['ID']['output']>;
  /** If SMS has been sent successfully */
  sent?: Maybe<Scalars['Boolean']['output']>;
  /** Seconds before sms code will expire */
  timeout?: Maybe<Scalars['Int']['output']>;
};

export type StockProduct = {
  __typename: 'StockProduct';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type StockProductInput = {
  items: Array<InputMaybe<OrderProductInput>>;
  shop_id: Scalars['ID']['input'];
};

export type StockProductResult = {
  __typename: 'StockProductResult';
  error_code: Scalars['Int']['output'];
  max_amount: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  productInfo?: Maybe<StockProduct>;
  product_id: Scalars['ID']['output'];
};

export type TextMaterial = {
  __typename: 'TextMaterial';
  author?: Maybe<TextMaterialAuthor>;
  averageRating?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<TextMaterialCategory>;
  commentsCount?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lead?: Maybe<Scalars['String']['output']>;
  likesCount?: Maybe<Scalars['Int']['output']>;
  preview?: Maybe<File>;
  preview_source?: Maybe<Scalars['String']['output']>;
  preview_url?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['Timestamp']['output']>;
  slug: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<TextMaterialTag>>>;
  themes?: Maybe<Array<Maybe<TextMaterialTheme>>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TextMaterialType>;
  viewsCount?: Maybe<Scalars['Int']['output']>;
};

export type TextMaterialAuthor = {
  __typename: 'TextMaterialAuthor';
  disclaimer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<File>;
};

export type TextMaterialCategory = {
  __typename: 'TextMaterialCategory';
  children?: Maybe<Array<Maybe<TextMaterialCategory>>>;
  id: Scalars['ID']['output'];
  parent?: Maybe<TextMaterialCategory>;
  slug: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type TextMaterialEdge = {
  __typename: 'TextMaterialEdge';
  edges?: Maybe<Array<Maybe<TextMaterial>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type TextMaterialTag = {
  __typename: 'TextMaterialTag';
  id: Scalars['ID']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TextMaterialTheme = {
  __typename: 'TextMaterialTheme';
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type TextMaterialType = {
  __typename: 'TextMaterialType';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type TokenAccountInfo = {
  __typename: 'TokenAccountInfo';
  expirationAt?: Maybe<Scalars['Timestamp']['output']>;
  expireAmount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  totalBalance?: Maybe<Scalars['Float']['output']>;
};

export type TopologyEdge = {
  __typename: 'TopologyEdge';
  countries?: Maybe<Array<Maybe<Country>>>;
};

export type UnapplyPromocodeResponse = {
  __typename: 'UnapplyPromocodeResponse';
  unapplied?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateAccessInput = {
  accountId: Scalars['ID']['input'];
  businessProfileId: Scalars['ID']['input'];
  manager_status: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type UpdateBusinessProfileInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  attorney_scan_id?: InputMaybe<Scalars['ID']['input']>;
  bankDetails?: InputMaybe<BankDetailsInput>;
  company_registration_scan_id?: InputMaybe<Scalars['ID']['input']>;
  director?: InputMaybe<Scalars['String']['input']>;
  director_confirm_scan_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
  require_invoice?: InputMaybe<Scalars['Boolean']['input']>;
  signAuthorizedPerson?: InputMaybe<Scalars['String']['input']>;
  vat_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrderInfoResponse = {
  __typename: 'UpdateOrderInfoResponse';
  isOk?: Maybe<Scalars['Boolean']['output']>;
  notifySlotChanged?: Maybe<Scalars['Boolean']['output']>;
  orderInfo?: Maybe<Order>;
};

export type UserAuthTokens = {
  __typename: 'UserAuthTokens';
  refreshToken?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type UserInfo = {
  __typename: 'UserInfo';
  authTokens?: Maybe<UserAuthTokens>;
  birthday?: Maybe<Scalars['Timestamp']['output']>;
  businessProfiles?: Maybe<Array<Maybe<BusinessProfile>>>;
  /** Customer main email */
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isEmailVerified?: Maybe<Scalars['Boolean']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  new_email?: Maybe<Scalars['String']['output']>;
  /** If user requested phone change */
  new_phone?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<Array<Maybe<UserOrder>>>;
  phone?: Maybe<Scalars['String']['output']>;
  /** Customer email for electronic receipts. Use it only on checkout */
  receipt_email?: Maybe<Scalars['String']['output']>;
  /** If `true` - only registerCustomer will work as authenticated customer */
  requireRegistration?: Maybe<Scalars['Boolean']['output']>;
  /** Customer requested account deletion. Prevent any activities except restoring account for this customer */
  secondsBeforeDeletion?: Maybe<Scalars['Int']['output']>;
  shop?: Maybe<Shop>;
  shop_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type UserOrder = {
  __typename: 'UserOrder';
  address?: Maybe<Scalars['String']['output']>;
  assembled_total?: Maybe<Scalars['Float']['output']>;
  assemblingFinishedAt?: Maybe<Scalars['Timestamp']['output']>;
  businessProfile?: Maybe<BusinessProfile>;
  business_profile_id?: Maybe<Scalars['ID']['output']>;
  cash_change?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  customerFinalCost?: Maybe<Scalars['Float']['output']>;
  deliveryClaim?: Maybe<UserOrderDeliveryClaim>;
  deliveryCost?: Maybe<Scalars['Float']['output']>;
  deliveryFinishedAt?: Maybe<Scalars['Timestamp']['output']>;
  deliverySlot?: Maybe<Slot>;
  deliveryType?: Maybe<Scalars['String']['output']>;
  deliveryZone?: Maybe<DeliveryZone>;
  feedbacks?: Maybe<Array<Maybe<Feedback>>>;
  id: Scalars['ID']['output'];
  meta?: Maybe<Array<Maybe<UserOrderProductPosition>>>;
  paymentMethod?: Maybe<CustomerPaymentMethod>;
  paymentReceivedAt?: Maybe<Scalars['Timestamp']['output']>;
  /** @deprecated USE paymentMethod.id instead */
  payment_id?: Maybe<Scalars['ID']['output']>;
  payment_status?: Maybe<Scalars['Int']['output']>;
  /** @deprecated USE paymentMethod.id instead */
  payment_token_id?: Maybe<Scalars['ID']['output']>;
  payment_type?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use information in `deliveryClaim` */
  pickup_code?: Maybe<Scalars['String']['output']>;
  placedAt?: Maybe<Scalars['Timestamp']['output']>;
  placed_at?: Maybe<Scalars['Timestamp']['output']>;
  receipts?: Maybe<Array<Maybe<UserOrderReceiptInfo>>>;
  recipientInfo?: Maybe<OrderRecipientInfo>;
  reviewInvite?: Maybe<Scalars['Boolean']['output']>;
  saleInfo?: Maybe<OrderSaleInfo>;
  saledCost?: Maybe<Scalars['Float']['output']>;
  shop?: Maybe<Shop>;
  shop_id?: Maybe<Scalars['ID']['output']>;
  slot_id?: Maybe<Scalars['ID']['output']>;
  status: Scalars['Int']['output'];
  total?: Maybe<Scalars['Float']['output']>;
  totalCashback?: Maybe<Scalars['Float']['output']>;
  totalDiscount?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type UserOrderDeliveryClaim = {
  __typename: 'UserOrderDeliveryClaim';
  customerPickupCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  packagePickupCode?: Maybe<Scalars['String']['output']>;
};

export type UserOrderProductPosition = {
  __typename: 'UserOrderProductPosition';
  assembled_count?: Maybe<Scalars['Int']['output']>;
  assembled_total?: Maybe<Scalars['Float']['output']>;
  assembled_weight?: Maybe<Scalars['Int']['output']>;
  assembly_method?: Maybe<Scalars['Int']['output']>;
  cashback?: Maybe<Scalars['Float']['output']>;
  changedBy?: Maybe<UserOrderProductPosition>;
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isChangeTo?: Maybe<UserOrderProductPosition>;
  name?: Maybe<Scalars['String']['output']>;
  oldPrice?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['ID']['output']>;
  shop_id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  total_weight?: Maybe<Scalars['Int']['output']>;
  unit_multiplier?: Maybe<Scalars['Int']['output']>;
  vat_code?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type UserOrderReceiptInfo = {
  __typename: 'UserOrderReceiptInfo';
  id: Scalars['ID']['output'];
  receiptPreviewUrl?: Maybe<Scalars['String']['output']>;
  receiptQueryString?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type UserPhoneActivationInfo = {
  __typename: 'UserPhoneActivationInfo';
  need_activate_new?: Maybe<Scalars['Boolean']['output']>;
  new_phone?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  sms_status?: Maybe<SmsRequestedResponse>;
};

export type AllBannersQueryVariables = Exact<{
  pager?: InputMaybe<CommonPagerInput>;
  style?: InputMaybe<Scalars['String']['input']>;
  bannerMobileSlideStyle2?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<NestedFilterInput>;
}>;


export type AllBannersQuery = (
  { allBanners?: (
    { edges?: Array<(
      { id?: string | null, name?: string | null, url?: string | null, status?: number | null, has_button?: boolean | null, button_text?: string | null, button_color?: string | null, optionOpenInNewWindow?: boolean | null, optionOpenInBrowser?: boolean | null, bannerSlide?: (
        { url?: string | null }
        & { __typename: 'File' }
      ) | null, bannerMobileSlide?: (
        { url?: string | null }
        & { __typename: 'File' }
      ) | null }
      & { __typename: 'BannerInfo' }
    ) | null> | null }
    & { __typename: 'BannersEdge' }
  ) | null }
  & { __typename: 'Query' }
);

export type AllTextMaterialsQueryVariables = Exact<{
  pager?: InputMaybe<CommonPagerInput>;
  sort?: InputMaybe<CommonSortInput>;
  filter?: InputMaybe<NestedFilterInput>;
  style?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllTextMaterialsQuery = (
  { allTextMaterials?: (
    { edges?: Array<(
      { id: string, slug: string, publishedAt?: any | null, viewsCount?: number | null, likesCount?: number | null, commentsCount?: number | null, averageRating?: number | null, title?: string | null, content?: string | null, lead?: string | null, type?: (
        { id: string, title?: string | null, icon?: string | null }
        & { __typename: 'TextMaterialType' }
      ) | null, category?: (
        { id: string, title?: string | null, slug: string, parent?: (
          { id: string, title?: string | null }
          & { __typename: 'TextMaterialCategory' }
        ) | null, children?: Array<(
          { id: string, title?: string | null }
          & { __typename: 'TextMaterialCategory' }
        ) | null> | null }
        & { __typename: 'TextMaterialCategory' }
      ) | null, themes?: Array<(
        { id: string, title?: string | null, slug: string }
        & { __typename: 'TextMaterialTheme' }
      ) | null> | null, tags?: Array<(
        { id: string, title?: string | null, slug?: string | null }
        & { __typename: 'TextMaterialTag' }
      ) | null> | null, author?: (
        { id: string, name?: string | null, photo?: (
          { url?: string | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'TextMaterialAuthor' }
      ) | null, preview?: (
        { url?: string | null }
        & { __typename: 'File' }
      ) | null }
      & { __typename: 'TextMaterial' }
    ) | null> | null, pageInfo?: (
      { page?: number | null, perPage?: number | null, lastPage?: number | null, next?: number | null, total?: number | null }
      & { __typename: 'PageInfo' }
    ) | null }
    & { __typename: 'TextMaterialEdge' }
  ) | null }
  & { __typename: 'Query' }
);

export type SingleTextMaterialQueryVariables = Exact<{
  singleTextMaterialId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type SingleTextMaterialQuery = (
  { singleTextMaterial?: (
    { id: string, preview_source?: string | null, preview_url?: string | null, slug: string, publishedAt?: any | null, viewsCount?: number | null, likesCount?: number | null, commentsCount?: number | null, averageRating?: number | null, title?: string | null, content?: string | null, lead?: string | null, type?: (
      { id: string, title?: string | null, icon?: string | null }
      & { __typename: 'TextMaterialType' }
    ) | null, category?: (
      { id: string, title?: string | null, slug: string }
      & { __typename: 'TextMaterialCategory' }
    ) | null, themes?: Array<(
      { id: string, title?: string | null, slug: string }
      & { __typename: 'TextMaterialTheme' }
    ) | null> | null, tags?: Array<(
      { id: string, title?: string | null, slug?: string | null }
      & { __typename: 'TextMaterialTag' }
    ) | null> | null, author?: (
      { id: string, name?: string | null, disclaimer?: string | null, photo?: (
        { url?: string | null }
        & { __typename: 'File' }
      ) | null }
      & { __typename: 'TextMaterialAuthor' }
    ) | null, preview?: (
      { url?: string | null }
      & { __typename: 'File' }
    ) | null }
    & { __typename: 'TextMaterial' }
  ) | null }
  & { __typename: 'Query' }
);

export type TextMaterialCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type TextMaterialCategoriesQuery = (
  { textMaterialCategories?: Array<(
    { id: string, title?: string | null, slug: string, parent?: (
      { id: string, title?: string | null, slug: string }
      & { __typename: 'TextMaterialCategory' }
    ) | null, children?: Array<(
      { id: string, title?: string | null, slug: string }
      & { __typename: 'TextMaterialCategory' }
    ) | null> | null }
    & { __typename: 'TextMaterialCategory' }
  ) | null> | null }
  & { __typename: 'Query' }
);

export type CategoriesBranchQueryVariables = Exact<{
  shopId: Scalars['ID']['input'];
  style?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CategoriesBranchQuery = (
  { categoriesBranch?: Array<(
    { name?: string | null, id?: string | null, slug?: string | null, childrens?: Array<(
      { id?: string | null, name?: string | null, slug?: string | null, childrens?: Array<(
        { childrens?: Array<(
          { id?: string | null, name?: string | null }
          & { __typename: 'CategoriesBranch' }
        ) | null> | null }
        & { __typename: 'CategoriesBranch' }
      ) | null> | null }
      & { __typename: 'CategoriesBranch' }
    ) | null> | null, icon?: (
      { url?: string | null }
      & { __typename: 'File' }
    ) | null, miniIcon?: (
      { url?: string | null }
      & { __typename: 'File' }
    ) | null }
    & { __typename: 'CategoriesBranch' }
  ) | null> | null }
  & { __typename: 'Query' }
);

export type CategoriesPreviewProductsQueryVariables = Exact<{
  shopId: Scalars['ID']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type CategoriesPreviewProductsQuery = (
  { categories?: Array<(
    { slug?: string | null, parent_id?: number | null, name?: string | null, is_alcohol?: boolean | null, id?: string | null, preview_size?: string | null, icon?: (
      { url?: string | null }
      & { __typename: 'File' }
    ) | null, miniIcon?: (
      { url?: string | null }
      & { __typename: 'File' }
    ) | null, products?: Array<(
      { id: string, name: string, price?: number | null, oldPrice?: number | null, price_type: string, isWeightProduct?: boolean | null, count_multiplier?: number | null, isFavorite?: boolean | null, slug?: string | null, review_count?: number | null, is_alcohol?: boolean | null, min_age?: number | null, stock?: (
        { amount?: number | null }
        & { __typename: 'ProductStock' }
      ) | null, preview?: (
        { url?: string | null }
        & { __typename: 'File' }
      ) | null, marketingLabels?: Array<(
        { id?: string | null, title?: string | null, description?: string | null, activeFrom?: any | null, activeUntil?: any | null, optionColor?: string | null, optionBackgroundColor?: string | null, optionLink?: string | null, optionLinkLabel?: string | null, image?: (
          { url?: string | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'MarketingLabel' }
      ) | null> | null, priceOffers: Array<(
        { id: string, price?: number | null, oldPrice?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: string | null, uiQuant?: string | null, quantAmount?: number | null, isDefault?: boolean | null, group?: string | null, salePeriod: (
          { start?: string | null, finish?: string | null }
          & { __typename: 'ProductPriceSalePeriod' }
        ) }
        & { __typename: 'ProductPriceOffer' }
      ) | null>, priceOffer?: (
        { id: string, price: number, oldPrice?: number | null, count_multiplier?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: number | null, quantAmount?: number | null, isDefault: boolean, group?: string | null, salePeriod?: (
          { start: string, finish: string }
          & { __typename: 'SalePeriod' }
        ) | null }
        & { __typename: 'PriceOffer' }
      ) | null }
      & { __typename: 'Product' }
    ) | null> | null }
    & { __typename: 'Category' }
  ) | null> | null }
  & { __typename: 'Query' }
);

export type CategoriesPreviewQueryVariables = Exact<{
  shopId: Scalars['ID']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type CategoriesPreviewQuery = (
  { categories?: Array<(
    { slug?: string | null, parent_id?: number | null, name?: string | null, is_alcohol?: boolean | null, id?: string | null, preview_size?: string | null, icon?: (
      { url?: string | null }
      & { __typename: 'File' }
    ) | null, miniIcon?: (
      { url?: string | null }
      & { __typename: 'File' }
    ) | null }
    & { __typename: 'Category' }
  ) | null> | null }
  & { __typename: 'Query' }
);

export type CategoryQueryVariables = Exact<{
  shopId: Scalars['ID']['input'];
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type CategoryQuery = (
  { category?: (
    { id?: string | null, name?: string | null, slug?: string | null, parent?: (
      { slug?: string | null, name?: string | null, id?: string | null }
      & { __typename: 'Category' }
    ) | null }
    & { __typename: 'Category' }
  ) | null }
  & { __typename: 'Query' }
);

export type CustomerProfileFieldsQueryVariables = Exact<{
  isRegistration?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CustomerProfileFieldsQuery = (
  { customerProfileFields?: Array<(
    { id: string, order: number, label: string, fieldName: string, type: string, required?: boolean | null, isReadOnly?: boolean | null, isVisibleInRegistration?: boolean | null, answer?: any | null, defaultValue?: string | null, fixedAnswers?: Array<(
      { name?: string | null, value?: string | null }
      & { __typename: 'FixedAnswer' }
    ) | null> | null }
    & { __typename: 'CustomerProfileField' }
  ) | null> | null }
  & { __typename: 'Query' }
);

export type RegisterCustomerMutationVariables = Exact<{
  answers?: InputMaybe<Array<InputMaybe<CustomerProfileFieldInput>> | InputMaybe<CustomerProfileFieldInput>>;
}>;


export type RegisterCustomerMutation = (
  { registerCustomer?: boolean | null }
  & { __typename: 'Mutation' }
);

export type PossibleOrderCashbackQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type PossibleOrderCashbackQuery = (
  { possibleOrderCashback?: (
    { total?: number | null, maxSaleAmount?: number | null, items?: Array<(
      { cashback?: number | null, product_id?: string | null }
      & { __typename: 'PossibleOrderPositionCashback' }
    ) | null> | null }
    & { __typename: 'PossibleOrderCashback' }
  ) | null }
  & { __typename: 'Query' }
);

export type SingleOfflinePurchaseQueryVariables = Exact<{
  singleOfflinePurchaseId: Scalars['ID']['input'];
}>;


export type SingleOfflinePurchaseQuery = (
  { singleOfflinePurchase?: (
    { id?: string | null, total?: number | null, address?: string | null, comment?: string | null, assembled_total?: number | null, totalCashback?: number | null, totalDiscount?: number | null, positions?: Array<(
      { id?: string | null, xid?: string | null, barCode?: string | null, name?: string | null, count?: number | null, price?: number | null, basePrice?: number | null, discount?: number | null, total?: number | null, discounts?: Array<(
        { code?: string | null, name?: string | null, type?: string | null, positionId?: string | null, xid?: string | null, totalDiscount?: number | null, amount?: number | null, cardNumber?: string | null }
        & { __typename: 'OfflineLoyaltyPromotionInfo' }
      ) | null> | null, product?: (
        { id: string, xid?: string | null, name: string, count?: number | null, min_count?: number | null, price?: number | null, oldPrice?: number | null, price_type: string, count_multiplier?: number | null, max_amount?: number | null, weight_multiplier?: number | null, slug?: string | null, short_description?: string | null, stock?: (
          { amount?: number | null }
          & { __typename: 'ProductStock' }
        ) | null, preview?: (
          { url?: string | null }
          & { __typename: 'File' }
        ) | null, images?: Array<(
          { url?: string | null }
          & { __typename: 'File' }
        ) | null> | null }
        & { __typename: 'Product' }
      ) | null }
      & { __typename: 'OfflinePurchasePosition' }
    ) | null> | null, discounts?: Array<(
      { code?: string | null, name?: string | null, type?: string | null, positionId?: string | null, xid?: string | null, totalDiscount?: number | null, amount?: number | null, cardNumber?: string | null }
      & { __typename: 'OfflineLoyaltyPromotionInfo' }
    ) | null> | null }
    & { __typename: 'OfflinePurchase' }
  ) | null }
  & { __typename: 'Query' }
);

export type ProductQueryVariables = Exact<{
  style?: InputMaybe<Scalars['String']['input']>;
  galleryImagesStyle?: InputMaybe<Scalars['String']['input']>;
  previewStyle2?: InputMaybe<Scalars['String']['input']>;
  fullPreviewStyle?: InputMaybe<Scalars['String']['input']>;
  marketingLabelsStyle?: InputMaybe<Scalars['String']['input']>;
  reviewImagesStyle?: InputMaybe<Scalars['String']['input']>;
  shopId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductQuery = (
  { product?: (
    { id: string, name: string, price?: number | null, oldPrice?: number | null, price_type: string, count_multiplier?: number | null, slug?: string | null, pkg?: string | null, short_description?: string | null, ingredients?: string | null, isWeightProduct?: boolean | null, average_rating?: number | null, review_count?: number | null, canBeReviewed?: boolean | null, isFavorite?: boolean | null, is_alcohol?: boolean | null, min_age?: number | null, categories?: Array<(
      { id?: string | null, slug?: string | null, parent_id?: number | null, name?: string | null }
      & { __typename: 'Category' }
    ) | null> | null, brand?: (
      { name: string, id: string }
      & { __typename: 'ProductBrand' }
    ) | null, stock?: (
      { amount?: number | null }
      & { __typename: 'ProductStock' }
    ) | null, images?: Array<(
      { url?: string | null }
      & { __typename: 'File' }
    ) | null> | null, galleryImages?: Array<(
      { url?: string | null }
      & { __typename: 'File' }
    ) | null> | null, productProperties?: (
      { fats?: string | null, proteins?: string | null, calories?: string | null, carbohydrate?: string | null, shelfLife?: string | null, manufacturerName?: string | null, country?: string | null }
      & { __typename: 'ProductProperties' }
    ) | null, marketingLabels?: Array<(
      { id?: string | null, title?: string | null, description?: string | null, activeFrom?: any | null, activeUntil?: any | null, optionColor?: string | null, optionBackgroundColor?: string | null, optionLink?: string | null, optionLinkLabel?: string | null, image?: (
        { url?: string | null }
        & { __typename: 'File' }
      ) | null }
      & { __typename: 'MarketingLabel' }
    ) | null> | null, preview?: (
      { url?: string | null }
      & { __typename: 'File' }
    ) | null, fullPreview?: (
      { url?: string | null }
      & { __typename: 'File' }
    ) | null, productReview?: Array<(
      { id: string, created_at?: any | null, status: number, customer_id?: string | null, product_id?: string | null, rating: number, comment?: string | null, customer?: (
        { id: string, first_name?: string | null, maskedLastName?: string | null }
        & { __typename: 'ProductReviewCustomerInfo' }
      ) | null, images?: Array<(
        { url?: string | null }
        & { __typename: 'File' }
      ) | null> | null }
      & { __typename: 'ProductReview' }
    ) | null> | null, attributes?: Array<(
      { name?: string | null, value?: string | null }
      & { __typename: 'ProductAttribute' }
    ) | null> | null, priceOffers: Array<(
      { id: string, price?: number | null, oldPrice?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: string | null, uiQuant?: string | null, quantAmount?: number | null, isDefault?: boolean | null, group?: string | null, salePeriod: (
        { start?: string | null, finish?: string | null }
        & { __typename: 'ProductPriceSalePeriod' }
      ) }
      & { __typename: 'ProductPriceOffer' }
    ) | null>, priceOffer?: (
      { id: string, price: number, oldPrice?: number | null, count_multiplier?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: number | null, quantAmount?: number | null, isDefault: boolean, group?: string | null, salePeriod?: (
        { start: string, finish: string }
        & { __typename: 'SalePeriod' }
      ) | null }
      & { __typename: 'PriceOffer' }
    ) | null }
    & { __typename: 'Product' }
  ) | null }
  & { __typename: 'Query' }
);

export type ProductFiltersQueryVariables = Exact<{
  shopId?: InputMaybe<Scalars['ID']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ProductFiltersQuery = (
  { productFilters?: Array<(
    { id?: string | null, label?: string | null, type?: string | null, filterInputFieldName?: string | null, op?: string | null, values?: Array<(
      { value?: string | null, gid?: string | null, name?: string | null }
      & { __typename: 'ProductFilterValue' }
    ) | null> | null }
    & { __typename: 'ProductFilter' }
  ) | null> | null }
  & { __typename: 'Query' }
);

export type PopularProductsQueryVariables = Exact<{
  shopId: Scalars['ID']['input'];
  pager?: InputMaybe<CommonPagerInput>;
  style?: InputMaybe<Scalars['String']['input']>;
}>;


export type PopularProductsQuery = (
  { popularProducts?: (
    { edges?: Array<(
      { id: string, name: string, price?: number | null, oldPrice?: number | null, price_type: string, isWeightProduct?: boolean | null, count_multiplier?: number | null, isFavorite?: boolean | null, slug?: string | null, review_count?: number | null, is_alcohol?: boolean | null, min_age?: number | null, stock?: (
        { amount?: number | null }
        & { __typename: 'ProductStock' }
      ) | null, preview?: (
        { url?: string | null }
        & { __typename: 'File' }
      ) | null, marketingLabels?: Array<(
        { id?: string | null, title?: string | null, description?: string | null, activeFrom?: any | null, activeUntil?: any | null, optionColor?: string | null, optionBackgroundColor?: string | null, optionLink?: string | null, optionLinkLabel?: string | null, image?: (
          { url?: string | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'MarketingLabel' }
      ) | null> | null, priceOffers: Array<(
        { id: string, price?: number | null, oldPrice?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: string | null, uiQuant?: string | null, quantAmount?: number | null, isDefault?: boolean | null, group?: string | null, salePeriod: (
          { start?: string | null, finish?: string | null }
          & { __typename: 'ProductPriceSalePeriod' }
        ) }
        & { __typename: 'ProductPriceOffer' }
      ) | null>, priceOffer?: (
        { id: string, price: number, oldPrice?: number | null, count_multiplier?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: number | null, quantAmount?: number | null, isDefault: boolean, group?: string | null, salePeriod?: (
          { start: string, finish: string }
          & { __typename: 'SalePeriod' }
        ) | null }
        & { __typename: 'PriceOffer' }
      ) | null }
      & { __typename: 'Product' }
    ) | null> | null, pageInfo?: (
      { page?: number | null, perPage?: number | null, lastPage?: number | null, next?: number | null, total?: number | null }
      & { __typename: 'PageInfo' }
    ) | null }
    & { __typename: 'ProductEdge' }
  ) | null }
  & { __typename: 'Query' }
);

export type PreviouslyOrderedProductsQueryVariables = Exact<{
  shopId: Scalars['ID']['input'];
  style?: InputMaybe<Scalars['String']['input']>;
  pager?: InputMaybe<CommonPagerInput>;
}>;


export type PreviouslyOrderedProductsQuery = (
  { previouslyOrderedProducts?: (
    { edges?: Array<(
      { id: string, name: string, price?: number | null, oldPrice?: number | null, price_type: string, isWeightProduct?: boolean | null, count_multiplier?: number | null, isFavorite?: boolean | null, slug?: string | null, review_count?: number | null, is_alcohol?: boolean | null, min_age?: number, stock?: (
        { amount?: number | null }
        & { __typename: 'ProductStock' }
      ) | null, preview?: (
        { url?: string | null }
        & { __typename: 'File' }
      ) | null, marketingLabels?: Array<(
        { id?: string | null, title?: string | null, description?: string | null, activeFrom?: any | null, activeUntil?: any | null, optionColor?: string | null, optionBackgroundColor?: string | null, optionLink?: string | null, optionLinkLabel?: string | null, image?: (
          { url?: string | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'MarketingLabel' }
      ) | null> | null, priceOffers: Array<(
        { id: string, price?: number | null, oldPrice?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: string | null, uiQuant?: string | null, quantAmount?: number | null, isDefault?: boolean | null, group?: string | null, salePeriod: (
          { start?: string | null, finish?: string | null }
          & { __typename: 'ProductPriceSalePeriod' }
        ) }
        & { __typename: 'ProductPriceOffer' }
      ) | null>, priceOffer?: (
        { id: string, price: number, oldPrice?: number | null, count_multiplier?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: number | null, quantAmount?: number | null, isDefault: boolean, group?: string | null, salePeriod?: (
          { start: string, finish: string }
          & { __typename: 'SalePeriod' }
        ) | null }
        & { __typename: 'PriceOffer' }
      ) | null }
      & { __typename: 'Product' }
    ) | null> | null, pageInfo?: (
      { page?: number | null, perPage?: number | null, lastPage?: number | null, next?: number | null, total?: number | null }
      & { __typename: 'PageInfo' }
    ) | null }
    & { __typename: 'ProductEdge' }
  ) | null }
  & { __typename: 'Query' }
);

export type AllProductsPreviewCardQueryVariables = Exact<{
  shopId: Scalars['ID']['input'];
  pager?: InputMaybe<CommonPagerInput>;
  sort?: InputMaybe<CommonSortInput>;
  filter?: InputMaybe<NestedFilterInput>;
}>;


export type AllProductsPreviewCardQuery = (
  { allProducts?: (
    { edges?: Array<(
      { id: string, name: string, price?: number | null, oldPrice?: number | null, price_type: string, isWeightProduct?: boolean | null, count_multiplier?: number | null, isFavorite?: boolean | null, slug?: string | null, review_count?: number | null, is_alcohol?: boolean | null, min_age?: number | null, stock?: (
        { amount?: number | null }
        & { __typename: 'ProductStock' }
      ) | null, preview?: (
        { url?: string | null }
        & { __typename: 'File' }
      ) | null, marketingLabels?: Array<(
        { id?: string | null, title?: string | null, description?: string | null, activeFrom?: any | null, activeUntil?: any | null, optionColor?: string | null, optionBackgroundColor?: string | null, optionLink?: string | null, optionLinkLabel?: string | null, image?: (
          { url?: string | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'MarketingLabel' }
      ) | null> | null, priceOffers: Array<(
        { id: string, price?: number | null, oldPrice?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: string | null, uiQuant?: string | null, quantAmount?: number | null, isDefault?: boolean | null, group?: string | null, salePeriod: (
          { start?: string | null, finish?: string | null }
          & { __typename: 'ProductPriceSalePeriod' }
        ) }
        & { __typename: 'ProductPriceOffer' }
      ) | null>, priceOffer?: (
        { id: string, price: number, oldPrice?: number | null, count_multiplier?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: number | null, quantAmount?: number | null, isDefault: boolean, group?: string | null, salePeriod?: (
          { start: string, finish: string }
          & { __typename: 'SalePeriod' }
        ) | null }
        & { __typename: 'PriceOffer' }
      ) | null }
      & { __typename: 'Product' }
    ) | null> | null, pageInfo?: (
      { page?: number | null, perPage?: number | null, lastPage?: number | null, next?: number | null, total?: number | null }
      & { __typename: 'PageInfo' }
    ) | null }
    & { __typename: 'ProductEdge' }
  ) | null }
  & { __typename: 'Query' }
);

export type ProductsPreviewCardQueryVariables = Exact<{
  shopId: Scalars['ID']['input'];
  style?: InputMaybe<Scalars['String']['input']>;
  pager?: InputMaybe<CommonPagerInput>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  sort?: InputMaybe<CommonSortInput>;
  filter?: InputMaybe<NestedFilterInput>;
}>;


export type ProductsPreviewCardQuery = (
  { products?: (
    { edges?: Array<(
      { id: string, name: string, price?: number | null, oldPrice?: number | null, price_type: string, isWeightProduct?: boolean | null, count_multiplier?: number | null, isFavorite?: boolean | null, slug?: string | null, review_count?: number | null, is_alcohol?: boolean | null, min_age?: number | null, stock?: (
        { amount?: number | null }
        & { __typename: 'ProductStock' }
      ) | null, preview?: (
        { url?: string | null }
        & { __typename: 'File' }
      ) | null, marketingLabels?: Array<(
        { id?: string | null, title?: string | null, description?: string | null, activeFrom?: any | null, activeUntil?: any | null, optionColor?: string | null, optionBackgroundColor?: string | null, optionLink?: string | null, optionLinkLabel?: string | null, image?: (
          { url?: string | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'MarketingLabel' }
      ) | null> | null, priceOffers: Array<(
        { id: string, price?: number | null, oldPrice?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: string | null, uiQuant?: string | null, quantAmount?: number | null, isDefault?: boolean | null, group?: string | null, salePeriod: (
          { start?: string | null, finish?: string | null }
          & { __typename: 'ProductPriceSalePeriod' }
        ) }
        & { __typename: 'ProductPriceOffer' }
      ) | null>, priceOffer?: (
        { id: string, price: number, oldPrice?: number | null, count_multiplier?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: number | null, quantAmount?: number | null, isDefault: boolean, group?: string | null, salePeriod?: (
          { start: string, finish: string }
          & { __typename: 'SalePeriod' }
        ) | null }
        & { __typename: 'PriceOffer' }
      ) | null }
      & { __typename: 'Product' }
    ) | null> | null, pageInfo?: (
      { page?: number | null, perPage?: number | null, lastPage?: number | null, next?: number | null, total?: number | null }
      & { __typename: 'PageInfo' }
    ) | null }
    & { __typename: 'ProductEdge' }
  ) | null }
  & { __typename: 'Query' }
);

export type SaleProductsQueryVariables = Exact<{
  shopId: Scalars['ID']['input'];
  style?: InputMaybe<Scalars['String']['input']>;
  pager?: InputMaybe<CommonPagerInput>;
}>;


export type SaleProductsQuery = (
  { saleProducts?: (
    { edges?: Array<(
      { id: string, name: string, price?: number | null, oldPrice?: number | null, price_type: string, isWeightProduct?: boolean | null, count_multiplier?: number | null, isFavorite?: boolean | null, slug?: string | null, review_count?: number | null, is_alcohol?: boolean | null, min_age?: number | null, stock?: (
        { amount?: number | null }
        & { __typename: 'ProductStock' }
      ) | null, preview?: (
        { url?: string | null }
        & { __typename: 'File' }
      ) | null, marketingLabels?: Array<(
        { id?: string | null, title?: string | null, description?: string | null, activeFrom?: any | null, activeUntil?: any | null, optionColor?: string | null, optionBackgroundColor?: string | null, optionLink?: string | null, optionLinkLabel?: string | null, image?: (
          { url?: string | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'MarketingLabel' }
      ) | null> | null, priceOffers: Array<(
        { id: string, price?: number | null, oldPrice?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: string | null, uiQuant?: string | null, quantAmount?: number | null, isDefault?: boolean | null, group?: string | null, salePeriod: (
          { start?: string | null, finish?: string | null }
          & { __typename: 'ProductPriceSalePeriod' }
        ) }
        & { __typename: 'ProductPriceOffer' }
      ) | null>, priceOffer?: (
        { id: string, price: number, oldPrice?: number | null, count_multiplier?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: number | null, quantAmount?: number | null, isDefault: boolean, group?: string | null, salePeriod?: (
          { start: string, finish: string }
          & { __typename: 'SalePeriod' }
        ) | null }
        & { __typename: 'PriceOffer' }
      ) | null }
      & { __typename: 'Product' }
    ) | null> | null, pageInfo?: (
      { page?: number | null, perPage?: number | null, lastPage?: number | null, next?: number | null, total?: number | null }
      & { __typename: 'PageInfo' }
    ) | null }
    & { __typename: 'ProductEdge' }
  ) | null }
  & { __typename: 'Query' }
);

export type SimilarProductsQueryVariables = Exact<{
  shopId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  style?: InputMaybe<Scalars['String']['input']>;
}>;


export type SimilarProductsQuery = (
  { similarProducts?: Array<(
    { id: string, name: string, price?: number | null, oldPrice?: number | null, price_type: string, isWeightProduct?: boolean | null, count_multiplier?: number | null, isFavorite?: boolean | null, slug?: string | null, review_count?: number | null, is_alcohol?: boolean | null, min_age?: number | null, stock?: (
      { amount?: number | null }
      & { __typename: 'ProductStock' }
    ) | null, preview?: (
      { url?: string | null }
      & { __typename: 'File' }
    ) | null, marketingLabels?: Array<(
      { id?: string | null, title?: string | null, description?: string | null, activeFrom?: any | null, activeUntil?: any | null, optionColor?: string | null, optionBackgroundColor?: string | null, optionLink?: string | null, optionLinkLabel?: string | null, image?: (
        { url?: string | null }
        & { __typename: 'File' }
      ) | null }
      & { __typename: 'MarketingLabel' }
    ) | null> | null, priceOffers: Array<(
      { id: string, price?: number | null, oldPrice?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: string | null, uiQuant?: string | null, quantAmount?: number | null, isDefault?: boolean | null, group?: string | null, salePeriod: (
        { start?: string | null, finish?: string | null }
        & { __typename: 'ProductPriceSalePeriod' }
      ) }
      & { __typename: 'ProductPriceOffer' }
    ) | null>, priceOffer?: (
      { id: string, price: number, oldPrice?: number | null, count_multiplier?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: number | null, quantAmount?: number | null, isDefault: boolean, group?: string | null, salePeriod?: (
        { start: string, finish: string }
        & { __typename: 'SalePeriod' }
      ) | null }
      & { __typename: 'PriceOffer' }
    ) | null }
    & { __typename: 'Product' }
  ) | null> | null }
  & { __typename: 'Query' }
);

export type SingleProductGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  shop_id: Scalars['ID']['input'];
}>;


export type SingleProductGroupQuery = (
  { singleProductGroup?: (
    { id?: string | null, created_at?: any | null, updated_at?: any | null, label?: string | null, type?: string | null, brand_id?: string | null, customer_id?: string | null }
    & { __typename: 'ProductGroup' }
  ) | null }
  & { __typename: 'Query' }
);

export type SaveProductReviewMutationVariables = Exact<{
  newData?: InputMaybe<ProductReviewInput>;
  upsert?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SaveProductReviewMutation = (
  { saveProductReview?: (
    { id: string, created_at?: any | null, status: number, customer_id?: string | null, product_id?: string | null, rating: number, comment?: string | null, images?: Array<(
      { url?: string | null }
      & { __typename: 'File' }
    ) | null> | null }
    & { __typename: 'ProductReview' }
  ) | null }
  & { __typename: 'Mutation' }
);

export type ZonesForGeoPointQueryVariables = Exact<{
  point: GeoPointInput;
  customerType?: InputMaybe<Scalars['String']['input']>;
}>;


export type ZonesForGeoPointQuery = (
  { zonesForGeoPoint?: Array<(
    { name: string, id: string, geo_delivery_zone?: string | null, shop_id?: string | null, status?: number | null, minOrderCost?: number | null, min_price?: number | null, delivery_cost?: number | null, first_delivery_cost?: number | null, freeSlotDeliveryCostFrom?: number | null, tzOffset?: number | null, shop?: (
      { id: string, name: string, firstAvailableSlot?: (
        { id: string, slotTime?: string | null, slotDate?: string | null }
        & { __typename: 'Slot' }
      ) | null }
      & { __typename: 'Shop' }
    ) | null, zoneGeoDeliveryZone?: Array<(
      { longitude?: number | null, latitude?: number | null }
      & { __typename: 'GeoPoint' }
    ) | null> | null, firstAvailableSlot?: (
      { id: string, slotTime?: string | null, slotDate?: string | null, shop_id?: string | null, availableUntil?: string | null, zone_id?: string | null, shop?: (
        { id: string, name: string, address?: string | null }
        & { __typename: 'Shop' }
      ) | null, period: (
        { to?: string | null, from?: string | null }
        & { __typename: 'SlotPeriod' }
      ) }
      & { __typename: 'Slot' }
    ) | null }
    & { __typename: 'DeliveryZone' }
  ) | null> | null }
  & { __typename: 'Query' }
);

export type AllMarketingStoriesQueryVariables = Exact<{
  style?: InputMaybe<Scalars['String']['input']>;
  imageStyle2?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllMarketingStoriesQuery = (
  { allMarketingStories?: (
    { edges?: Array<(
      { id?: string | null, name?: string | null, preview?: (
        { url?: string | null }
        & { __typename: 'File' }
      ) | null, slides?: Array<(
        { id?: string | null, name?: string | null, url?: string | null, optionOpenInBrowser?: boolean | null, optionOpenInNewWindow?: boolean | null, optionUrl?: string | null, image?: (
          { url?: string | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'MarketingStorySlide' }
      ) | null> | null }
      & { __typename: 'MarketingStory' }
    ) | null> | null }
    & { __typename: 'MarketingStoryEdge' }
  ) | null }
  & { __typename: 'Query' }
);

export type CheckIsEmailUsedMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type CheckIsEmailUsedMutation = (
  { checkIsEmailUsed?: boolean | null }
  & { __typename: 'Mutation' }
);

export type UpdateCustomerMutationVariables = Exact<{
  answers?: InputMaybe<Array<InputMaybe<CustomerProfileFieldInput>> | InputMaybe<CustomerProfileFieldInput>>;
}>;


export type UpdateCustomerMutation = (
  { updateCustomer?: boolean | null }
  & { __typename: 'Mutation' }
);

export type AuthBySmsCodeMutationVariables = Exact<{
  authBySmsCodeId: Scalars['ID']['input'];
  smsCode: Scalars['String']['input'];
}>;


export type AuthBySmsCodeMutation = (
  { authBySmsCode?: (
    { status?: number | null, id?: string | null }
    & { __typename: 'UserInfo' }
  ) | null }
  & { __typename: 'Mutation' }
);

export type PingAuthQueryVariables = Exact<{ [key: string]: never; }>;


export type PingAuthQuery = (
  { pingAuth?: (
    { id?: string | null, phone?: string | null, first_name?: string | null, last_name?: string | null, birthday?: any | null, new_phone?: string | null, status?: number | null, receipt_email?: string | null, secondsBeforeDeletion?: number | null, requireRegistration?: boolean | null }
    & { __typename: 'UserInfo' }
  ) | null }
  & { __typename: 'Query' }
);

export type LoginOrRegisterMutationVariables = Exact<{
  phone: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type LoginOrRegisterMutation = (
  { loginOrRegister: (
    { timeout?: number | null, sent?: boolean | null, id?: string | null, error?: string | null }
    & { __typename: 'SmsRequestedResponse' }
  ) }
  & { __typename: 'Mutation' }
);

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = (
  { logout?: boolean | null }
  & { __typename: 'Mutation' }
);

export type RequestNewSmsMutationVariables = Exact<{
  requestNewSmsId: Scalars['ID']['input'];
}>;


export type RequestNewSmsMutation = (
  { requestNewSms: (
    { id?: string | null, timeout?: number | null, sent?: boolean | null, error?: string | null }
    & { __typename: 'SmsRequestedResponse' }
  ) }
  & { __typename: 'Mutation' }
);

export type CartInfoQueryVariables = Exact<{
  cartInfo: CartInfoInput;
  style?: InputMaybe<Scalars['String']['input']>;
  imageStyle2?: InputMaybe<Scalars['String']['input']>;
  imagesStyle2?: InputMaybe<Scalars['String']['input']>;
  previewStyle2?: InputMaybe<Scalars['String']['input']>;
}>;


export type CartInfoQuery = (
  { cartInfo?: (
    { totalWeight?: number | null, promocode?: string | null, promocodeType?: string | null, priceGroup?: string | null, totals?: (
      { count?: number | null, baseTotal?: number | null, total?: number | null, baseSale?: number | null, sale?: number | null, salePercent?: number | null, maxSale?: number | null }
      & { __typename: 'CartInfoTotals' }
    ) | null, delivery?: (
      { total?: number | null, sale?: number | null, promoPercent?: number | null }
      & { __typename: 'CartDeliveryCostInfo' }
    ) | null, saleErrors?: Array<(
      { internalCode?: string | null, internalIssuer?: string | null, type?: string | null, message?: string | null, inputPart?: (
        { promocodes?: (
          { code?: string | null }
          & { __typename: 'SalePromocodeInputPart' }
        ) | null }
        & { __typename: 'CartSaleErrorInputPart' }
      ) | null }
      & { __typename: 'CartSaleError' }
    ) | null> | null, products?: Array<(
      { id?: string | null, amount?: number | null, shop_id?: string | null, comment?: string | null, info?: (
        { id: string, name: string, price?: number | null, oldPrice?: number | null, price_type: string, isWeightProduct?: boolean | null, count_multiplier?: number | null, isFavorite?: boolean | null, slug?: string | null, review_count?: number | null, is_alcohol?: boolean | null, min_age?: number | null, stock?: (
          { amount?: number | null }
          & { __typename: 'ProductStock' }
        ) | null, preview?: (
          { url?: string | null }
          & { __typename: 'File' }
        ) | null, marketingLabels?: Array<(
          { id?: string | null, title?: string | null, description?: string | null, activeFrom?: any | null, activeUntil?: any | null, optionColor?: string | null, optionBackgroundColor?: string | null, optionLink?: string | null, optionLinkLabel?: string | null, image?: (
            { url?: string | null }
            & { __typename: 'File' }
          ) | null }
          & { __typename: 'MarketingLabel' }
        ) | null> | null, priceOffers: Array<(
          { id: string, price?: number | null, oldPrice?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: string | null, uiQuant?: string | null, quantAmount?: number | null, isDefault?: boolean | null, group?: string | null, salePeriod: (
            { start?: string | null, finish?: string | null }
            & { __typename: 'ProductPriceSalePeriod' }
          ) }
          & { __typename: 'ProductPriceOffer' }
        ) | null>, priceOffer?: (
          { id: string, price: number, oldPrice?: number | null, count_multiplier?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: number | null, quantAmount?: number | null, isDefault: boolean, group?: string | null, salePeriod?: (
            { start: string, finish: string }
            & { __typename: 'SalePeriod' }
          ) | null }
          & { __typename: 'PriceOffer' }
        ) | null }
        & { __typename: 'Product' }
      ) | null }
      & { __typename: 'ExtendedCartItem' }
    ) | null> | null, saleAddedPositions?: Array<(
      { id?: string | null, productId?: string | null, positionKey?: string | null, amount?: number | null, price?: number | null, total?: number | null, info?: Product | null }
      & { __typename: 'SaleAddedPosition' }
    ) | null> | null }
    & { __typename: 'CartInfoProducts' }
  ) | null }
  & { __typename: 'Query' }
);

export type CheckProductsInStockQueryVariables = Exact<{
  productData: StockProductInput;
}>;


export type CheckProductsInStockQuery = (
  { checkProductsInStock?: Array<(
    { error_code: number, message?: string | null, max_amount: number, product_id: string, productInfo?: (
      { id?: string | null, name?: string | null }
      & { __typename: 'StockProduct' }
    ) | null }
    & { __typename: 'StockProductResult' }
  ) | null> | null }
  & { __typename: 'Query' }
);

export type ClearCartMutationVariables = Exact<{
  shopId: Scalars['ID']['input'];
}>;


export type ClearCartMutation = (
  { clearCart?: boolean | null }
  & { __typename: 'Mutation' }
);

export type DropCartItemMutationVariables = Exact<{
  shopId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
}>;


export type DropCartItemMutation = (
  { dropCartItem?: boolean | null }
  & { __typename: 'Mutation' }
);

export type InitialSyncCartsMutationVariables = Exact<{
  carts: Array<InputMaybe<CartInfoInput>> | InputMaybe<CartInfoInput>;
}>;


export type InitialSyncCartsMutation = (
  { initialSyncCarts?: Array<(
    { id?: string | null, product_id?: string | null, amount?: number | null, shop_id?: string | null, delivery_cost?: number | null, usedPromocode?: string | null }
    & { __typename: 'Cart' }
  ) | null> | null }
  & { __typename: 'Mutation' }
);

export type LoadCartsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadCartsQuery = (
  { loadCarts?: Array<(
    { shop_id?: string | null, items?: Array<(
      { product_id?: string | null, amount?: number | null, comment?: string | null, offer_id?: string | null }
      & { __typename: 'CartInfoOutputProduct' }
    ) | null> | null }
    & { __typename: 'CartInfoOutput' }
  ) | null> | null }
  & { __typename: 'Query' }
);

export type SyncCartMutationVariables = Exact<{
  cart: CartInfoInput;
}>;


export type SyncCartMutation = (
  { syncCart?: Array<(
    { id?: string | null, product_id?: string | null, amount?: number | null, shop_id?: string | null, delivery_cost?: number | null, usedPromocode?: string | null }
    & { __typename: 'Cart' }
  ) | null> | null }
  & { __typename: 'Mutation' }
);

export type UpdateCartProductAmountMutationVariables = Exact<{
  itemData: CartDataInput;
  shopId: Scalars['ID']['input'];
}>;


export type UpdateCartProductAmountMutation = (
  { updateCartProductAmount: Array<(
    { product_id: string, message?: string | null, max_amount: number, productInfo?: (
      { name?: string | null, id?: string | null }
      & { __typename: 'StockProduct' }
    ) | null }
    & { __typename: 'StockProductResult' }
  ) | null> }
  & { __typename: 'Mutation' }
);

export type SuggestionsQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type SuggestionsQuery = (
  { getAddressSuggestions?: (
    { suggestions?: Array<(
      { value: string, unrestricted_value: string, data?: (
        { geo_lat?: string | null, geo_lon?: string | null }
        & { __typename: 'GeoDataSuggestionData' }
      ) | null }
      & { __typename: 'GeoDataSuggestion' }
    ) | null> | null }
    & { __typename: 'GeoDataResponse' }
  ) | null }
  & { __typename: 'Query' }
);

export type SearchForAddressSuggestionsQueryVariables = Exact<{
  addressFilter: AddressSuggestionFilterInput;
}>;


export type SearchForAddressSuggestionsQuery = (
  { searchForAddressSuggestions?: (
    { suggestions?: Array<(
      { value: string, unrestricted_value: string, data?: (
        { geo_lat?: string | null, geo_lon?: string | null }
        & { __typename: 'GeoDataSuggestionData' }
      ) | null }
      & { __typename: 'GeoDataSuggestion' }
    ) | null> | null }
    & { __typename: 'GeoDataResponse' }
  ) | null }
  & { __typename: 'Query' }
);

export type AddFavoriteProductMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type AddFavoriteProductMutation = (
  { addFavoriteProduct?: boolean | null }
  & { __typename: 'Mutation' }
);

export type FavoriteProductsQueryVariables = Exact<{
  shopId: Scalars['ID']['input'];
  pager?: InputMaybe<CommonPagerInput>;
}>;


export type FavoriteProductsQuery = (
  { favoriteProducts?: (
    { pageInfo?: (
      { total?: number | null, next?: number | null, lastPage?: number | null, perPage?: number | null, page?: number | null }
      & { __typename: 'PageInfo' }
    ) | null, edges?: Array<(
      { id: string }
      & { __typename: 'Product' }
    ) | null> | null }
    & { __typename: 'ProductEdge' }
  ) | null }
  & { __typename: 'Query' }
);

export type FavoriteProductsCardsQueryVariables = Exact<{
  shopId: Scalars['ID']['input'];
  pager?: InputMaybe<CommonPagerInput>;
  style?: InputMaybe<Scalars['String']['input']>;
}>;


export type FavoriteProductsCardsQuery = (
  { favoriteProducts?: (
    { edges?: Array<(
      { id: string, name: string, price?: number | null, oldPrice?: number | null, price_type: string, isWeightProduct?: boolean | null, count_multiplier?: number | null, isFavorite?: boolean | null, slug?: string | null, review_count?: number | null, is_alcohol?: boolean | null, min_age?: number | null, stock?: (
        { amount?: number | null }
        & { __typename: 'ProductStock' }
      ) | null, preview?: (
        { url?: string | null }
        & { __typename: 'File' }
      ) | null, marketingLabels?: Array<(
        { id?: string | null, title?: string | null, description?: string | null, activeFrom?: any | null, activeUntil?: any | null, optionColor?: string | null, optionBackgroundColor?: string | null, optionLink?: string | null, optionLinkLabel?: string | null, image?: (
          { url?: string | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'MarketingLabel' }
      ) | null> | null, priceOffers: Array<(
        { id: string, price?: number | null, oldPrice?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: string | null, uiQuant?: string | null, quantAmount?: number | null, isDefault?: boolean | null, group?: string | null, salePeriod: (
          { start?: string | null, finish?: string | null }
          & { __typename: 'ProductPriceSalePeriod' }
        ) }
        & { __typename: 'ProductPriceOffer' }
      ) | null>, priceOffer?: (
        { id: string, price: number, oldPrice?: number | null, count_multiplier?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: number | null, quantAmount?: number | null, isDefault: boolean, group?: string | null, salePeriod?: (
          { start: string, finish: string }
          & { __typename: 'SalePeriod' }
        ) | null }
        & { __typename: 'PriceOffer' }
      ) | null }
      & { __typename: 'Product' }
    ) | null> | null, pageInfo?: (
      { page?: number | null, perPage?: number | null, lastPage?: number | null, next?: number | null, total?: number | null }
      & { __typename: 'PageInfo' }
    ) | null }
    & { __typename: 'ProductEdge' }
  ) | null }
  & { __typename: 'Query' }
);

export type RemoveFavoriteProductMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type RemoveFavoriteProductMutation = (
  { removeFavoriteProduct?: boolean | null }
  & { __typename: 'Mutation' }
);

export type SaveFeedbackMutationVariables = Exact<{
  feedbackInfo: FeedbackInput;
}>;


export type SaveFeedbackMutation = (
  { saveFeedback?: (
    { id?: string | null, brand_id?: string | null, order_id?: string | null, shop_id?: string | null, review?: string | null, general_rating?: number | null, assemble_rating?: number | null, shipping_rating?: number | null, product_rating?: number | null, need_call?: boolean | null, images?: Array<(
      { url?: string | null }
      & { __typename: 'File' }
    ) | null> | null }
    & { __typename: 'Feedback' }
  ) | null }
  & { __typename: 'Mutation' }
);

export type CustomerActivePaymentMethodsQueryVariables = Exact<{
  paymentPluginId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CustomerActivePaymentMethodsQuery = (
  { customerActivePaymentMethods?: Array<(
    { id?: string | null, type?: string | null, card?: string | null, last?: string | null, country?: string | null, pluginId?: string | null, isDefault?: boolean | null }
    & { __typename: 'CustomerPaymentMethod' }
  ) | null> | null }
  & { __typename: 'Query' }
);

export type ChooseDefaultPaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars['ID']['input'];
}>;


export type ChooseDefaultPaymentMethodMutation = (
  { chooseDefaultPaymentMethod?: (
    { id?: string | null, type?: string | null, card?: string | null, last?: string | null, country?: string | null, pluginId?: string | null, isDefault?: boolean | null }
    & { __typename: 'CustomerPaymentMethod' }
  ) | null }
  & { __typename: 'Mutation' }
);

export type ChoosePaymentPluginMutationVariables = Exact<{
  orderId?: InputMaybe<Scalars['ID']['input']>;
  paymentPluginId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
}>;

export type ChoosePaymentMethodForOrderMutation = (
  {
    choosePaymentMethodForOrder?: (
      {
        paymentMethod: CustomerPaymentMethod,
        affectedOrdersAmount: number,
        order: UserOrder
      }
    ) | null
  } & { __typename: 'Mutation' }
)

export type ChoosePaymentMethodForOrderMutationVariables = Exact<{
  paymentMethodId: Scalars['ID']['input'],
  orderId: Scalars['ID']['input'],
  useAsDefault?: InputMaybe<Scalars['Boolean']['input']>
  markAsDefault?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ChoosePaymentPluginMutation = (
  { choosePaymentPlugin?: (
    { pluginId?: string | null, type?: string | null, operationId?: string | null, payload?: (
      { embed?: string | null, controllable?: string | null, redirect?: string | null }
      & { __typename: 'PaymentPluginIntegrationInfoPayload' }
    ) | null }
    & { __typename: 'PaymentPluginIntegrationInfo' }
  ) | null }
  & { __typename: 'Mutation' }
);

export type PaymentPluginDetailsQueryVariables = Exact<{
  paymentPluginId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaymentPluginDetailsQuery = (
  { paymentPluginDetails?: (
    { id?: string | null, integrationType?: string | null, label?: string | null, description?: string | null }
    & { __typename: 'PaymentPluginInfo' }
  ) | null }
  & { __typename: 'Query' }
);

export type RemovePaymentMethodMutationVariables = Exact<{
  removePaymentMethodId: Scalars['ID']['input'];
}>;


export type RemovePaymentMethodMutation = (
  { removePaymentMethod: (
    { id: string, removed: boolean }
    & { __typename: 'CustomerPaymentMethodRemoveResult' }
  ) }
  & { __typename: 'Mutation' }
);

export type SearchProductsFullQueryVariables = Exact<{
  shopId: Scalars['ID']['input'];
  searchQuery: SearchQuery;
  style?: InputMaybe<Scalars['String']['input']>;
  pager?: InputMaybe<CommonPagerInput>;
  filter?: InputMaybe<NestedFilterInput>;
}>;


export type SearchProductsFullQuery = (
  { searchProducts?: (
    { edges?: Array<(
      { id: string, name: string, price?: number | null, oldPrice?: number | null, price_type: string, isWeightProduct?: boolean | null, count_multiplier?: number | null, isFavorite?: boolean | null, slug?: string | null, review_count?: number | null, is_alcohol?: boolean | null, min_age?: number | null, stock?: (
        { amount?: number | null }
        & { __typename: 'ProductStock' }
      ) | null, preview?: (
        { url?: string | null }
        & { __typename: 'File' }
      ) | null, marketingLabels?: Array<(
        { id?: string | null, title?: string | null, description?: string | null, activeFrom?: any | null, activeUntil?: any | null, optionColor?: string | null, optionBackgroundColor?: string | null, optionLink?: string | null, optionLinkLabel?: string | null, image?: (
          { url?: string | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'MarketingLabel' }
      ) | null> | null, priceOffers: Array<(
        { id: string, price?: number | null, oldPrice?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: string | null, uiQuant?: string | null, quantAmount?: number | null, isDefault?: boolean | null, group?: string | null, salePeriod: (
          { start?: string | null, finish?: string | null }
          & { __typename: 'ProductPriceSalePeriod' }
        ) }
        & { __typename: 'ProductPriceOffer' }
      ) | null>, priceOffer?: (
        { id: string, price: number, oldPrice?: number | null, count_multiplier?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: number | null, quantAmount?: number | null, isDefault: boolean, group?: string | null, salePeriod?: (
          { start: string, finish: string }
          & { __typename: 'SalePeriod' }
        ) | null }
        & { __typename: 'PriceOffer' }
      ) | null }
      & { __typename: 'Product' }
    ) | null> | null, pageInfo?: (
      { page?: number | null, perPage?: number | null, lastPage?: number | null, next?: number | null, total?: number | null }
      & { __typename: 'PageInfo' }
    ) | null, filters?: Array<(
      { id?: string | null, label?: string | null, type?: string | null, filterInputFieldName?: string | null, op?: string | null, values?: Array<(
        { name?: string | null, value?: string | null, gid?: string | null }
        & { __typename: 'ProductFilterValue' }
      ) | null> | null }
      & { __typename: 'ProductFilter' }
    ) | null> | null }
    & { __typename: 'SearchProductEdge' }
  ) | null }
  & { __typename: 'Query' }
);

export type SearchProductsQueryVariables = Exact<{
  shopId: Scalars['ID']['input'];
  searchQuery: SearchQuery;
  style?: InputMaybe<Scalars['String']['input']>;
  pager?: InputMaybe<CommonPagerInput>;
}>;


export type SearchProductsQuery = (
  { searchProducts?: (
    { edges?: Array<(
      { id: string, name: string, price?: number | null, oldPrice?: number | null, price_type: string, isWeightProduct?: boolean | null, count_multiplier?: number | null, isFavorite?: boolean | null, slug?: string | null, review_count?: number | null, is_alcohol?: boolean | null, min_age?: number | null, stock?: (
        { amount?: number | null }
        & { __typename: 'ProductStock' }
      ) | null, preview?: (
        { url?: string | null }
        & { __typename: 'File' }
      ) | null, marketingLabels?: Array<(
        { id?: string | null, title?: string | null, description?: string | null, activeFrom?: any | null, activeUntil?: any | null, optionColor?: string | null, optionBackgroundColor?: string | null, optionLink?: string | null, optionLinkLabel?: string | null, image?: (
          { url?: string | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'MarketingLabel' }
      ) | null> | null, priceOffers: Array<(
        { id: string, price?: number | null, oldPrice?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: string | null, uiQuant?: string | null, quantAmount?: number | null, isDefault?: boolean | null, group?: string | null, salePeriod: (
          { start?: string | null, finish?: string | null }
          & { __typename: 'ProductPriceSalePeriod' }
        ) }
        & { __typename: 'ProductPriceOffer' }
      ) | null>, priceOffer?: (
        { id: string, price: number, oldPrice?: number | null, count_multiplier?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: number | null, quantAmount?: number | null, isDefault: boolean, group?: string | null, salePeriod?: (
          { start: string, finish: string }
          & { __typename: 'SalePeriod' }
        ) | null }
        & { __typename: 'PriceOffer' }
      ) | null }
      & { __typename: 'Product' }
    ) | null> | null }
    & { __typename: 'SearchProductEdge' }
  ) | null }
  & { __typename: 'Query' }
);

export type DeleteAddressMutationVariables = Exact<{
  deleteAddressId: Scalars['ID']['input'];
}>;


export type DeleteAddressMutation = (
  { deleteAddress?: boolean | null }
  & { __typename: 'Mutation' }
);

export type SaveAddressMutationVariables = Exact<{
  addressInfo: CustomerAddressInput;
}>;


export type SaveAddressMutation = (
  { saveAddress?: (
    { id?: string | null, label?: string | null, shop_id?: string | null, address?: string | null, address_appartments?: string | null, address_intercom?: string | null, address_porch?: string | null, address_floor?: string | null, door_delivery?: boolean | null, no_door_call?: boolean | null, other_recipient?: boolean | null, recipient_phone?: string | null, recipient_name?: string | null, recipient_last_name?: string | null, comment?: string | null, shop?: (
      { id: string, name: string, address?: string | null }
      & { __typename: 'Shop' }
    ) | null }
    & { __typename: 'CustomerAddress' }
  ) | null }
  & { __typename: 'Mutation' }
);

export type ShopsInGeoPolygonQueryVariables = Exact<{
  corners: Array<InputMaybe<GeoPointInput>> | InputMaybe<GeoPointInput>;
  useZone?: InputMaybe<Scalars['Boolean']['input']>;
  customerType?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShopsInGeoPolygonQuery = (
  { shopsInGeoPolygon?: Array<(
    { id: string, name: string, address?: string | null, geo_delivery_zone?: string | null, status?: number | null, slug?: string | null, min_price?: number | null, minOrderCost?: number | null, delivery_cost?: number | null, first_delivery_cost?: number | null, phone?: string | null, open_time?: number | null, close_time?: number | null, brand_id?: number | null, isPickupDeliveryAvailable?: boolean | null, city_id?: string | null, geo_point?: (
      { latitude?: number | null, longitude?: number | null }
      & { __typename: 'GeoPoint' }
    ) | null, shopGeoPoint?: (
      { latitude?: number | null, longitude?: number | null }
      & { __typename: 'GeoPoint' }
    ) | null, brand?: (
      { id: string, name: string, status?: number | null, shops?: Array<(
        { id: string, name: string, address?: string | null, shopPickupDeliveryCost?: number | null, isPickupDeliveryAvailable?: boolean | null, shopHasPickupDelivery?: boolean | null, city_id?: string | null, geo_point?: (
          { latitude?: number | null, longitude?: number | null }
          & { __typename: 'GeoPoint' }
        ) | null, shopGeoPoint?: (
          { latitude?: number | null, longitude?: number | null }
          & { __typename: 'GeoPoint' }
        ) | null, images?: Array<(
          { url?: string | null }
          & { __typename: 'File' }
        ) | null> | null, firstAvailableSlot?: (
          { id: string, slotTime?: string | null, slotDate?: string | null, shop_id?: string | null, availableUntil?: string | null, zone_id?: string | null, shop?: (
            { id: string, name: string, address?: string | null, status?: number | null, slug?: string | null, min_price?: number | null, minOrderCost?: number | null, delivery_cost?: number | null, phone?: string | null, open_time?: number | null, close_time?: number | null, shopPickupDeliveryCost?: number | null, isPickupDeliveryAvailable?: boolean | null, city_id?: string | null, geo_point?: (
              { latitude?: number | null, longitude?: number | null }
              & { __typename: 'GeoPoint' }
            ) | null, shopGeoPoint?: (
              { latitude?: number | null, longitude?: number | null }
              & { __typename: 'GeoPoint' }
            ) | null }
            & { __typename: 'Shop' }
          ) | null }
          & { __typename: 'Slot' }
        ) | null }
        & { __typename: 'Shop' }
      ) | null> | null }
      & { __typename: 'Brand' }
    ) | null, firstAvailableSlot?: (
      { id: string, slotTime?: string | null, slotDate?: string | null, shop_id?: string | null, availableUntil?: string | null, zone_id?: string | null }
      & { __typename: 'Slot' }
    ) | null, shopTags?: Array<(
      { id: string, name: string }
      & { __typename: 'ShopTag' }
    ) | null> | null }
    & { __typename: 'Shop' }
  ) | null> | null }
  & { __typename: 'Query' }
);

export type PageInfoFieldsFragment = (
  { page?: number | null, perPage?: number | null, lastPage?: number | null, next?: number | null, total?: number | null }
  & { __typename: 'PageInfo' }
);

export type ProductBaseFieldsFragment = (
  { id: string, name: string, price?: number | null, oldPrice?: number | null, price_type: string, isWeightProduct?: boolean | null, count_multiplier?: number | null, isFavorite?: boolean | null, slug?: string | null, review_count?: number | null, is_alcohol?: boolean | null, min_age?: number | null, stock?: (
    { amount?: number | null }
    & { __typename: 'ProductStock' }
  ) | null, preview?: (
    { url?: string | null }
    & { __typename: 'File' }
  ) | null, marketingLabels?: Array<(
    { id?: string | null, title?: string | null, description?: string | null, activeFrom?: any | null, activeUntil?: any | null, optionColor?: string | null, optionBackgroundColor?: string | null, optionLink?: string | null, optionLinkLabel?: string | null, image?: (
      { url?: string | null }
      & { __typename: 'File' }
    ) | null }
    & { __typename: 'MarketingLabel' }
  ) | null> | null }
  & { __typename: 'Product' }
);

export type ProductPriceOffersFieldsFragment = (
  { priceOffers: Array<(
    { id: string, price?: number | null, oldPrice?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: string | null, uiQuant?: string | null, quantAmount?: number | null, isDefault?: boolean | null, group?: string | null, salePeriod: (
      { start?: string | null, finish?: string | null }
      & { __typename: 'ProductPriceSalePeriod' }
    ) }
    & { __typename: 'ProductPriceOffer' }
  ) | null> }
  & { __typename: 'Product' }
);

export type ProductPriceOfferFieldsFragment = (
  { priceOffer?: (
    { id: string, price: number, oldPrice?: number | null, count_multiplier?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: number | null, quantAmount?: number | null, isDefault: boolean, group?: string | null, salePeriod?: (
      { start: string, finish: string }
      & { __typename: 'SalePeriod' }
    ) | null }
    & { __typename: 'PriceOffer' }
  ) | null }
  & { __typename: 'Product' }
);

export type ProductWithOfferFragment = (
  { id: string, name: string, price?: number | null, oldPrice?: number | null, price_type: string, isWeightProduct?: boolean | null, count_multiplier?: number | null, isFavorite?: boolean | null, slug?: string | null, review_count?: number | null, is_alcohol?: boolean | null, min_age?: number | null, stock?: (
    { amount?: number | null }
    & { __typename: 'ProductStock' }
  ) | null, preview?: (
    { url?: string | null }
    & { __typename: 'File' }
  ) | null, marketingLabels?: Array<(
    { id?: string | null, title?: string | null, description?: string | null, activeFrom?: any | null, activeUntil?: any | null, optionColor?: string | null, optionBackgroundColor?: string | null, optionLink?: string | null, optionLinkLabel?: string | null, image?: (
      { url?: string | null }
      & { __typename: 'File' }
    ) | null }
    & { __typename: 'MarketingLabel' }
  ) | null> | null, priceOffers: Array<(
    { id: string, price?: number | null, oldPrice?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: string | null, uiQuant?: string | null, quantAmount?: number | null, isDefault?: boolean | null, group?: string | null, salePeriod: (
      { start?: string | null, finish?: string | null }
      & { __typename: 'ProductPriceSalePeriod' }
    ) }
    & { __typename: 'ProductPriceOffer' }
  ) | null>, priceOffer?: (
    { id: string, price: number, oldPrice?: number | null, count_multiplier?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: number | null, quantAmount?: number | null, isDefault: boolean, group?: string | null, salePeriod?: (
      { start: string, finish: string }
      & { __typename: 'SalePeriod' }
    ) | null }
    & { __typename: 'PriceOffer' }
  ) | null }
  & { __typename: 'Product' }
);

export type GetBarcodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBarcodeQuery = (
  { getBarcode?: (
    { code?: string | null, type?: string | null }
    & { __typename: 'Barcode' }
  ) | null }
  & { __typename: 'Query' }
);

export type InitializeOrderWithCartQueryVariables = Exact<{
  shopId: Scalars['ID']['input'];
  cart?: InputMaybe<CartInfoInput>;
}>;


export type InitializeOrderWithCartQuery = (
  { initializeOrderWithCart?: (
    { id: string, business_profile_id?: string | null, uuid?: string | null, shop_id: string, status: number, step: number, total?: number | null, delivery_total?: number | null, address?: string | null, comment?: string | null, customer_phone?: string | null, address_appartments?: string | null, address_intercom?: string | null, address_porch?: string | null, address_floor?: string | null, door_delivery?: boolean | null, receipt_email?: string | null, assembly_method?: number | null, slot_id?: string | null, deliveryType?: string | null, totalCashback?: number | null, totalDiscount?: number | null, customerCourierMessage?: string | null, payment_id?: string | null, recipientInfo?: (
      { phone?: string | null, firstName?: string | null, lastName?: string | null }
      & { __typename: 'OrderRecipientInfo' }
    ) | null, paymentMethod?: (
      { id?: string | null, type?: string | null, card?: string | null, last?: string | null, country?: string | null }
      & { __typename: 'CustomerPaymentMethod' }
    ) | null }
    & { __typename: 'OrderInfoOutput' }
  ) | null }
  & { __typename: 'Query' }
);

export type InitializeOrderQueryVariables = Exact<{
  shopId: Scalars['ID']['input'];
}>;


export type InitializeOrderQuery = (
  { initializeOrder?: (
    { id: string, business_profile_id?: string | null, uuid?: string | null, shop_id: string, status: number, step: number, total?: number | null, delivery_total?: number | null, address?: string | null, comment?: string | null, customer_phone?: string | null, address_appartments?: string | null, address_intercom?: string | null, address_porch?: string | null, address_floor?: string | null, door_delivery?: boolean | null, receipt_email?: string | null, assembly_method?: number | null, slot_id?: string | null, deliveryType?: string | null, totalCashback?: number | null, totalDiscount?: number | null, customerCourierMessage?: string | null, payment_id?: string | null, customer_geoposition?: (
      { latitude?: number | null, longitude?: number | null }
      & { __typename: 'GeoPoint' }
    ) | null, recipientInfo?: (
      { phone?: string | null, firstName?: string | null, lastName?: string | null }
      & { __typename: 'OrderRecipientInfo' }
    ) | null, paymentMethod?: (
      { id?: string | null, type?: string | null, card?: string | null, last?: string | null, country?: string | null }
      & { __typename: 'CustomerPaymentMethod' }
    ) | null }
    & { __typename: 'OrderInfoOutput' }
  ) | null }
  & { __typename: 'Query' }
);

export type PlaceOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type PlaceOrderMutation = (
  { placeOrder: (
    { error_code: number, order_id: string, placed: boolean, message?: string | null }
    & { __typename: 'PlaceOrderInfo' }
  ) }
  & { __typename: 'Mutation' }
);

export type UpdateOrderInfoWithSlotCheckMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  orderInfo?: InputMaybe<OrderInfoInput>;
}>;


export type UpdateOrderInfoWithSlotCheckMutation = (
  { updateOrderInfoWithSlotCheck?: (
    { isOk?: boolean | null, notifySlotChanged?: boolean | null, orderInfo?: (
      { id?: string | null, status?: number | null, courier_phone?: string | null, slot_id?: string | null }
      & { __typename: 'Order' }
    ) | null }
    & { __typename: 'UpdateOrderInfoResponse' }
  ) | null }
  & { __typename: 'Mutation' }
);

export type AllMyOrdersQueryVariables = Exact<{
  pager?: InputMaybe<CommonPagerInput>;
  style?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllMyOrdersQuery = (
  { allMyOrders?: (
    { edges?: Array<(
      { id: string, shop_id?: string | null, created_at?: any | null, status: number, total?: number | null, customerFinalCost?: number | null, deliveryCost?: number | null, address?: string | null, totalCashback?: number | null, totalDiscount?: number | null, deliveryType?: string | null, shop?: (
        { id: string, name: string, address?: string | null, status?: number | null }
        & { __typename: 'Shop' }
      ) | null, deliverySlot?: (
        { id: string, slotTime?: string | null, slotDate?: string | null, shop_id?: string | null, availableUntil?: string | null, zone_id?: string | null }
        & { __typename: 'Slot' }
      ) | null, paymentMethod?: (
        { id?: string | null, type?: string | null, card?: string | null, last?: string | null, isDefault?: boolean | null }
        & { __typename: 'CustomerPaymentMethod' }
      ) | null, meta?: Array<(
        { id?: string | null, product_id?: string | null, shop_id?: string | null, name?: string | null, price?: number | null, count?: number | null, weight?: number | null, total_weight?: number | null, total?: number | null, status?: number | null, assembly_method?: number | null, assembled_count?: number | null, assembled_total?: number | null, cashback?: number | null, unit_multiplier?: number | null, changedBy?: (
          { id?: string | null, product_id?: string | null, shop_id?: string | null, name?: string | null, price?: number | null, unit_multiplier?: number | null, count?: number | null, weight?: number | null, total_weight?: number | null, total?: number | null, status?: number | null, assembly_method?: number | null, assembled_count?: number | null, assembled_weight?: number | null, assembled_total?: number | null, cashback?: number | null }
          & { __typename: 'UserOrderProductPosition' }
        ) | null, isChangeTo?: (
          { id?: string | null, product_id?: string | null, shop_id?: string | null, name?: string | null, price?: number | null, unit_multiplier?: number | null, count?: number | null, weight?: number | null, total_weight?: number | null, total?: number | null, status?: number | null, assembly_method?: number | null, assembled_count?: number | null, assembled_weight?: number | null, assembled_total?: number | null, cashback?: number | null }
          & { __typename: 'UserOrderProductPosition' }
        ) | null, product?: (
          { id: string, name: string, price?: number | null, oldPrice?: number | null, price_type: string, isWeightProduct?: boolean | null, count_multiplier?: number | null, isFavorite?: boolean | null, slug?: string | null, review_count?: number | null, is_alcohol?: boolean | null, min_age?: number | null, stock?: (
            { amount?: number | null }
            & { __typename: 'ProductStock' }
          ) | null, preview?: (
            { url?: string | null }
            & { __typename: 'File' }
          ) | null, marketingLabels?: Array<(
            { id?: string | null, title?: string | null, description?: string | null, activeFrom?: any | null, activeUntil?: any | null, optionColor?: string | null, optionBackgroundColor?: string | null, optionLink?: string | null, optionLinkLabel?: string | null, image?: (
              { url?: string | null }
              & { __typename: 'File' }
            ) | null }
            & { __typename: 'MarketingLabel' }
          ) | null> | null }
          & { __typename: 'Product' }
        ) | null }
        & { __typename: 'UserOrderProductPosition' }
      ) | null> | null }
      & { __typename: 'UserOrder' }
    ) | null> | null, pageInfo?: (
      { page?: number | null, perPage?: number | null, lastPage?: number | null, next?: number | null, total?: number | null }
      & { __typename: 'PageInfo' }
    ) | null }
    & { __typename: 'OrdersEdge' }
  ) | null }
  & { __typename: 'Query' }
);

export type OfflinePurchasesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
}>;


export type OfflinePurchasesQuery = (
  { offlinePurchases?: Array<(
    { id: string, shop_id?: string | null, created_at?: any | null, placed_at?: any | null, status: number, total?: number | null, saledCost?: number | null, customerFinalCost?: number | null, deliveryCost?: number | null, weight?: number | null, address?: string | null, comment?: string | null, slot_id?: string | null, payment_status?: number | null, payment_type?: string | null, cash_change?: number | null, payment_token_id?: string | null, payment_id?: string | null, assembled_total?: number | null, totalCashback?: number | null, totalDiscount?: number | null, reviewInvite?: boolean | null, pickup_code?: string | null, deliveryType?: string | null, placedAt?: any | null, assemblingFinishedAt?: any | null, deliveryFinishedAt?: any | null, paymentReceivedAt?: any | null, deliverySlot?: (
      { id: string, slotTime?: string | null, slotDate?: string | null, shop_id?: string | null, availableUntil?: string | null, zone_id?: string | null, period: (
        { from?: string | null, to?: string | null }
        & { __typename: 'SlotPeriod' }
      ) }
      & { __typename: 'Slot' }
    ) | null, paymentMethod?: (
      { id?: string | null, type?: string | null, card?: string | null, last?: string | null, country?: string | null, pluginId?: string | null, isDefault?: boolean | null }
      & { __typename: 'CustomerPaymentMethod' }
    ) | null, meta?: Array<(
      { id?: string | null, product_id?: string | null, shop_id?: string | null, name?: string | null, price?: number | null, unit_multiplier?: number | null, count?: number | null, weight?: number | null, total_weight?: number | null, total?: number | null, status?: number | null, assembly_method?: number | null, assembled_count?: number | null, assembled_weight?: number | null, assembled_total?: number | null, cashback?: number | null, product?: (
        { id: string, name: string, price?: number | null, oldPrice?: number | null, price_type: string, isWeightProduct?: boolean | null, count_multiplier?: number | null, isFavorite?: boolean | null, slug?: string | null, review_count?: number | null, is_alcohol?: boolean | null, min_age?: number | null, stock?: (
          { amount?: number | null }
          & { __typename: 'ProductStock' }
        ) | null, preview?: (
          { url?: string | null }
          & { __typename: 'File' }
        ) | null, marketingLabels?: Array<(
          { id?: string | null, title?: string | null, description?: string | null, activeFrom?: any | null, activeUntil?: any | null, optionColor?: string | null, optionBackgroundColor?: string | null, optionLink?: string | null, optionLinkLabel?: string | null, image?: (
            { url?: string | null }
            & { __typename: 'File' }
          ) | null }
          & { __typename: 'MarketingLabel' }
        ) | null> | null, priceOffers: Array<(
          { id: string, price?: number | null, oldPrice?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: string | null, uiQuant?: string | null, quantAmount?: number | null, isDefault?: boolean | null, group?: string | null, salePeriod: (
            { start?: string | null, finish?: string | null }
            & { __typename: 'ProductPriceSalePeriod' }
          ) }
          & { __typename: 'ProductPriceOffer' }
        ) | null>, priceOffer?: (
          { id: string, price: number, oldPrice?: number | null, count_multiplier?: number | null, min?: number | null, max?: number | null, step?: number | null, quant?: number | null, quantAmount?: number | null, isDefault: boolean, group?: string | null, salePeriod?: (
            { start: string, finish: string }
            & { __typename: 'SalePeriod' }
          ) | null }
          & { __typename: 'PriceOffer' }
        ) | null }
        & { __typename: 'Product' }
      ) | null }
      & { __typename: 'UserOrderProductPosition' }
    ) | null> | null, saleInfo?: (
      { type?: string | null, name?: string | null, discount?: number | null }
      & { __typename: 'OrderSaleInfo' }
    ) | null, receipts?: Array<(
      { id: string, type?: string | null, status?: string | null, receiptQueryString?: string | null, receiptPreviewUrl?: string | null }
      & { __typename: 'UserOrderReceiptInfo' }
    ) | null> | null, recipientInfo?: (
      { phone?: string | null, firstName?: string | null, lastName?: string | null }
      & { __typename: 'OrderRecipientInfo' }
    ) | null }
    & { __typename: 'UserOrder' }
  ) | null> | null }
  & { __typename: 'Query' }
);

export type MyAddressesQueryVariables = Exact<{
  showPickupShops?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MyAddressesQuery = (
  { myAddresses?: Array<(
    { id?: string | null, label?: string | null, shop_id?: string | null, address?: string | null, address_appartments?: string | null, address_intercom?: string | null, address_porch?: string | null, address_floor?: string | null, door_delivery?: boolean | null, no_door_call?: boolean | null, other_recipient?: boolean | null, recipient_phone?: string | null, recipient_name?: string | null, recipient_last_name?: string | null, comment?: string | null, shop?: (
      { id: string, name: string, address?: string | null, distance?: number | null, geo_point?: (
        { latitude?: number | null, longitude?: number | null }
        & { __typename: 'GeoPoint' }
      ) | null, shopGeoPoint?: (
        { latitude?: number | null, longitude?: number | null }
        & { __typename: 'GeoPoint' }
      ) | null, brand?: (
        { id: string, name: string }
        & { __typename: 'Brand' }
      ) | null, firstAvailableSlot?: (
        { id: string, slotTime?: string | null, slotDate?: string | null, shop_id?: string | null, availableUntil?: string | null, zone_id?: string | null, period: (
          { from?: string | null, to?: string | null }
          & { __typename: 'SlotPeriod' }
        ) }
        & { __typename: 'Slot' }
      ) | null, shopTags?: Array<(
        { id: string, name: string, icon?: (
          { url?: string | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'ShopTag' }
      ) | null> | null, images?: Array<(
        { url?: string | null }
        & { __typename: 'File' }
      ) | null> | null, deliveryZones?: (
        { id: string, name: string, shop_id?: string | null, zoneGeoDeliveryZone?: Array<(
          { latitude?: number | null, longitude?: number | null }
          & { __typename: 'GeoPoint' }
        ) | null> | null, firstAvailableSlot?: (
          { id: string, slotTime?: string | null, slotDate?: string | null, shop_id?: string | null, availableUntil?: string | null, zone_id?: string | null }
          & { __typename: 'Slot' }
        ) | null }
        & { __typename: 'DeliveryZone' }
      ) | null }
      & { __typename: 'Shop' }
    ) | null, customerGeoPoint?: (
      { latitude?: number | null, longitude?: number | null }
      & { __typename: 'GeoPoint' }
    ) | null }
    & { __typename: 'CustomerAddress' }
  ) | null> | null }
  & { __typename: 'Query' }
);

export type MyBonusTotalQueryVariables = Exact<{ [key: string]: never; }>;


export type MyBonusTotalQuery = (
  { myBonus?: (
    { bonusBalance?: number | null, activeBonuses?: number | null, bonusCards?: Array<(
      { id?: string | null, cardNumber?: string | null, barCode?: string | null, status?: string | null }
      & { __typename: 'BonusCard' }
    ) | null> | null, pendingBonuses?: Array<(
      { amount?: number | null, nextActivationAmount?: number | null, activationDate?: string | null }
      & { __typename: 'PendingBonus' }
    ) | null> | null, nearestExpiringBonus?: (
      { expireAmount?: number | null, expireAt?: any | null }
      & { __typename: 'NearestExpiringBonus' }
    ) | null }
    & { __typename: 'CustomerBonusInfo' }
  ) | null }
  & { __typename: 'Query' }
);

export type MyBonusHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type MyBonusHistoryQuery = (
  { bonusHistory?: Array<(
    { id?: string | null, accountType?: string | null, type?: string | null, amount?: number | null, saledAt?: any | null, operationAt?: any | null, activationAt?: any | null, expireAt?: any | null, purchaseId?: string | null, comment?: string | null }
    & { __typename: 'BonusOperation' }
  ) | null> | null }
  & { __typename: 'Query' }
);

export type AvailableSlotsQueryVariables = Exact<{
  shopId?: InputMaybe<Scalars['ID']['input']>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AvailableSlotsQuery = (
  { availableSlots?: Array<(
    { id: string, slotTime?: string | null, slotDate?: string | null, shop_id?: string | null, availableUntil?: string | null, zone_id?: string | null, shop?: (
      { id: string, name: string, address?: string | null }
      & { __typename: 'Shop' }
    ) | null, period: (
      { from?: string | null, to?: string | null }
      & { __typename: 'SlotPeriod' }
    ) }
    & { __typename: 'Slot' }
  ) | null> | null }
  & { __typename: 'Query' }
);

export const PageInfoFieldsFragmentDoc = gql`
    fragment PageInfoFields on PageInfo {
  page
  perPage
  lastPage
  next
  total
}
    `
export const ProductBaseFieldsFragmentDoc = gql`
    fragment ProductBaseFields on Product {
  id
  xid
  name
  price
  oldPrice
  price_type
  isWeightProduct
  count_multiplier
  isFavorite
  stock {
    amount
  }
  preview {
    url
  }
  slug
  average_rating
  review_count
  marketingLabels {
    id
    title
    description
    image(style: "600xauto") {
      url
    }
    activeFrom
    activeUntil
    optionColor
    optionBackgroundColor
    optionLink
    optionLinkLabel
  }
  is_alcohol
  min_age
}
    `
export const ProductPriceOffersFieldsFragmentDoc = gql`
    fragment ProductPriceOffersFields on Product {
  priceOffers {
    id
    price
    oldPrice
    salePeriod {
      start
      finish
    }
    min
    max
    step
    quant
    uiQuant
    quantAmount
    isDefault
    group
  }
}
    `
export const ProductPriceOfferFieldsFragmentDoc = gql`
    fragment ProductPriceOfferFields on Product {
  priceOffer @client {
    id
    price
    oldPrice
    count_multiplier
    salePeriod {
      start
      finish
    }
    min
    max
    step
    quant
    quantAmount
    uiQuant
    isDefault
    group
  }
}
    `
export const ProductWithOfferFragmentDoc = gql`
    fragment ProductWithOffer on Product {
  ...ProductBaseFields
  ...ProductPriceOffersFields
  ...ProductPriceOfferFields
}
    ${ProductBaseFieldsFragmentDoc}
${ProductPriceOffersFieldsFragmentDoc}
${ProductPriceOfferFieldsFragmentDoc}`
export const AllBannersDocument = gql`
    query AllBanners($pager: CommonPagerInput, $style: String, $bannerMobileSlideStyle2: String, $filter: NestedFilterInput) {
  allBanners(pager: $pager, filter: $filter) {
    edges {
      id
      name
      url
      status
      has_button
      button_text
      button_color
      bannerSlide(style: $style) {
        url
      }
      bannerMobileSlide(style: $bannerMobileSlideStyle2) {
        url
      }
      optionOpenInNewWindow
      optionOpenInBrowser
    }
  }
}
    `

/**
 * __useAllBannersQuery__
 *
 * To run a query within a React component, call `useAllBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllBannersQuery({
 *   variables: {
 *      pager: // value for 'pager'
 *      style: // value for 'style'
 *      bannerMobileSlideStyle2: // value for 'bannerMobileSlideStyle2'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllBannersQuery (baseOptions?: Apollo.QueryHookOptions<AllBannersQuery, AllBannersQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<AllBannersQuery, AllBannersQueryVariables>(AllBannersDocument, options)
}
export function useAllBannersLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<AllBannersQuery, AllBannersQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<AllBannersQuery, AllBannersQueryVariables>(AllBannersDocument, options)
}
export function useAllBannersSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllBannersQuery, AllBannersQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<AllBannersQuery, AllBannersQueryVariables>(AllBannersDocument, options)
}
export type AllBannersQueryHookResult = ReturnType<typeof useAllBannersQuery>;
export type AllBannersLazyQueryHookResult = ReturnType<typeof useAllBannersLazyQuery>;
export type AllBannersSuspenseQueryHookResult = ReturnType<typeof useAllBannersSuspenseQuery>;
export type AllBannersQueryResult = Apollo.QueryResult<AllBannersQuery, AllBannersQueryVariables>;
export const AllTextMaterialsDocument = gql`
    query AllTextMaterials($pager: CommonPagerInput, $sort: CommonSortInput, $filter: NestedFilterInput, $style: String) {
  allTextMaterials(filter: $filter, pager: $pager, sort: $sort) {
    edges {
      id
      type {
        id
        title
        icon
      }
      category {
        id
        title
        slug
        parent {
          id
          title
        }
        children {
          id
          title
        }
      }
      themes {
        id
        title
        slug
      }
      tags {
        id
        title
        slug
      }
      author {
        id
        name
        photo {
          url
        }
      }
      preview(style: $style) {
        url
      }
      slug
      publishedAt
      viewsCount
      likesCount
      commentsCount
      averageRating
      title
      content
      lead
    }
    pageInfo {
      ...PageInfoFields
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`

/**
 * __useAllTextMaterialsQuery__
 *
 * To run a query within a React component, call `useAllTextMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTextMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTextMaterialsQuery({
 *   variables: {
 *      pager: // value for 'pager'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllTextMaterialsQuery (baseOptions?: Apollo.QueryHookOptions<AllTextMaterialsQuery, AllTextMaterialsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<AllTextMaterialsQuery, AllTextMaterialsQueryVariables>(AllTextMaterialsDocument, options)
}
export function useAllTextMaterialsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<AllTextMaterialsQuery, AllTextMaterialsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<AllTextMaterialsQuery, AllTextMaterialsQueryVariables>(AllTextMaterialsDocument, options)
}
export function useAllTextMaterialsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllTextMaterialsQuery, AllTextMaterialsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<AllTextMaterialsQuery, AllTextMaterialsQueryVariables>(AllTextMaterialsDocument, options)
}
export type AllTextMaterialsQueryHookResult = ReturnType<typeof useAllTextMaterialsQuery>;
export type AllTextMaterialsLazyQueryHookResult = ReturnType<typeof useAllTextMaterialsLazyQuery>;
export type AllTextMaterialsSuspenseQueryHookResult = ReturnType<typeof useAllTextMaterialsSuspenseQuery>;
export type AllTextMaterialsQueryResult = Apollo.QueryResult<AllTextMaterialsQuery, AllTextMaterialsQueryVariables>;
export const SingleTextMaterialDocument = gql`
    query SingleTextMaterial($singleTextMaterialId: ID, $slug: String) {
  singleTextMaterial(id: $singleTextMaterialId, slug: $slug) {
    id
    type {
      id
      title
      icon
    }
    category {
      id
      title
      slug
    }
    themes {
      id
      title
      slug
    }
    tags {
      id
      title
      slug
    }
    author {
      id
      name
      disclaimer
      photo {
        url
      }
    }
    preview {
      url
    }
    preview_source
    preview_url
    slug
    publishedAt
    viewsCount
    likesCount
    commentsCount
    averageRating
    title
    content
    lead
  }
}
    `

/**
 * __useSingleTextMaterialQuery__
 *
 * To run a query within a React component, call `useSingleTextMaterialQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTextMaterialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTextMaterialQuery({
 *   variables: {
 *      singleTextMaterialId: // value for 'singleTextMaterialId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSingleTextMaterialQuery (baseOptions?: Apollo.QueryHookOptions<SingleTextMaterialQuery, SingleTextMaterialQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<SingleTextMaterialQuery, SingleTextMaterialQueryVariables>(SingleTextMaterialDocument, options)
}
export function useSingleTextMaterialLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<SingleTextMaterialQuery, SingleTextMaterialQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<SingleTextMaterialQuery, SingleTextMaterialQueryVariables>(SingleTextMaterialDocument, options)
}
export function useSingleTextMaterialSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SingleTextMaterialQuery, SingleTextMaterialQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<SingleTextMaterialQuery, SingleTextMaterialQueryVariables>(SingleTextMaterialDocument, options)
}
export type SingleTextMaterialQueryHookResult = ReturnType<typeof useSingleTextMaterialQuery>;
export type SingleTextMaterialLazyQueryHookResult = ReturnType<typeof useSingleTextMaterialLazyQuery>;
export type SingleTextMaterialSuspenseQueryHookResult = ReturnType<typeof useSingleTextMaterialSuspenseQuery>;
export type SingleTextMaterialQueryResult = Apollo.QueryResult<SingleTextMaterialQuery, SingleTextMaterialQueryVariables>;
export const TextMaterialCategoriesDocument = gql`
    query TextMaterialCategories {
  textMaterialCategories {
    id
    title
    slug
    parent {
      id
      title
      slug
    }
    children {
      id
      title
      slug
    }
  }
}
    `

/**
 * __useTextMaterialCategoriesQuery__
 *
 * To run a query within a React component, call `useTextMaterialCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTextMaterialCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTextMaterialCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTextMaterialCategoriesQuery (baseOptions?: Apollo.QueryHookOptions<TextMaterialCategoriesQuery, TextMaterialCategoriesQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<TextMaterialCategoriesQuery, TextMaterialCategoriesQueryVariables>(TextMaterialCategoriesDocument, options)
}
export function useTextMaterialCategoriesLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<TextMaterialCategoriesQuery, TextMaterialCategoriesQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<TextMaterialCategoriesQuery, TextMaterialCategoriesQueryVariables>(TextMaterialCategoriesDocument, options)
}
export function useTextMaterialCategoriesSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TextMaterialCategoriesQuery, TextMaterialCategoriesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<TextMaterialCategoriesQuery, TextMaterialCategoriesQueryVariables>(TextMaterialCategoriesDocument, options)
}
export type TextMaterialCategoriesQueryHookResult = ReturnType<typeof useTextMaterialCategoriesQuery>;
export type TextMaterialCategoriesLazyQueryHookResult = ReturnType<typeof useTextMaterialCategoriesLazyQuery>;
export type TextMaterialCategoriesSuspenseQueryHookResult = ReturnType<typeof useTextMaterialCategoriesSuspenseQuery>;
export type TextMaterialCategoriesQueryResult = Apollo.QueryResult<TextMaterialCategoriesQuery, TextMaterialCategoriesQueryVariables>;
export const CategoriesBranchDocument = gql`
    query CategoriesBranch($shopId: ID!, $style: String, $parentId: ID) {
  categoriesBranch(shop_id: $shopId, parent_id: $parentId) {
    name
    id
    childrens {
      id
      name
      childrens {
        childrens {
          id
          name
        }
      }
      slug
    }
    icon(style: $style) {
      url
    }
    slug
    miniIcon(style: $style) {
      url
    }
  }
}
    `

/**
 * __useCategoriesBranchQuery__
 *
 * To run a query within a React component, call `useCategoriesBranchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesBranchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesBranchQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      style: // value for 'style'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useCategoriesBranchQuery (baseOptions: Apollo.QueryHookOptions<CategoriesBranchQuery, CategoriesBranchQueryVariables> & ({ variables: CategoriesBranchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<CategoriesBranchQuery, CategoriesBranchQueryVariables>(CategoriesBranchDocument, options)
}
export function useCategoriesBranchLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<CategoriesBranchQuery, CategoriesBranchQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<CategoriesBranchQuery, CategoriesBranchQueryVariables>(CategoriesBranchDocument, options)
}
export function useCategoriesBranchSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategoriesBranchQuery, CategoriesBranchQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<CategoriesBranchQuery, CategoriesBranchQueryVariables>(CategoriesBranchDocument, options)
}
export type CategoriesBranchQueryHookResult = ReturnType<typeof useCategoriesBranchQuery>;
export type CategoriesBranchLazyQueryHookResult = ReturnType<typeof useCategoriesBranchLazyQuery>;
export type CategoriesBranchSuspenseQueryHookResult = ReturnType<typeof useCategoriesBranchSuspenseQuery>;
export type CategoriesBranchQueryResult = Apollo.QueryResult<CategoriesBranchQuery, CategoriesBranchQueryVariables>;
export const CategoriesPreviewProductsDocument = gql`
    query CategoriesPreviewProducts($shopId: ID!, $parentId: ID, $style: String, $ids: [ID]) {
  categories(shop_id: $shopId, parent_id: $parentId, ids: $ids) {
    slug
    parent_id
    name
    is_alcohol
    id
    icon(style: $style) {
      url
    }
    preview_size
    miniIcon(style: $style) {
      url
    }
    products {
      ...ProductWithOffer
    }
  }
}
    ${ProductWithOfferFragmentDoc}`

/**
 * __useCategoriesPreviewProductsQuery__
 *
 * To run a query within a React component, call `useCategoriesPreviewProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesPreviewProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesPreviewProductsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      parentId: // value for 'parentId'
 *      style: // value for 'style'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCategoriesPreviewProductsQuery (baseOptions: Apollo.QueryHookOptions<CategoriesPreviewProductsQuery, CategoriesPreviewProductsQueryVariables> & ({ variables: CategoriesPreviewProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<CategoriesPreviewProductsQuery, CategoriesPreviewProductsQueryVariables>(CategoriesPreviewProductsDocument, options)
}
export function useCategoriesPreviewProductsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<CategoriesPreviewProductsQuery, CategoriesPreviewProductsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<CategoriesPreviewProductsQuery, CategoriesPreviewProductsQueryVariables>(CategoriesPreviewProductsDocument, options)
}
export function useCategoriesPreviewProductsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategoriesPreviewProductsQuery, CategoriesPreviewProductsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<CategoriesPreviewProductsQuery, CategoriesPreviewProductsQueryVariables>(CategoriesPreviewProductsDocument, options)
}
export type CategoriesPreviewProductsQueryHookResult = ReturnType<typeof useCategoriesPreviewProductsQuery>;
export type CategoriesPreviewProductsLazyQueryHookResult = ReturnType<typeof useCategoriesPreviewProductsLazyQuery>;
export type CategoriesPreviewProductsSuspenseQueryHookResult = ReturnType<typeof useCategoriesPreviewProductsSuspenseQuery>;
export type CategoriesPreviewProductsQueryResult = Apollo.QueryResult<CategoriesPreviewProductsQuery, CategoriesPreviewProductsQueryVariables>;
export const CategoriesPreviewDocument = gql`
    query CategoriesPreview($shopId: ID!, $parentId: ID, $style: String, $ids: [ID]) {
  categories(shop_id: $shopId, parent_id: $parentId, ids: $ids) {
    slug
    parent_id
    name
    is_alcohol
    id
    icon(style: $style) {
      url
    }
    preview_size
    miniIcon(style: $style) {
      url
    }
  }
}
    `

/**
 * __useCategoriesPreviewQuery__
 *
 * To run a query within a React component, call `useCategoriesPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesPreviewQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      parentId: // value for 'parentId'
 *      style: // value for 'style'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCategoriesPreviewQuery (baseOptions: Apollo.QueryHookOptions<CategoriesPreviewQuery, CategoriesPreviewQueryVariables> & ({ variables: CategoriesPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<CategoriesPreviewQuery, CategoriesPreviewQueryVariables>(CategoriesPreviewDocument, options)
}
export function useCategoriesPreviewLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<CategoriesPreviewQuery, CategoriesPreviewQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<CategoriesPreviewQuery, CategoriesPreviewQueryVariables>(CategoriesPreviewDocument, options)
}
export function useCategoriesPreviewSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategoriesPreviewQuery, CategoriesPreviewQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<CategoriesPreviewQuery, CategoriesPreviewQueryVariables>(CategoriesPreviewDocument, options)
}
export type CategoriesPreviewQueryHookResult = ReturnType<typeof useCategoriesPreviewQuery>;
export type CategoriesPreviewLazyQueryHookResult = ReturnType<typeof useCategoriesPreviewLazyQuery>;
export type CategoriesPreviewSuspenseQueryHookResult = ReturnType<typeof useCategoriesPreviewSuspenseQuery>;
export type CategoriesPreviewQueryResult = Apollo.QueryResult<CategoriesPreviewQuery, CategoriesPreviewQueryVariables>;
export const CategoryDocument = gql`
    query Category($shopId: ID!, $categoryId: ID, $slug: String) {
  category(shop_id: $shopId, id: $categoryId, slug: $slug) {
    id
    name
    slug
    parent {
      slug
      name
      id
    }
  }
}
    `

/**
 * __useCategoryQuery__
 *
 * To run a query within a React component, call `useCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      categoryId: // value for 'categoryId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCategoryQuery (baseOptions: Apollo.QueryHookOptions<CategoryQuery, CategoryQueryVariables> & ({ variables: CategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<CategoryQuery, CategoryQueryVariables>(CategoryDocument, options)
}
export function useCategoryLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<CategoryQuery, CategoryQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<CategoryQuery, CategoryQueryVariables>(CategoryDocument, options)
}
export function useCategorySuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategoryQuery, CategoryQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<CategoryQuery, CategoryQueryVariables>(CategoryDocument, options)
}
export type CategoryQueryHookResult = ReturnType<typeof useCategoryQuery>;
export type CategoryLazyQueryHookResult = ReturnType<typeof useCategoryLazyQuery>;
export type CategorySuspenseQueryHookResult = ReturnType<typeof useCategorySuspenseQuery>;
export type CategoryQueryResult = Apollo.QueryResult<CategoryQuery, CategoryQueryVariables>;
export const CustomerProfileFieldsDocument = gql`
    query CustomerProfileFields($isRegistration: Boolean) {
  customerProfileFields(isRegistration: $isRegistration) {
    id
    order
    label
    fieldName
    type
    required
    isReadOnly
    isVisibleInRegistration
    answer
    defaultValue
    fixedAnswers {
      name
      value
    }
  }
}
    `

/**
 * __useCustomerProfileFieldsQuery__
 *
 * To run a query within a React component, call `useCustomerProfileFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerProfileFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerProfileFieldsQuery({
 *   variables: {
 *      isRegistration: // value for 'isRegistration'
 *   },
 * });
 */
export function useCustomerProfileFieldsQuery (baseOptions?: Apollo.QueryHookOptions<CustomerProfileFieldsQuery, CustomerProfileFieldsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<CustomerProfileFieldsQuery, CustomerProfileFieldsQueryVariables>(CustomerProfileFieldsDocument, options)
}
export function useCustomerProfileFieldsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<CustomerProfileFieldsQuery, CustomerProfileFieldsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<CustomerProfileFieldsQuery, CustomerProfileFieldsQueryVariables>(CustomerProfileFieldsDocument, options)
}
export function useCustomerProfileFieldsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerProfileFieldsQuery, CustomerProfileFieldsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<CustomerProfileFieldsQuery, CustomerProfileFieldsQueryVariables>(CustomerProfileFieldsDocument, options)
}
export type CustomerProfileFieldsQueryHookResult = ReturnType<typeof useCustomerProfileFieldsQuery>;
export type CustomerProfileFieldsLazyQueryHookResult = ReturnType<typeof useCustomerProfileFieldsLazyQuery>;
export type CustomerProfileFieldsSuspenseQueryHookResult = ReturnType<typeof useCustomerProfileFieldsSuspenseQuery>;
export type CustomerProfileFieldsQueryResult = Apollo.QueryResult<CustomerProfileFieldsQuery, CustomerProfileFieldsQueryVariables>;
export const RegisterCustomerDocument = gql`
    mutation RegisterCustomer($answers: [CustomerProfileFieldInput]) {
  registerCustomer(answers: $answers)
}
    `
export type RegisterCustomerMutationFn = Apollo.MutationFunction<RegisterCustomerMutation, RegisterCustomerMutationVariables>;

/**
 * __useRegisterCustomerMutation__
 *
 * To run a mutation, you first call `useRegisterCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerCustomerMutation, { data, loading, error }] = useRegisterCustomerMutation({
 *   variables: {
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useRegisterCustomerMutation (baseOptions?: Apollo.MutationHookOptions<RegisterCustomerMutation, RegisterCustomerMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<RegisterCustomerMutation, RegisterCustomerMutationVariables>(RegisterCustomerDocument, options)
}
export type RegisterCustomerMutationHookResult = ReturnType<typeof useRegisterCustomerMutation>;
export type RegisterCustomerMutationResult = Apollo.MutationResult<RegisterCustomerMutation>;
export type RegisterCustomerMutationOptions = Apollo.BaseMutationOptions<RegisterCustomerMutation, RegisterCustomerMutationVariables>;
export const PossibleOrderCashbackDocument = gql`
    query PossibleOrderCashback($orderId: ID!) {
  possibleOrderCashback(order_id: $orderId) {
    total
    maxSaleAmount
    items {
      cashback
      product_id
    }
  }
}
    `

/**
 * __usePossibleOrderCashbackQuery__
 *
 * To run a query within a React component, call `usePossibleOrderCashbackQuery` and pass it any options that fit your needs.
 * When your component renders, `usePossibleOrderCashbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePossibleOrderCashbackQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function usePossibleOrderCashbackQuery (baseOptions: Apollo.QueryHookOptions<PossibleOrderCashbackQuery, PossibleOrderCashbackQueryVariables> & ({ variables: PossibleOrderCashbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<PossibleOrderCashbackQuery, PossibleOrderCashbackQueryVariables>(PossibleOrderCashbackDocument, options)
}
export function usePossibleOrderCashbackLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<PossibleOrderCashbackQuery, PossibleOrderCashbackQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<PossibleOrderCashbackQuery, PossibleOrderCashbackQueryVariables>(PossibleOrderCashbackDocument, options)
}
export function usePossibleOrderCashbackSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PossibleOrderCashbackQuery, PossibleOrderCashbackQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<PossibleOrderCashbackQuery, PossibleOrderCashbackQueryVariables>(PossibleOrderCashbackDocument, options)
}
export type PossibleOrderCashbackQueryHookResult = ReturnType<typeof usePossibleOrderCashbackQuery>;
export type PossibleOrderCashbackLazyQueryHookResult = ReturnType<typeof usePossibleOrderCashbackLazyQuery>;
export type PossibleOrderCashbackSuspenseQueryHookResult = ReturnType<typeof usePossibleOrderCashbackSuspenseQuery>;
export type PossibleOrderCashbackQueryResult = Apollo.QueryResult<PossibleOrderCashbackQuery, PossibleOrderCashbackQueryVariables>;
export const SingleOfflinePurchaseDocument = gql`
    query SingleOfflinePurchase($singleOfflinePurchaseId: ID!) {
  singleOfflinePurchase(id: $singleOfflinePurchaseId) {
    id
    total
    address
    comment
    assembled_total
    totalCashback
    totalDiscount
    positions {
      id
      xid
      barCode
      name
      count
      price
      basePrice
      discount
      total
      discounts {
        code
        name
        type
        positionId
        xid
        totalDiscount
        amount
        cardNumber
      }
      product {
        id
        xid
        name
        count
        min_count
        price
        oldPrice
        price_type
        count_multiplier
        max_amount
        weight_multiplier
        slug
        stock {
          amount
        }
        short_description
        preview {
          url
        }
        images {
          url
        }
      }
    }
    discounts {
      code
      name
      type
      positionId
      xid
      totalDiscount
      amount
      cardNumber
    }
  }
}
    `

/**
 * __useSingleOfflinePurchaseQuery__
 *
 * To run a query within a React component, call `useSingleOfflinePurchaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleOfflinePurchaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleOfflinePurchaseQuery({
 *   variables: {
 *      singleOfflinePurchaseId: // value for 'singleOfflinePurchaseId'
 *   },
 * });
 */
export function useSingleOfflinePurchaseQuery (baseOptions: Apollo.QueryHookOptions<SingleOfflinePurchaseQuery, SingleOfflinePurchaseQueryVariables> & ({ variables: SingleOfflinePurchaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<SingleOfflinePurchaseQuery, SingleOfflinePurchaseQueryVariables>(SingleOfflinePurchaseDocument, options)
}
export function useSingleOfflinePurchaseLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<SingleOfflinePurchaseQuery, SingleOfflinePurchaseQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<SingleOfflinePurchaseQuery, SingleOfflinePurchaseQueryVariables>(SingleOfflinePurchaseDocument, options)
}
export function useSingleOfflinePurchaseSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SingleOfflinePurchaseQuery, SingleOfflinePurchaseQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<SingleOfflinePurchaseQuery, SingleOfflinePurchaseQueryVariables>(SingleOfflinePurchaseDocument, options)
}
export type SingleOfflinePurchaseQueryHookResult = ReturnType<typeof useSingleOfflinePurchaseQuery>;
export type SingleOfflinePurchaseLazyQueryHookResult = ReturnType<typeof useSingleOfflinePurchaseLazyQuery>;
export type SingleOfflinePurchaseSuspenseQueryHookResult = ReturnType<typeof useSingleOfflinePurchaseSuspenseQuery>;
export type SingleOfflinePurchaseQueryResult = Apollo.QueryResult<SingleOfflinePurchaseQuery, SingleOfflinePurchaseQueryVariables>;
export const ProductDocument = gql`
    query Product($style: String, $galleryImagesStyle: String, $previewStyle2: String, $fullPreviewStyle: String, $marketingLabelsStyle: String, $reviewImagesStyle: String, $shopId: ID, $productId: ID, $slug: String) {
  product(shop_id: $shopId, id: $productId, slug: $slug) {
    id
    xid
    name
    price
    oldPrice
    ...ProductPriceOffersFields
    ...ProductPriceOfferFields
    categories {
      id
      slug
      parent_id
      name
    }
    price_type
    count_multiplier
    brand {
      name
      id
    }
    slug
    stock {
      amount
    }
    pkg
    short_description
    images(style: $style) {
      url
    }
    galleryImages: images(style: $galleryImagesStyle) {
      url
    }
    ingredients
    productProperties {
      fats
      proteins
      calories
      carbohydrate
      shelfLife
      manufacturerName
      country
    }
    isWeightProduct
    marketingLabels {
      id
      title
      description
      image(style: "600xauto") {
        url
      }
      activeFrom
      activeUntil
      optionColor
      optionBackgroundColor
      optionLink
      optionLinkLabel
    }
    preview(style: $previewStyle2) {
      url
    }
    fullPreview: preview(style: $fullPreviewStyle) {
      url
    }
    average_rating
    review_count
    canBeReviewed
    productReview {
      id
      created_at
      status
      customer_id
      customer {
        id
        first_name
        maskedLastName
      }
      product_id
      rating
      comment
      images(style: $reviewImagesStyle) {
        url
      }
    }
    isFavorite
    is_alcohol
    min_age
    attributes {
      name
      value
    }
  }
}
    ${ProductPriceOffersFieldsFragmentDoc}
${ProductPriceOfferFieldsFragmentDoc}`

/**
 * __useProductQuery__
 *
 * To run a query within a React component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuery({
 *   variables: {
 *      style: // value for 'style'
 *      galleryImagesStyle: // value for 'galleryImagesStyle'
 *      previewStyle2: // value for 'previewStyle2'
 *      fullPreviewStyle: // value for 'fullPreviewStyle'
 *      marketingLabelsStyle: // value for 'marketingLabelsStyle'
 *      reviewImagesStyle: // value for 'reviewImagesStyle'
 *      shopId: // value for 'shopId'
 *      productId: // value for 'productId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useProductQuery (baseOptions?: Apollo.QueryHookOptions<ProductQuery, ProductQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options)
}
export function useProductLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<ProductQuery, ProductQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options)
}
export function useProductSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductQuery, ProductQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options)
}
export type ProductQueryHookResult = ReturnType<typeof useProductQuery>;
export type ProductLazyQueryHookResult = ReturnType<typeof useProductLazyQuery>;
export type ProductSuspenseQueryHookResult = ReturnType<typeof useProductSuspenseQuery>;
export type ProductQueryResult = Apollo.QueryResult<ProductQuery, ProductQueryVariables>;
export const ProductFiltersDocument = gql`
    query ProductFilters($shopId: ID, $categoryId: ID) {
  productFilters(shop_id: $shopId, category_id: $categoryId) {
    id
    label
    type
    filterInputFieldName
    op
    values {
      value
      gid
      name
    }
  }
}
    `

/**
 * __useProductFiltersQuery__
 *
 * To run a query within a React component, call `useProductFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFiltersQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useProductFiltersQuery (baseOptions?: Apollo.QueryHookOptions<ProductFiltersQuery, ProductFiltersQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<ProductFiltersQuery, ProductFiltersQueryVariables>(ProductFiltersDocument, options)
}
export function useProductFiltersLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<ProductFiltersQuery, ProductFiltersQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<ProductFiltersQuery, ProductFiltersQueryVariables>(ProductFiltersDocument, options)
}
export function useProductFiltersSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductFiltersQuery, ProductFiltersQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<ProductFiltersQuery, ProductFiltersQueryVariables>(ProductFiltersDocument, options)
}
export type ProductFiltersQueryHookResult = ReturnType<typeof useProductFiltersQuery>;
export type ProductFiltersLazyQueryHookResult = ReturnType<typeof useProductFiltersLazyQuery>;
export type ProductFiltersSuspenseQueryHookResult = ReturnType<typeof useProductFiltersSuspenseQuery>;
export type ProductFiltersQueryResult = Apollo.QueryResult<ProductFiltersQuery, ProductFiltersQueryVariables>;
export const PopularProductsDocument = gql`
    query PopularProducts($shopId: ID!, $pager: CommonPagerInput, $style: String) {
  popularProducts(shop_id: $shopId, pager: $pager) {
    edges {
      ...ProductWithOffer
    }
    pageInfo {
      ...PageInfoFields
    }
  }
}
    ${ProductWithOfferFragmentDoc}
${PageInfoFieldsFragmentDoc}`

/**
 * __usePopularProductsQuery__
 *
 * To run a query within a React component, call `usePopularProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopularProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopularProductsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      pager: // value for 'pager'
 *      style: // value for 'style'
 *   },
 * });
 */
export function usePopularProductsQuery (baseOptions: Apollo.QueryHookOptions<PopularProductsQuery, PopularProductsQueryVariables> & ({ variables: PopularProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<PopularProductsQuery, PopularProductsQueryVariables>(PopularProductsDocument, options)
}
export function usePopularProductsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<PopularProductsQuery, PopularProductsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<PopularProductsQuery, PopularProductsQueryVariables>(PopularProductsDocument, options)
}
export function usePopularProductsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PopularProductsQuery, PopularProductsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<PopularProductsQuery, PopularProductsQueryVariables>(PopularProductsDocument, options)
}
export type PopularProductsQueryHookResult = ReturnType<typeof usePopularProductsQuery>;
export type PopularProductsLazyQueryHookResult = ReturnType<typeof usePopularProductsLazyQuery>;
export type PopularProductsSuspenseQueryHookResult = ReturnType<typeof usePopularProductsSuspenseQuery>;
export type PopularProductsQueryResult = Apollo.QueryResult<PopularProductsQuery, PopularProductsQueryVariables>;
export const PreviouslyOrderedProductsDocument = gql`
    query previouslyOrderedProducts($shopId: ID!, $style: String, $pager: CommonPagerInput) {
  previouslyOrderedProducts(shop_id: $shopId, pager: $pager) {
    edges {
      ...ProductWithOffer
    }
    pageInfo {
      ...PageInfoFields
    }
  }
}
    ${ProductWithOfferFragmentDoc}
${PageInfoFieldsFragmentDoc}`

/**
 * __usePreviouslyOrderedProductsQuery__
 *
 * To run a query within a React component, call `usePreviouslyOrderedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviouslyOrderedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviouslyOrderedProductsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      style: // value for 'style'
 *      pager: // value for 'pager'
 *   },
 * });
 */
export function usePreviouslyOrderedProductsQuery (baseOptions: Apollo.QueryHookOptions<PreviouslyOrderedProductsQuery, PreviouslyOrderedProductsQueryVariables> & ({ variables: PreviouslyOrderedProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<PreviouslyOrderedProductsQuery, PreviouslyOrderedProductsQueryVariables>(PreviouslyOrderedProductsDocument, options)
}
export function usePreviouslyOrderedProductsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<PreviouslyOrderedProductsQuery, PreviouslyOrderedProductsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<PreviouslyOrderedProductsQuery, PreviouslyOrderedProductsQueryVariables>(PreviouslyOrderedProductsDocument, options)
}
export function usePreviouslyOrderedProductsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviouslyOrderedProductsQuery, PreviouslyOrderedProductsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<PreviouslyOrderedProductsQuery, PreviouslyOrderedProductsQueryVariables>(PreviouslyOrderedProductsDocument, options)
}
export type PreviouslyOrderedProductsQueryHookResult = ReturnType<typeof usePreviouslyOrderedProductsQuery>;
export type PreviouslyOrderedProductsLazyQueryHookResult = ReturnType<typeof usePreviouslyOrderedProductsLazyQuery>;
export type PreviouslyOrderedProductsSuspenseQueryHookResult = ReturnType<typeof usePreviouslyOrderedProductsSuspenseQuery>;
export type PreviouslyOrderedProductsQueryResult = Apollo.QueryResult<PreviouslyOrderedProductsQuery, PreviouslyOrderedProductsQueryVariables>;
export const AllProductsPreviewCardDocument = gql`
    query AllProductsPreviewCard($shopId: ID!, $pager: CommonPagerInput, $sort: CommonSortInput, $filter: NestedFilterInput) {
  allProducts(shop_id: $shopId, pager: $pager, sort: $sort, filter: $filter) {
    edges {
      ...ProductWithOffer
    }
    pageInfo {
      ...PageInfoFields
    }
  }
}
    ${ProductWithOfferFragmentDoc}
${PageInfoFieldsFragmentDoc}`

/**
 * __useAllProductsPreviewCardQuery__
 *
 * To run a query within a React component, call `useAllProductsPreviewCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProductsPreviewCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProductsPreviewCardQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      pager: // value for 'pager'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllProductsPreviewCardQuery (baseOptions: Apollo.QueryHookOptions<AllProductsPreviewCardQuery, AllProductsPreviewCardQueryVariables> & ({ variables: AllProductsPreviewCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<AllProductsPreviewCardQuery, AllProductsPreviewCardQueryVariables>(AllProductsPreviewCardDocument, options)
}
export function useAllProductsPreviewCardLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<AllProductsPreviewCardQuery, AllProductsPreviewCardQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<AllProductsPreviewCardQuery, AllProductsPreviewCardQueryVariables>(AllProductsPreviewCardDocument, options)
}
export function useAllProductsPreviewCardSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllProductsPreviewCardQuery, AllProductsPreviewCardQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<AllProductsPreviewCardQuery, AllProductsPreviewCardQueryVariables>(AllProductsPreviewCardDocument, options)
}
export type AllProductsPreviewCardQueryHookResult = ReturnType<typeof useAllProductsPreviewCardQuery>;
export type AllProductsPreviewCardLazyQueryHookResult = ReturnType<typeof useAllProductsPreviewCardLazyQuery>;
export type AllProductsPreviewCardSuspenseQueryHookResult = ReturnType<typeof useAllProductsPreviewCardSuspenseQuery>;
export type AllProductsPreviewCardQueryResult = Apollo.QueryResult<AllProductsPreviewCardQuery, AllProductsPreviewCardQueryVariables>;
export const ProductsPreviewCardDocument = gql`
    query ProductsPreviewCard($shopId: ID!, $style: String, $pager: CommonPagerInput, $categoryId: ID, $sort: CommonSortInput, $filter: NestedFilterInput) {
  products(
    shop_id: $shopId
    pager: $pager
    category_id: $categoryId
    sort: $sort
    filter: $filter
  ) {
    edges {
      ...ProductWithOffer
    }
    pageInfo {
      ...PageInfoFields
    }
  }
}
    ${ProductWithOfferFragmentDoc}
${PageInfoFieldsFragmentDoc}`

/**
 * __useProductsPreviewCardQuery__
 *
 * To run a query within a React component, call `useProductsPreviewCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsPreviewCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsPreviewCardQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      style: // value for 'style'
 *      pager: // value for 'pager'
 *      categoryId: // value for 'categoryId'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProductsPreviewCardQuery (baseOptions: Apollo.QueryHookOptions<ProductsPreviewCardQuery, ProductsPreviewCardQueryVariables> & ({ variables: ProductsPreviewCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<ProductsPreviewCardQuery, ProductsPreviewCardQueryVariables>(ProductsPreviewCardDocument, options)
}
export function useProductsPreviewCardLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<ProductsPreviewCardQuery, ProductsPreviewCardQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<ProductsPreviewCardQuery, ProductsPreviewCardQueryVariables>(ProductsPreviewCardDocument, options)
}
export function useProductsPreviewCardSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductsPreviewCardQuery, ProductsPreviewCardQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<ProductsPreviewCardQuery, ProductsPreviewCardQueryVariables>(ProductsPreviewCardDocument, options)
}
export type ProductsPreviewCardQueryHookResult = ReturnType<typeof useProductsPreviewCardQuery>;
export type ProductsPreviewCardLazyQueryHookResult = ReturnType<typeof useProductsPreviewCardLazyQuery>;
export type ProductsPreviewCardSuspenseQueryHookResult = ReturnType<typeof useProductsPreviewCardSuspenseQuery>;
export type ProductsPreviewCardQueryResult = Apollo.QueryResult<ProductsPreviewCardQuery, ProductsPreviewCardQueryVariables>;
export const SaleProductsDocument = gql`
    query SaleProducts($shopId: ID!, $style: String, $pager: CommonPagerInput) {
  saleProducts(shop_id: $shopId, pager: $pager) {
    edges {
      ...ProductWithOffer
    }
    pageInfo {
      ...PageInfoFields
    }
  }
}
    ${ProductWithOfferFragmentDoc}
${PageInfoFieldsFragmentDoc}`

/**
 * __useSaleProductsQuery__
 *
 * To run a query within a React component, call `useSaleProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaleProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaleProductsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      style: // value for 'style'
 *      pager: // value for 'pager'
 *   },
 * });
 */
export function useSaleProductsQuery (baseOptions: Apollo.QueryHookOptions<SaleProductsQuery, SaleProductsQueryVariables> & ({ variables: SaleProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<SaleProductsQuery, SaleProductsQueryVariables>(SaleProductsDocument, options)
}
export function useSaleProductsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<SaleProductsQuery, SaleProductsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<SaleProductsQuery, SaleProductsQueryVariables>(SaleProductsDocument, options)
}
export function useSaleProductsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SaleProductsQuery, SaleProductsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<SaleProductsQuery, SaleProductsQueryVariables>(SaleProductsDocument, options)
}
export type SaleProductsQueryHookResult = ReturnType<typeof useSaleProductsQuery>;
export type SaleProductsLazyQueryHookResult = ReturnType<typeof useSaleProductsLazyQuery>;
export type SaleProductsSuspenseQueryHookResult = ReturnType<typeof useSaleProductsSuspenseQuery>;
export type SaleProductsQueryResult = Apollo.QueryResult<SaleProductsQuery, SaleProductsQueryVariables>;
export const SimilarProductsDocument = gql`
    query SimilarProducts($shopId: ID!, $productId: ID!, $style: String) {
  similarProducts(shop_id: $shopId, product_id: $productId) {
    ...ProductWithOffer
  }
}
    ${ProductWithOfferFragmentDoc}`

/**
 * __useSimilarProductsQuery__
 *
 * To run a query within a React component, call `useSimilarProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimilarProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimilarProductsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      productId: // value for 'productId'
 *      style: // value for 'style'
 *   },
 * });
 */
export function useSimilarProductsQuery (baseOptions: Apollo.QueryHookOptions<SimilarProductsQuery, SimilarProductsQueryVariables> & ({ variables: SimilarProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<SimilarProductsQuery, SimilarProductsQueryVariables>(SimilarProductsDocument, options)
}
export function useSimilarProductsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<SimilarProductsQuery, SimilarProductsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<SimilarProductsQuery, SimilarProductsQueryVariables>(SimilarProductsDocument, options)
}
export function useSimilarProductsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SimilarProductsQuery, SimilarProductsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<SimilarProductsQuery, SimilarProductsQueryVariables>(SimilarProductsDocument, options)
}
export type SimilarProductsQueryHookResult = ReturnType<typeof useSimilarProductsQuery>;
export type SimilarProductsLazyQueryHookResult = ReturnType<typeof useSimilarProductsLazyQuery>;
export type SimilarProductsSuspenseQueryHookResult = ReturnType<typeof useSimilarProductsSuspenseQuery>;
export type SimilarProductsQueryResult = Apollo.QueryResult<SimilarProductsQuery, SimilarProductsQueryVariables>;
export const SingleProductGroupDocument = gql`
    query SingleProductGroup($id: ID!, $shop_id: ID!) {
  singleProductGroup(id: $id, shop_id: $shop_id) {
    id
    created_at
    updated_at
    label
    type
    brand_id
    customer_id
  }
}
    `

/**
 * __useSingleProductGroupQuery__
 *
 * To run a query within a React component, call `useSingleProductGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleProductGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleProductGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *      shop_id: // value for 'shop_id'
 *      style: // value for 'style'
 *   },
 * });
 */
export function useSingleProductGroupQuery (baseOptions: Apollo.QueryHookOptions<SingleProductGroupQuery, SingleProductGroupQueryVariables> & ({ variables: SingleProductGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<SingleProductGroupQuery, SingleProductGroupQueryVariables>(SingleProductGroupDocument, options)
}
export function useSingleProductGroupLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<SingleProductGroupQuery, SingleProductGroupQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<SingleProductGroupQuery, SingleProductGroupQueryVariables>(SingleProductGroupDocument, options)
}
export function useSingleProductGroupSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SingleProductGroupQuery, SingleProductGroupQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<SingleProductGroupQuery, SingleProductGroupQueryVariables>(SingleProductGroupDocument, options)
}
export type SingleProductGroupQueryHookResult = ReturnType<typeof useSingleProductGroupQuery>;
export type SingleProductGroupLazyQueryHookResult = ReturnType<typeof useSingleProductGroupLazyQuery>;
export type SingleProductGroupSuspenseQueryHookResult = ReturnType<typeof useSingleProductGroupSuspenseQuery>;
export type SingleProductGroupQueryResult = Apollo.QueryResult<SingleProductGroupQuery, SingleProductGroupQueryVariables>;
export const SaveProductReviewDocument = gql`
    mutation SaveProductReview($newData: ProductReviewInput, $upsert: Boolean) {
  saveProductReview(newData: $newData, upsert: $upsert) {
    id
    created_at
    status
    customer_id
    product_id
    rating
    comment
    images {
      url
    }
  }
}
    `
export type SaveProductReviewMutationFn = Apollo.MutationFunction<SaveProductReviewMutation, SaveProductReviewMutationVariables>;

/**
 * __useSaveProductReviewMutation__
 *
 * To run a mutation, you first call `useSaveProductReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProductReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProductReviewMutation, { data, loading, error }] = useSaveProductReviewMutation({
 *   variables: {
 *      newData: // value for 'newData'
 *      upsert: // value for 'upsert'
 *   },
 * });
 */
export function useSaveProductReviewMutation (baseOptions?: Apollo.MutationHookOptions<SaveProductReviewMutation, SaveProductReviewMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<SaveProductReviewMutation, SaveProductReviewMutationVariables>(SaveProductReviewDocument, options)
}
export type SaveProductReviewMutationHookResult = ReturnType<typeof useSaveProductReviewMutation>;
export type SaveProductReviewMutationResult = Apollo.MutationResult<SaveProductReviewMutation>;
export type SaveProductReviewMutationOptions = Apollo.BaseMutationOptions<SaveProductReviewMutation, SaveProductReviewMutationVariables>;
export const ZonesForGeoPointDocument = gql`
    query ZonesForGeoPoint($point: GeoPointInput!, $customerType: String) {
  zonesForGeoPoint(point: $point, customerType: $customerType) {
    name
    id
    geo_delivery_zone
    shop_id
    status
    minOrderCost
    min_price
    shop {
      id
      name
      firstAvailableSlot {
        id
        slotTime
        slotDate
      }
    }
    delivery_cost
    first_delivery_cost
    zoneGeoDeliveryZone {
      longitude
      latitude
    }
    freeSlotDeliveryCostFrom
    firstAvailableSlot {
      id
      shop {
        id
        name
        address
      }
      slotTime
      slotDate
      period {
        to
        from
      }
      shop_id
      availableUntil
      zone_id
    }
    tzOffset
  }
}
    `

/**
 * __useZonesForGeoPointQuery__
 *
 * To run a query within a React component, call `useZonesForGeoPointQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesForGeoPointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesForGeoPointQuery({
 *   variables: {
 *      point: // value for 'point'
 *      customerType: // value for 'customerType'
 *   },
 * });
 */
export function useZonesForGeoPointQuery (baseOptions: Apollo.QueryHookOptions<ZonesForGeoPointQuery, ZonesForGeoPointQueryVariables> & ({ variables: ZonesForGeoPointQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<ZonesForGeoPointQuery, ZonesForGeoPointQueryVariables>(ZonesForGeoPointDocument, options)
}
export function useZonesForGeoPointLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<ZonesForGeoPointQuery, ZonesForGeoPointQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<ZonesForGeoPointQuery, ZonesForGeoPointQueryVariables>(ZonesForGeoPointDocument, options)
}
export function useZonesForGeoPointSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZonesForGeoPointQuery, ZonesForGeoPointQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<ZonesForGeoPointQuery, ZonesForGeoPointQueryVariables>(ZonesForGeoPointDocument, options)
}
export type ZonesForGeoPointQueryHookResult = ReturnType<typeof useZonesForGeoPointQuery>;
export type ZonesForGeoPointLazyQueryHookResult = ReturnType<typeof useZonesForGeoPointLazyQuery>;
export type ZonesForGeoPointSuspenseQueryHookResult = ReturnType<typeof useZonesForGeoPointSuspenseQuery>;
export type ZonesForGeoPointQueryResult = Apollo.QueryResult<ZonesForGeoPointQuery, ZonesForGeoPointQueryVariables>;
export const AllMarketingStoriesDocument = gql`
    query allMarketingStories($style: String, $imageStyle2: String) {
  allMarketingStories {
    edges {
      id
      name
      preview(style: $style) {
        url
      }
      slides {
        id
        name
        image(style: $imageStyle2) {
          url
        }
        url
        optionOpenInBrowser
        optionOpenInNewWindow
        optionUrl
      }
    }
  }
}
    `

/**
 * __useAllMarketingStoriesQuery__
 *
 * To run a query within a React component, call `useAllMarketingStoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMarketingStoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMarketingStoriesQuery({
 *   variables: {
 *      style: // value for 'style'
 *      imageStyle2: // value for 'imageStyle2'
 *   },
 * });
 */
export function useAllMarketingStoriesQuery (baseOptions?: Apollo.QueryHookOptions<AllMarketingStoriesQuery, AllMarketingStoriesQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<AllMarketingStoriesQuery, AllMarketingStoriesQueryVariables>(AllMarketingStoriesDocument, options)
}
export function useAllMarketingStoriesLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<AllMarketingStoriesQuery, AllMarketingStoriesQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<AllMarketingStoriesQuery, AllMarketingStoriesQueryVariables>(AllMarketingStoriesDocument, options)
}
export function useAllMarketingStoriesSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllMarketingStoriesQuery, AllMarketingStoriesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<AllMarketingStoriesQuery, AllMarketingStoriesQueryVariables>(AllMarketingStoriesDocument, options)
}
export type AllMarketingStoriesQueryHookResult = ReturnType<typeof useAllMarketingStoriesQuery>;
export type AllMarketingStoriesLazyQueryHookResult = ReturnType<typeof useAllMarketingStoriesLazyQuery>;
export type AllMarketingStoriesSuspenseQueryHookResult = ReturnType<typeof useAllMarketingStoriesSuspenseQuery>;
export type AllMarketingStoriesQueryResult = Apollo.QueryResult<AllMarketingStoriesQuery, AllMarketingStoriesQueryVariables>;
export const CheckIsEmailUsedDocument = gql`
    mutation CheckIsEmailUsed($email: String!) {
  checkIsEmailUsed(email: $email)
}
    `
export type CheckIsEmailUsedMutationFn = Apollo.MutationFunction<CheckIsEmailUsedMutation, CheckIsEmailUsedMutationVariables>;

/**
 * __useCheckIsEmailUsedMutation__
 *
 * To run a mutation, you first call `useCheckIsEmailUsedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckIsEmailUsedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkIsEmailUsedMutation, { data, loading, error }] = useCheckIsEmailUsedMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCheckIsEmailUsedMutation (baseOptions?: Apollo.MutationHookOptions<CheckIsEmailUsedMutation, CheckIsEmailUsedMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CheckIsEmailUsedMutation, CheckIsEmailUsedMutationVariables>(CheckIsEmailUsedDocument, options)
}
export type CheckIsEmailUsedMutationHookResult = ReturnType<typeof useCheckIsEmailUsedMutation>;
export type CheckIsEmailUsedMutationResult = Apollo.MutationResult<CheckIsEmailUsedMutation>;
export type CheckIsEmailUsedMutationOptions = Apollo.BaseMutationOptions<CheckIsEmailUsedMutation, CheckIsEmailUsedMutationVariables>;
export const UpdateCustomerDocument = gql`
    mutation UpdateCustomer($answers: [CustomerProfileFieldInput]) {
  updateCustomer(answers: $answers)
}
    `
export type UpdateCustomerMutationFn = Apollo.MutationFunction<UpdateCustomerMutation, UpdateCustomerMutationVariables>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useUpdateCustomerMutation (baseOptions?: Apollo.MutationHookOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument, options)
}
export type UpdateCustomerMutationHookResult = ReturnType<typeof useUpdateCustomerMutation>;
export type UpdateCustomerMutationResult = Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const AuthBySmsCodeDocument = gql`
    mutation AuthBySmsCode($authBySmsCodeId: ID!, $smsCode: String!) {
  authBySmsCode(id: $authBySmsCodeId, smsCode: $smsCode) {
    status
    id
  }
}
    `
export type AuthBySmsCodeMutationFn = Apollo.MutationFunction<AuthBySmsCodeMutation, AuthBySmsCodeMutationVariables>;

/**
 * __useAuthBySmsCodeMutation__
 *
 * To run a mutation, you first call `useAuthBySmsCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthBySmsCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authBySmsCodeMutation, { data, loading, error }] = useAuthBySmsCodeMutation({
 *   variables: {
 *      authBySmsCodeId: // value for 'authBySmsCodeId'
 *      smsCode: // value for 'smsCode'
 *   },
 * });
 */
export function useAuthBySmsCodeMutation (baseOptions?: Apollo.MutationHookOptions<AuthBySmsCodeMutation, AuthBySmsCodeMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<AuthBySmsCodeMutation, AuthBySmsCodeMutationVariables>(AuthBySmsCodeDocument, options)
}
export type AuthBySmsCodeMutationHookResult = ReturnType<typeof useAuthBySmsCodeMutation>;
export type AuthBySmsCodeMutationResult = Apollo.MutationResult<AuthBySmsCodeMutation>;
export type AuthBySmsCodeMutationOptions = Apollo.BaseMutationOptions<AuthBySmsCodeMutation, AuthBySmsCodeMutationVariables>;
export const PingAuthDocument = gql`
    query PingAuth {
  pingAuth {
    id
    phone
    first_name
    last_name
    birthday
    new_phone
    status
    receipt_email
    secondsBeforeDeletion
    requireRegistration
  }
}
    `

/**
 * __usePingAuthQuery__
 *
 * To run a query within a React component, call `usePingAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `usePingAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePingAuthQuery({
 *   variables: {
 *   },
 * });
 */
export function usePingAuthQuery (baseOptions?: Apollo.QueryHookOptions<PingAuthQuery, PingAuthQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<PingAuthQuery, PingAuthQueryVariables>(PingAuthDocument, options)
}
export function usePingAuthLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<PingAuthQuery, PingAuthQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<PingAuthQuery, PingAuthQueryVariables>(PingAuthDocument, options)
}
export function usePingAuthSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PingAuthQuery, PingAuthQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<PingAuthQuery, PingAuthQueryVariables>(PingAuthDocument, options)
}
export type PingAuthQueryHookResult = ReturnType<typeof usePingAuthQuery>;
export type PingAuthLazyQueryHookResult = ReturnType<typeof usePingAuthLazyQuery>;
export type PingAuthSuspenseQueryHookResult = ReturnType<typeof usePingAuthSuspenseQuery>;
export type PingAuthQueryResult = Apollo.QueryResult<PingAuthQuery, PingAuthQueryVariables>;
export const LoginOrRegisterDocument = gql`
    mutation LoginOrRegister($phone: String!, $token: String!) {
  loginOrRegister(phone: $phone, token: $token) {
    timeout
    sent
    id
    error
  }
}
    `
export type LoginOrRegisterMutationFn = Apollo.MutationFunction<LoginOrRegisterMutation, LoginOrRegisterMutationVariables>;

/**
 * __useLoginOrRegisterMutation__
 *
 * To run a mutation, you first call `useLoginOrRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginOrRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginOrRegisterMutation, { data, loading, error }] = useLoginOrRegisterMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useLoginOrRegisterMutation (baseOptions?: Apollo.MutationHookOptions<LoginOrRegisterMutation, LoginOrRegisterMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<LoginOrRegisterMutation, LoginOrRegisterMutationVariables>(LoginOrRegisterDocument, options)
}
export type LoginOrRegisterMutationHookResult = ReturnType<typeof useLoginOrRegisterMutation>;
export type LoginOrRegisterMutationResult = Apollo.MutationResult<LoginOrRegisterMutation>;
export type LoginOrRegisterMutationOptions = Apollo.BaseMutationOptions<LoginOrRegisterMutation, LoginOrRegisterMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation (baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options)
}
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const RequestNewSmsDocument = gql`
    mutation RequestNewSms($requestNewSmsId: ID!) {
  requestNewSms(id: $requestNewSmsId) {
    id
    timeout
    sent
    error
  }
}
    `
export type RequestNewSmsMutationFn = Apollo.MutationFunction<RequestNewSmsMutation, RequestNewSmsMutationVariables>;

/**
 * __useRequestNewSmsMutation__
 *
 * To run a mutation, you first call `useRequestNewSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestNewSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestNewSmsMutation, { data, loading, error }] = useRequestNewSmsMutation({
 *   variables: {
 *      requestNewSmsId: // value for 'requestNewSmsId'
 *   },
 * });
 */
export function useRequestNewSmsMutation (baseOptions?: Apollo.MutationHookOptions<RequestNewSmsMutation, RequestNewSmsMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<RequestNewSmsMutation, RequestNewSmsMutationVariables>(RequestNewSmsDocument, options)
}
export type RequestNewSmsMutationHookResult = ReturnType<typeof useRequestNewSmsMutation>;
export type RequestNewSmsMutationResult = Apollo.MutationResult<RequestNewSmsMutation>;
export type RequestNewSmsMutationOptions = Apollo.BaseMutationOptions<RequestNewSmsMutation, RequestNewSmsMutationVariables>;
export const CartInfoDocument = gql`
    query CartInfo($cartInfo: CartInfoInput!, $style: String, $imageStyle2: String, $imagesStyle2: String, $previewStyle2: String) {
  cartInfo(cartInfo: $cartInfo) {
    totalWeight
    promocode
    promocodeType
    priceGroup
    totals {
      count
      baseTotal
      total
      baseSale
      sale
      salePercent
      effectiveTotal
      maxSale
    }
    delivery {
      total
      sale
      effectiveTotal
      promoPercent
    }
    saleErrors {
      internalCode
      internalIssuer
      type
      message
      inputPart {
        promocodes {
          code
        }
      }
    }
    products {
      id
      amount
      shop_id
      comment
      info {
        ...ProductWithOffer
      }
    }
    saleAddedPositions {
      id
      productId
      positionKey
      amount
      price
      total
      info {
        ...ProductWithOffer
      }
    }
  }
}
    ${ProductWithOfferFragmentDoc}`

/**
 * __useCartInfoQuery__
 *
 * To run a query within a React component, call `useCartInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartInfoQuery({
 *   variables: {
 *      cartInfo: // value for 'cartInfo'
 *      style: // value for 'style'
 *      imageStyle2: // value for 'imageStyle2'
 *      imagesStyle2: // value for 'imagesStyle2'
 *      previewStyle2: // value for 'previewStyle2'
 *   },
 * });
 */
export function useCartInfoQuery (baseOptions: Apollo.QueryHookOptions<CartInfoQuery, CartInfoQueryVariables> & ({ variables: CartInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<CartInfoQuery, CartInfoQueryVariables>(CartInfoDocument, options)
}
export function useCartInfoLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<CartInfoQuery, CartInfoQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<CartInfoQuery, CartInfoQueryVariables>(CartInfoDocument, options)
}
export function useCartInfoSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CartInfoQuery, CartInfoQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<CartInfoQuery, CartInfoQueryVariables>(CartInfoDocument, options)
}
export type CartInfoQueryHookResult = ReturnType<typeof useCartInfoQuery>;
export type CartInfoLazyQueryHookResult = ReturnType<typeof useCartInfoLazyQuery>;
export type CartInfoSuspenseQueryHookResult = ReturnType<typeof useCartInfoSuspenseQuery>;
export type CartInfoQueryResult = Apollo.QueryResult<CartInfoQuery, CartInfoQueryVariables>;
export const CheckProductsInStockDocument = gql`
    query CheckProductsInStock($productData: StockProductInput!) {
  checkProductsInStock(productData: $productData) {
    error_code
    message
    max_amount
    productInfo {
      id
      name
    }
    product_id
  }
}
    `

/**
 * __useCheckProductsInStockQuery__
 *
 * To run a query within a React component, call `useCheckProductsInStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckProductsInStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckProductsInStockQuery({
 *   variables: {
 *      productData: // value for 'productData'
 *   },
 * });
 */
export function useCheckProductsInStockQuery (baseOptions: Apollo.QueryHookOptions<CheckProductsInStockQuery, CheckProductsInStockQueryVariables> & ({ variables: CheckProductsInStockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<CheckProductsInStockQuery, CheckProductsInStockQueryVariables>(CheckProductsInStockDocument, options)
}
export function useCheckProductsInStockLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<CheckProductsInStockQuery, CheckProductsInStockQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<CheckProductsInStockQuery, CheckProductsInStockQueryVariables>(CheckProductsInStockDocument, options)
}
export function useCheckProductsInStockSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckProductsInStockQuery, CheckProductsInStockQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<CheckProductsInStockQuery, CheckProductsInStockQueryVariables>(CheckProductsInStockDocument, options)
}
export type CheckProductsInStockQueryHookResult = ReturnType<typeof useCheckProductsInStockQuery>;
export type CheckProductsInStockLazyQueryHookResult = ReturnType<typeof useCheckProductsInStockLazyQuery>;
export type CheckProductsInStockSuspenseQueryHookResult = ReturnType<typeof useCheckProductsInStockSuspenseQuery>;
export type CheckProductsInStockQueryResult = Apollo.QueryResult<CheckProductsInStockQuery, CheckProductsInStockQueryVariables>;
export const ClearCartDocument = gql`
    mutation ClearCart($shopId: ID!) {
  clearCart(shop_id: $shopId)
}
    `
export type ClearCartMutationFn = Apollo.MutationFunction<ClearCartMutation, ClearCartMutationVariables>;

/**
 * __useClearCartMutation__
 *
 * To run a mutation, you first call `useClearCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearCartMutation, { data, loading, error }] = useClearCartMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useClearCartMutation (baseOptions?: Apollo.MutationHookOptions<ClearCartMutation, ClearCartMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ClearCartMutation, ClearCartMutationVariables>(ClearCartDocument, options)
}
export type ClearCartMutationHookResult = ReturnType<typeof useClearCartMutation>;
export type ClearCartMutationResult = Apollo.MutationResult<ClearCartMutation>;
export type ClearCartMutationOptions = Apollo.BaseMutationOptions<ClearCartMutation, ClearCartMutationVariables>;
export const DropCartItemDocument = gql`
    mutation DropCartItem($shopId: ID!, $productId: ID!) {
  dropCartItem(shop_id: $shopId, product_id: $productId)
}
    `
export type DropCartItemMutationFn = Apollo.MutationFunction<DropCartItemMutation, DropCartItemMutationVariables>;

/**
 * __useDropCartItemMutation__
 *
 * To run a mutation, you first call `useDropCartItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDropCartItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dropCartItemMutation, { data, loading, error }] = useDropCartItemMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useDropCartItemMutation (baseOptions?: Apollo.MutationHookOptions<DropCartItemMutation, DropCartItemMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DropCartItemMutation, DropCartItemMutationVariables>(DropCartItemDocument, options)
}
export type DropCartItemMutationHookResult = ReturnType<typeof useDropCartItemMutation>;
export type DropCartItemMutationResult = Apollo.MutationResult<DropCartItemMutation>;
export type DropCartItemMutationOptions = Apollo.BaseMutationOptions<DropCartItemMutation, DropCartItemMutationVariables>;
export const InitialSyncCartsDocument = gql`
    mutation InitialSyncCarts($carts: [CartInfoInput]!) {
  initialSyncCarts(carts: $carts) {
    id
    product_id
    amount
    shop_id
    delivery_cost
    usedPromocode
  }
}
    `
export type InitialSyncCartsMutationFn = Apollo.MutationFunction<InitialSyncCartsMutation, InitialSyncCartsMutationVariables>;

/**
 * __useInitialSyncCartsMutation__
 *
 * To run a mutation, you first call `useInitialSyncCartsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitialSyncCartsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initialSyncCartsMutation, { data, loading, error }] = useInitialSyncCartsMutation({
 *   variables: {
 *      carts: // value for 'carts'
 *   },
 * });
 */
export function useInitialSyncCartsMutation (baseOptions?: Apollo.MutationHookOptions<InitialSyncCartsMutation, InitialSyncCartsMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<InitialSyncCartsMutation, InitialSyncCartsMutationVariables>(InitialSyncCartsDocument, options)
}
export type InitialSyncCartsMutationHookResult = ReturnType<typeof useInitialSyncCartsMutation>;
export type InitialSyncCartsMutationResult = Apollo.MutationResult<InitialSyncCartsMutation>;
export type InitialSyncCartsMutationOptions = Apollo.BaseMutationOptions<InitialSyncCartsMutation, InitialSyncCartsMutationVariables>;
export const LoadCartsDocument = gql`
    query LoadCarts {
  loadCarts {
    shop_id
    items {
      product_id
      amount
      comment
      offer_id
    }
  }
}
    `

/**
 * __useLoadCartsQuery__
 *
 * To run a query within a React component, call `useLoadCartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadCartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadCartsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoadCartsQuery (baseOptions?: Apollo.QueryHookOptions<LoadCartsQuery, LoadCartsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<LoadCartsQuery, LoadCartsQueryVariables>(LoadCartsDocument, options)
}
export function useLoadCartsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<LoadCartsQuery, LoadCartsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<LoadCartsQuery, LoadCartsQueryVariables>(LoadCartsDocument, options)
}
export function useLoadCartsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoadCartsQuery, LoadCartsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<LoadCartsQuery, LoadCartsQueryVariables>(LoadCartsDocument, options)
}
export type LoadCartsQueryHookResult = ReturnType<typeof useLoadCartsQuery>;
export type LoadCartsLazyQueryHookResult = ReturnType<typeof useLoadCartsLazyQuery>;
export type LoadCartsSuspenseQueryHookResult = ReturnType<typeof useLoadCartsSuspenseQuery>;
export type LoadCartsQueryResult = Apollo.QueryResult<LoadCartsQuery, LoadCartsQueryVariables>;
export const SyncCartDocument = gql`
    mutation SyncCart($cart: CartInfoInput!) {
  syncCart(cart: $cart) {
    id
    product_id
    amount
    shop_id
    delivery_cost
    usedPromocode
  }
}
    `
export type SyncCartMutationFn = Apollo.MutationFunction<SyncCartMutation, SyncCartMutationVariables>;

/**
 * __useSyncCartMutation__
 *
 * To run a mutation, you first call `useSyncCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncCartMutation, { data, loading, error }] = useSyncCartMutation({
 *   variables: {
 *      cart: // value for 'cart'
 *   },
 * });
 */
export function useSyncCartMutation (baseOptions?: Apollo.MutationHookOptions<SyncCartMutation, SyncCartMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<SyncCartMutation, SyncCartMutationVariables>(SyncCartDocument, options)
}
export type SyncCartMutationHookResult = ReturnType<typeof useSyncCartMutation>;
export type SyncCartMutationResult = Apollo.MutationResult<SyncCartMutation>;
export type SyncCartMutationOptions = Apollo.BaseMutationOptions<SyncCartMutation, SyncCartMutationVariables>;
export const UpdateCartProductAmountDocument = gql`
    mutation UpdateCartProductAmount($itemData: CartDataInput!, $shopId: ID!) {
  updateCartProductAmount(itemData: $itemData, shop_id: $shopId) {
    product_id
    message
    max_amount
    productInfo {
      name
      id
    }
  }
}
    `
export type UpdateCartProductAmountMutationFn = Apollo.MutationFunction<UpdateCartProductAmountMutation, UpdateCartProductAmountMutationVariables>;

/**
 * __useUpdateCartProductAmountMutation__
 *
 * To run a mutation, you first call `useUpdateCartProductAmountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartProductAmountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartProductAmountMutation, { data, loading, error }] = useUpdateCartProductAmountMutation({
 *   variables: {
 *      itemData: // value for 'itemData'
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useUpdateCartProductAmountMutation (baseOptions?: Apollo.MutationHookOptions<UpdateCartProductAmountMutation, UpdateCartProductAmountMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateCartProductAmountMutation, UpdateCartProductAmountMutationVariables>(UpdateCartProductAmountDocument, options)
}
export type UpdateCartProductAmountMutationHookResult = ReturnType<typeof useUpdateCartProductAmountMutation>;
export type UpdateCartProductAmountMutationResult = Apollo.MutationResult<UpdateCartProductAmountMutation>;
export type UpdateCartProductAmountMutationOptions = Apollo.BaseMutationOptions<UpdateCartProductAmountMutation, UpdateCartProductAmountMutationVariables>;
export const SuggestionsDocument = gql`
    query Suggestions($address: String!) {
  getAddressSuggestions(address: $address) {
    suggestions {
      value
      unrestricted_value
      data {
        geo_lat
        geo_lon
      }
    }
  }
}
    `

/**
 * __useSuggestionsQuery__
 *
 * To run a query within a React component, call `useSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestionsQuery({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useSuggestionsQuery (baseOptions: Apollo.QueryHookOptions<SuggestionsQuery, SuggestionsQueryVariables> & ({ variables: SuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<SuggestionsQuery, SuggestionsQueryVariables>(SuggestionsDocument, options)
}
export function useSuggestionsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<SuggestionsQuery, SuggestionsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<SuggestionsQuery, SuggestionsQueryVariables>(SuggestionsDocument, options)
}
export function useSuggestionsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestionsQuery, SuggestionsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<SuggestionsQuery, SuggestionsQueryVariables>(SuggestionsDocument, options)
}
export type SuggestionsQueryHookResult = ReturnType<typeof useSuggestionsQuery>;
export type SuggestionsLazyQueryHookResult = ReturnType<typeof useSuggestionsLazyQuery>;
export type SuggestionsSuspenseQueryHookResult = ReturnType<typeof useSuggestionsSuspenseQuery>;
export type SuggestionsQueryResult = Apollo.QueryResult<SuggestionsQuery, SuggestionsQueryVariables>;
export const SearchForAddressSuggestionsDocument = gql`
    query SearchForAddressSuggestions($addressFilter: AddressSuggestionFilterInput!) {
  searchForAddressSuggestions(addressFilter: $addressFilter) {
    suggestions {
      value
      unrestricted_value
      data {
        geo_lat
        geo_lon
      }
    }
  }
}
    `

/**
 * __useSearchForAddressSuggestionsQuery__
 *
 * To run a query within a React component, call `useSearchForAddressSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchForAddressSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchForAddressSuggestionsQuery({
 *   variables: {
 *      addressFilter: // value for 'addressFilter'
 *   },
 * });
 */
export function useSearchForAddressSuggestionsQuery (baseOptions: Apollo.QueryHookOptions<SearchForAddressSuggestionsQuery, SearchForAddressSuggestionsQueryVariables> & ({ variables: SearchForAddressSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<SearchForAddressSuggestionsQuery, SearchForAddressSuggestionsQueryVariables>(SearchForAddressSuggestionsDocument, options)
}
export function useSearchForAddressSuggestionsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<SearchForAddressSuggestionsQuery, SearchForAddressSuggestionsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<SearchForAddressSuggestionsQuery, SearchForAddressSuggestionsQueryVariables>(SearchForAddressSuggestionsDocument, options)
}
export function useSearchForAddressSuggestionsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchForAddressSuggestionsQuery, SearchForAddressSuggestionsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<SearchForAddressSuggestionsQuery, SearchForAddressSuggestionsQueryVariables>(SearchForAddressSuggestionsDocument, options)
}
export type SearchForAddressSuggestionsQueryHookResult = ReturnType<typeof useSearchForAddressSuggestionsQuery>;
export type SearchForAddressSuggestionsLazyQueryHookResult = ReturnType<typeof useSearchForAddressSuggestionsLazyQuery>;
export type SearchForAddressSuggestionsSuspenseQueryHookResult = ReturnType<typeof useSearchForAddressSuggestionsSuspenseQuery>;
export type SearchForAddressSuggestionsQueryResult = Apollo.QueryResult<SearchForAddressSuggestionsQuery, SearchForAddressSuggestionsQueryVariables>;
export const AddFavoriteProductDocument = gql`
    mutation AddFavoriteProduct($productId: ID!) {
  addFavoriteProduct(product_id: $productId)
}
    `
export type AddFavoriteProductMutationFn = Apollo.MutationFunction<AddFavoriteProductMutation, AddFavoriteProductMutationVariables>;

/**
 * __useAddFavoriteProductMutation__
 *
 * To run a mutation, you first call `useAddFavoriteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoriteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoriteProductMutation, { data, loading, error }] = useAddFavoriteProductMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useAddFavoriteProductMutation (baseOptions?: Apollo.MutationHookOptions<AddFavoriteProductMutation, AddFavoriteProductMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<AddFavoriteProductMutation, AddFavoriteProductMutationVariables>(AddFavoriteProductDocument, options)
}
export type AddFavoriteProductMutationHookResult = ReturnType<typeof useAddFavoriteProductMutation>;
export type AddFavoriteProductMutationResult = Apollo.MutationResult<AddFavoriteProductMutation>;
export type AddFavoriteProductMutationOptions = Apollo.BaseMutationOptions<AddFavoriteProductMutation, AddFavoriteProductMutationVariables>;
export const FavoriteProductsDocument = gql`
    query FavoriteProducts($shopId: ID!, $pager: CommonPagerInput) {
  favoriteProducts(shop_id: $shopId, pager: $pager) {
    pageInfo {
      total
      next
      lastPage
      perPage
      page
    }
    edges {
      id
    }
  }
}
    `

/**
 * __useFavoriteProductsQuery__
 *
 * To run a query within a React component, call `useFavoriteProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoriteProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoriteProductsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      pager: // value for 'pager'
 *   },
 * });
 */
export function useFavoriteProductsQuery (baseOptions: Apollo.QueryHookOptions<FavoriteProductsQuery, FavoriteProductsQueryVariables> & ({ variables: FavoriteProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<FavoriteProductsQuery, FavoriteProductsQueryVariables>(FavoriteProductsDocument, options)
}
export function useFavoriteProductsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<FavoriteProductsQuery, FavoriteProductsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<FavoriteProductsQuery, FavoriteProductsQueryVariables>(FavoriteProductsDocument, options)
}
export function useFavoriteProductsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FavoriteProductsQuery, FavoriteProductsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<FavoriteProductsQuery, FavoriteProductsQueryVariables>(FavoriteProductsDocument, options)
}
export type FavoriteProductsQueryHookResult = ReturnType<typeof useFavoriteProductsQuery>;
export type FavoriteProductsLazyQueryHookResult = ReturnType<typeof useFavoriteProductsLazyQuery>;
export type FavoriteProductsSuspenseQueryHookResult = ReturnType<typeof useFavoriteProductsSuspenseQuery>;
export type FavoriteProductsQueryResult = Apollo.QueryResult<FavoriteProductsQuery, FavoriteProductsQueryVariables>;
export const FavoriteProductsCardsDocument = gql`
    query FavoriteProductsCards($shopId: ID!, $pager: CommonPagerInput, $style: String) {
  favoriteProducts(shop_id: $shopId, pager: $pager) {
    edges {
      ...ProductWithOffer
    }
    pageInfo {
      ...PageInfoFields
    }
  }
}
    ${ProductWithOfferFragmentDoc}
${PageInfoFieldsFragmentDoc}`

/**
 * __useFavoriteProductsCardsQuery__
 *
 * To run a query within a React component, call `useFavoriteProductsCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoriteProductsCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoriteProductsCardsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      pager: // value for 'pager'
 *      style: // value for 'style'
 *   },
 * });
 */
export function useFavoriteProductsCardsQuery (baseOptions: Apollo.QueryHookOptions<FavoriteProductsCardsQuery, FavoriteProductsCardsQueryVariables> & ({ variables: FavoriteProductsCardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<FavoriteProductsCardsQuery, FavoriteProductsCardsQueryVariables>(FavoriteProductsCardsDocument, options)
}
export function useFavoriteProductsCardsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<FavoriteProductsCardsQuery, FavoriteProductsCardsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<FavoriteProductsCardsQuery, FavoriteProductsCardsQueryVariables>(FavoriteProductsCardsDocument, options)
}
export function useFavoriteProductsCardsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FavoriteProductsCardsQuery, FavoriteProductsCardsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<FavoriteProductsCardsQuery, FavoriteProductsCardsQueryVariables>(FavoriteProductsCardsDocument, options)
}
export type FavoriteProductsCardsQueryHookResult = ReturnType<typeof useFavoriteProductsCardsQuery>;
export type FavoriteProductsCardsLazyQueryHookResult = ReturnType<typeof useFavoriteProductsCardsLazyQuery>;
export type FavoriteProductsCardsSuspenseQueryHookResult = ReturnType<typeof useFavoriteProductsCardsSuspenseQuery>;
export type FavoriteProductsCardsQueryResult = Apollo.QueryResult<FavoriteProductsCardsQuery, FavoriteProductsCardsQueryVariables>;
export const RemoveFavoriteProductDocument = gql`
    mutation RemoveFavoriteProduct($productId: ID!) {
  removeFavoriteProduct(product_id: $productId)
}
    `
export type RemoveFavoriteProductMutationFn = Apollo.MutationFunction<RemoveFavoriteProductMutation, RemoveFavoriteProductMutationVariables>;

/**
 * __useRemoveFavoriteProductMutation__
 *
 * To run a mutation, you first call `useRemoveFavoriteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFavoriteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFavoriteProductMutation, { data, loading, error }] = useRemoveFavoriteProductMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useRemoveFavoriteProductMutation (baseOptions?: Apollo.MutationHookOptions<RemoveFavoriteProductMutation, RemoveFavoriteProductMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<RemoveFavoriteProductMutation, RemoveFavoriteProductMutationVariables>(RemoveFavoriteProductDocument, options)
}
export type RemoveFavoriteProductMutationHookResult = ReturnType<typeof useRemoveFavoriteProductMutation>;
export type RemoveFavoriteProductMutationResult = Apollo.MutationResult<RemoveFavoriteProductMutation>;
export type RemoveFavoriteProductMutationOptions = Apollo.BaseMutationOptions<RemoveFavoriteProductMutation, RemoveFavoriteProductMutationVariables>;
export const SaveFeedbackDocument = gql`
    mutation SaveFeedback($feedbackInfo: FeedbackInput!) {
  saveFeedback(feedbackInfo: $feedbackInfo) {
    id
    brand_id
    order_id
    shop_id
    review
    general_rating
    assemble_rating
    shipping_rating
    product_rating
    need_call
    images {
      url
    }
  }
}
    `
export type SaveFeedbackMutationFn = Apollo.MutationFunction<SaveFeedbackMutation, SaveFeedbackMutationVariables>;

/**
 * __useSaveFeedbackMutation__
 *
 * To run a mutation, you first call `useSaveFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFeedbackMutation, { data, loading, error }] = useSaveFeedbackMutation({
 *   variables: {
 *      feedbackInfo: // value for 'feedbackInfo'
 *   },
 * });
 */
export function useSaveFeedbackMutation (baseOptions?: Apollo.MutationHookOptions<SaveFeedbackMutation, SaveFeedbackMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<SaveFeedbackMutation, SaveFeedbackMutationVariables>(SaveFeedbackDocument, options)
}
export type SaveFeedbackMutationHookResult = ReturnType<typeof useSaveFeedbackMutation>;
export type SaveFeedbackMutationResult = Apollo.MutationResult<SaveFeedbackMutation>;
export type SaveFeedbackMutationOptions = Apollo.BaseMutationOptions<SaveFeedbackMutation, SaveFeedbackMutationVariables>;
export const CustomerActivePaymentMethodsDocument = gql`
    query CustomerActivePaymentMethods($paymentPluginId: String) {
  customerActivePaymentMethods(paymentPluginId: $paymentPluginId) {
    id
    type
    card
    last
    country
    pluginId
    isDefault
  }
}
    `

/**
 * __useCustomerActivePaymentMethodsQuery__
 *
 * To run a query within a React component, call `useCustomerActivePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerActivePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerActivePaymentMethodsQuery({
 *   variables: {
 *      paymentPluginId: // value for 'paymentPluginId'
 *   },
 * });
 */
export function useCustomerActivePaymentMethodsQuery (baseOptions?: Apollo.QueryHookOptions<CustomerActivePaymentMethodsQuery, CustomerActivePaymentMethodsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<CustomerActivePaymentMethodsQuery, CustomerActivePaymentMethodsQueryVariables>(CustomerActivePaymentMethodsDocument, options)
}
export function useCustomerActivePaymentMethodsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<CustomerActivePaymentMethodsQuery, CustomerActivePaymentMethodsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<CustomerActivePaymentMethodsQuery, CustomerActivePaymentMethodsQueryVariables>(CustomerActivePaymentMethodsDocument, options)
}
export function useCustomerActivePaymentMethodsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerActivePaymentMethodsQuery, CustomerActivePaymentMethodsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<CustomerActivePaymentMethodsQuery, CustomerActivePaymentMethodsQueryVariables>(CustomerActivePaymentMethodsDocument, options)
}
export type CustomerActivePaymentMethodsQueryHookResult = ReturnType<typeof useCustomerActivePaymentMethodsQuery>;
export type CustomerActivePaymentMethodsLazyQueryHookResult = ReturnType<typeof useCustomerActivePaymentMethodsLazyQuery>;
export type CustomerActivePaymentMethodsSuspenseQueryHookResult = ReturnType<typeof useCustomerActivePaymentMethodsSuspenseQuery>;
export type CustomerActivePaymentMethodsQueryResult = Apollo.QueryResult<CustomerActivePaymentMethodsQuery, CustomerActivePaymentMethodsQueryVariables>;
export const ChooseDefaultPaymentMethodDocument = gql`
    mutation ChooseDefaultPaymentMethod($paymentMethodId: ID!) {
  chooseDefaultPaymentMethod(paymentMethodId: $paymentMethodId) {
    id
    type
    card
    last
    country
    pluginId
    isDefault
  }
}
    `
export type ChooseDefaultPaymentMethodMutationFn = Apollo.MutationFunction<ChooseDefaultPaymentMethodMutation, ChooseDefaultPaymentMethodMutationVariables>;

/**
 * __useChooseDefaultPaymentMethodMutation__
 *
 * To run a mutation, you first call `useChooseDefaultPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChooseDefaultPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chooseDefaultPaymentMethodMutation, { data, loading, error }] = useChooseDefaultPaymentMethodMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useChooseDefaultPaymentMethodMutation (baseOptions?: Apollo.MutationHookOptions<ChooseDefaultPaymentMethodMutation, ChooseDefaultPaymentMethodMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ChooseDefaultPaymentMethodMutation, ChooseDefaultPaymentMethodMutationVariables>(ChooseDefaultPaymentMethodDocument, options)
}
export type ChooseDefaultPaymentMethodMutationHookResult = ReturnType<typeof useChooseDefaultPaymentMethodMutation>;
export type ChooseDefaultPaymentMethodMutationResult = Apollo.MutationResult<ChooseDefaultPaymentMethodMutation>;
export type ChooseDefaultPaymentMethodMutationOptions = Apollo.BaseMutationOptions<ChooseDefaultPaymentMethodMutation, ChooseDefaultPaymentMethodMutationVariables>;


export const ChoosePaymentMethodForOrderDocument = gql`
  mutation ChoosePaymentMethodForOrder($paymentMethodId: ID!, $orderId: ID!, $useAsDefault: Boolean, $markAsDefault: Boolean) {
    choosePaymentMethodForOrder(
      paymentMethodId: $paymentMethodId,
      orderId: $orderId,
      useAsDefault: $useAsDefault
      markAsDefault: $markAsDefault
    ) {
      paymentMethod {
        id
        type
        card
        last
        country
        pluginId
        isDefault
      }
      affectedOrdersAmount
      order {
        id
        paymentMethod {
          id
          type
          card
          last
          country
          pluginId
          isDefault
        }
      }
    }
  }
`

export function useChoosePaymentMethodForOrderMutation (baseOptions?: Apollo.MutationHookOptions<ChoosePaymentMethodForOrderMutation, ChoosePaymentMethodForOrderMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ChoosePaymentMethodForOrderMutation, ChoosePaymentMethodForOrderMutationVariables>(ChoosePaymentMethodForOrderDocument, options)
}

export const ChoosePaymentPluginDocument = gql`
    mutation ChoosePaymentPlugin($orderId: ID, $paymentPluginId: String, $source: String) {
  choosePaymentPlugin(
    orderId: $orderId
    paymentPluginId: $paymentPluginId
    source: $source
  ) {
    pluginId
    type
    payload {
      embed
      controllable
      redirect
    }
    operationId
  }
}
    `
export type ChoosePaymentPluginMutationFn = Apollo.MutationFunction<ChoosePaymentPluginMutation, ChoosePaymentPluginMutationVariables>;

/**
 * __useChoosePaymentPluginMutation__
 *
 * To run a mutation, you first call `useChoosePaymentPluginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChoosePaymentPluginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [choosePaymentPluginMutation, { data, loading, error }] = useChoosePaymentPluginMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      paymentPluginId: // value for 'paymentPluginId'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useChoosePaymentPluginMutation (baseOptions?: Apollo.MutationHookOptions<ChoosePaymentPluginMutation, ChoosePaymentPluginMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ChoosePaymentPluginMutation, ChoosePaymentPluginMutationVariables>(ChoosePaymentPluginDocument, options)
}
export type ChoosePaymentPluginMutationHookResult = ReturnType<typeof useChoosePaymentPluginMutation>;
export type ChoosePaymentPluginMutationResult = Apollo.MutationResult<ChoosePaymentPluginMutation>;
export type ChoosePaymentPluginMutationOptions = Apollo.BaseMutationOptions<ChoosePaymentPluginMutation, ChoosePaymentPluginMutationVariables>;
export const PaymentPluginDetailsDocument = gql`
    query PaymentPluginDetails($paymentPluginId: String) {
  paymentPluginDetails(paymentPluginId: $paymentPluginId) {
    id
    integrationType
    label
    description
  }
}
    `

/**
 * __usePaymentPluginDetailsQuery__
 *
 * To run a query within a React component, call `usePaymentPluginDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentPluginDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentPluginDetailsQuery({
 *   variables: {
 *      paymentPluginId: // value for 'paymentPluginId'
 *   },
 * });
 */
export function usePaymentPluginDetailsQuery (baseOptions?: Apollo.QueryHookOptions<PaymentPluginDetailsQuery, PaymentPluginDetailsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<PaymentPluginDetailsQuery, PaymentPluginDetailsQueryVariables>(PaymentPluginDetailsDocument, options)
}
export function usePaymentPluginDetailsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<PaymentPluginDetailsQuery, PaymentPluginDetailsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<PaymentPluginDetailsQuery, PaymentPluginDetailsQueryVariables>(PaymentPluginDetailsDocument, options)
}
export function usePaymentPluginDetailsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentPluginDetailsQuery, PaymentPluginDetailsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<PaymentPluginDetailsQuery, PaymentPluginDetailsQueryVariables>(PaymentPluginDetailsDocument, options)
}
export type PaymentPluginDetailsQueryHookResult = ReturnType<typeof usePaymentPluginDetailsQuery>;
export type PaymentPluginDetailsLazyQueryHookResult = ReturnType<typeof usePaymentPluginDetailsLazyQuery>;
export type PaymentPluginDetailsSuspenseQueryHookResult = ReturnType<typeof usePaymentPluginDetailsSuspenseQuery>;
export type PaymentPluginDetailsQueryResult = Apollo.QueryResult<PaymentPluginDetailsQuery, PaymentPluginDetailsQueryVariables>;
export const RemovePaymentMethodDocument = gql`
    mutation RemovePaymentMethod($removePaymentMethodId: ID!) {
  removePaymentMethod(id: $removePaymentMethodId) {
    id
    removed
  }
}
    `
export type RemovePaymentMethodMutationFn = Apollo.MutationFunction<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>;

/**
 * __useRemovePaymentMethodMutation__
 *
 * To run a mutation, you first call `useRemovePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePaymentMethodMutation, { data, loading, error }] = useRemovePaymentMethodMutation({
 *   variables: {
 *      removePaymentMethodId: // value for 'removePaymentMethodId'
 *   },
 * });
 */
export function useRemovePaymentMethodMutation (baseOptions?: Apollo.MutationHookOptions<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>(RemovePaymentMethodDocument, options)
}
export type RemovePaymentMethodMutationHookResult = ReturnType<typeof useRemovePaymentMethodMutation>;
export type RemovePaymentMethodMutationResult = Apollo.MutationResult<RemovePaymentMethodMutation>;
export type RemovePaymentMethodMutationOptions = Apollo.BaseMutationOptions<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>;
export const SearchProductsFullDocument = gql`
    query SearchProductsFull($shopId: ID!, $searchQuery: SearchQuery!, $style: String, $pager: CommonPagerInput, $filter: NestedFilterInput) {
  searchProducts(
    shop_id: $shopId
    searchQuery: $searchQuery
    pager: $pager
    filter: $filter
  ) {
    edges {
      ...ProductWithOffer
    }
    pageInfo {
      page
      perPage
      lastPage
      next
      total
    }
    filters {
      id
      label
      type
      filterInputFieldName
      values {
        name
        value
        gid
      }
      op
    }
  }
}
    ${ProductWithOfferFragmentDoc}`

/**
 * __useSearchProductsFullQuery__
 *
 * To run a query within a React component, call `useSearchProductsFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProductsFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProductsFullQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      searchQuery: // value for 'searchQuery'
 *      style: // value for 'style'
 *      pager: // value for 'pager'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchProductsFullQuery (baseOptions: Apollo.QueryHookOptions<SearchProductsFullQuery, SearchProductsFullQueryVariables> & ({ variables: SearchProductsFullQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<SearchProductsFullQuery, SearchProductsFullQueryVariables>(SearchProductsFullDocument, options)
}
export function useSearchProductsFullLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<SearchProductsFullQuery, SearchProductsFullQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<SearchProductsFullQuery, SearchProductsFullQueryVariables>(SearchProductsFullDocument, options)
}
export function useSearchProductsFullSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchProductsFullQuery, SearchProductsFullQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<SearchProductsFullQuery, SearchProductsFullQueryVariables>(SearchProductsFullDocument, options)
}
export type SearchProductsFullQueryHookResult = ReturnType<typeof useSearchProductsFullQuery>;
export type SearchProductsFullLazyQueryHookResult = ReturnType<typeof useSearchProductsFullLazyQuery>;
export type SearchProductsFullSuspenseQueryHookResult = ReturnType<typeof useSearchProductsFullSuspenseQuery>;
export type SearchProductsFullQueryResult = Apollo.QueryResult<SearchProductsFullQuery, SearchProductsFullQueryVariables>;
export const SearchProductsDocument = gql`
    query SearchProducts($shopId: ID!, $searchQuery: SearchQuery!, $style: String, $pager: CommonPagerInput) {
  searchProducts(shop_id: $shopId, searchQuery: $searchQuery, pager: $pager) {
    edges {
      ...ProductWithOffer
    }
  }
}
    ${ProductWithOfferFragmentDoc}`

/**
 * __useSearchProductsQuery__
 *
 * To run a query within a React component, call `useSearchProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProductsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      searchQuery: // value for 'searchQuery'
 *      style: // value for 'style'
 *      pager: // value for 'pager'
 *   },
 * });
 */
export function useSearchProductsQuery (baseOptions: Apollo.QueryHookOptions<SearchProductsQuery, SearchProductsQueryVariables> & ({ variables: SearchProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<SearchProductsQuery, SearchProductsQueryVariables>(SearchProductsDocument, options)
}
export function useSearchProductsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<SearchProductsQuery, SearchProductsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<SearchProductsQuery, SearchProductsQueryVariables>(SearchProductsDocument, options)
}
export function useSearchProductsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchProductsQuery, SearchProductsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<SearchProductsQuery, SearchProductsQueryVariables>(SearchProductsDocument, options)
}
export type SearchProductsQueryHookResult = ReturnType<typeof useSearchProductsQuery>;
export type SearchProductsLazyQueryHookResult = ReturnType<typeof useSearchProductsLazyQuery>;
export type SearchProductsSuspenseQueryHookResult = ReturnType<typeof useSearchProductsSuspenseQuery>;
export type SearchProductsQueryResult = Apollo.QueryResult<SearchProductsQuery, SearchProductsQueryVariables>;
export const DeleteAddressDocument = gql`
    mutation DeleteAddress($deleteAddressId: ID!) {
  deleteAddress(id: $deleteAddressId)
}
    `
export type DeleteAddressMutationFn = Apollo.MutationFunction<DeleteAddressMutation, DeleteAddressMutationVariables>;

/**
 * __useDeleteAddressMutation__
 *
 * To run a mutation, you first call `useDeleteAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAddressMutation, { data, loading, error }] = useDeleteAddressMutation({
 *   variables: {
 *      deleteAddressId: // value for 'deleteAddressId'
 *   },
 * });
 */
export function useDeleteAddressMutation (baseOptions?: Apollo.MutationHookOptions<DeleteAddressMutation, DeleteAddressMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DeleteAddressMutation, DeleteAddressMutationVariables>(DeleteAddressDocument, options)
}
export type DeleteAddressMutationHookResult = ReturnType<typeof useDeleteAddressMutation>;
export type DeleteAddressMutationResult = Apollo.MutationResult<DeleteAddressMutation>;
export type DeleteAddressMutationOptions = Apollo.BaseMutationOptions<DeleteAddressMutation, DeleteAddressMutationVariables>;
export const SaveAddressDocument = gql`
    mutation SaveAddress($addressInfo: CustomerAddressInput!) {
  saveAddress(addressInfo: $addressInfo) {
    id
    label
    shop_id
    shop {
      id
      name
      address
    }
    address
    address_appartments
    address_intercom
    address_porch
    address_floor
    door_delivery
    no_door_call
    other_recipient
    recipient_phone
    recipient_name
    recipient_last_name
    comment
  }
}
    `
export type SaveAddressMutationFn = Apollo.MutationFunction<SaveAddressMutation, SaveAddressMutationVariables>;

/**
 * __useSaveAddressMutation__
 *
 * To run a mutation, you first call `useSaveAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAddressMutation, { data, loading, error }] = useSaveAddressMutation({
 *   variables: {
 *      addressInfo: // value for 'addressInfo'
 *   },
 * });
 */
export function useSaveAddressMutation (baseOptions?: Apollo.MutationHookOptions<SaveAddressMutation, SaveAddressMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<SaveAddressMutation, SaveAddressMutationVariables>(SaveAddressDocument, options)
}
export type SaveAddressMutationHookResult = ReturnType<typeof useSaveAddressMutation>;
export type SaveAddressMutationResult = Apollo.MutationResult<SaveAddressMutation>;
export type SaveAddressMutationOptions = Apollo.BaseMutationOptions<SaveAddressMutation, SaveAddressMutationVariables>;
export const ShopsInGeoPolygonDocument = gql`
    query ShopsInGeoPolygon($corners: [GeoPointInput]!, $useZone: Boolean, $customerType: String) {
  shopsInGeoPolygon(
    corners: $corners
    useZone: $useZone
    customerType: $customerType
  ) {
    id
    name
    address
    geo_point {
      latitude
      longitude
    }
    geo_delivery_zone
    status
    slug
    min_price
    minOrderCost
    delivery_cost
    first_delivery_cost
    phone
    open_time
    close_time
    shopGeoPoint {
      latitude
      longitude
    }
    brand_id
    brand {
      id
      name
      status
      shops {
        id
        name
        address
        geo_point {
          latitude
          longitude
        }
        shopGeoPoint {
          latitude
          longitude
        }
        shopPickupDeliveryCost
        isPickupDeliveryAvailable
        shopHasPickupDelivery
        images {
          url
        }
        city_id
        firstAvailableSlot {
          id
          slotTime
          slotDate
          shop_id
          availableUntil
          zone_id
          shop {
            id
            name
            address
            geo_point {
              latitude
              longitude
            }
            status
            slug
            min_price
            minOrderCost
            delivery_cost
            phone
            open_time
            close_time
            shopGeoPoint {
              latitude
              longitude
            }
            shopPickupDeliveryCost
            isPickupDeliveryAvailable
            city_id
          }
        }
      }
    }
    isPickupDeliveryAvailable
    firstAvailableSlot {
      id
      slotTime
      slotDate
      shop_id
      availableUntil
      zone_id
    }
    shopTags {
      id
      name
    }
    city_id
  }
}
    `

/**
 * __useShopsInGeoPolygonQuery__
 *
 * To run a query within a React component, call `useShopsInGeoPolygonQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopsInGeoPolygonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopsInGeoPolygonQuery({
 *   variables: {
 *      corners: // value for 'corners'
 *      useZone: // value for 'useZone'
 *      customerType: // value for 'customerType'
 *   },
 * });
 */
export function useShopsInGeoPolygonQuery (baseOptions: Apollo.QueryHookOptions<ShopsInGeoPolygonQuery, ShopsInGeoPolygonQueryVariables> & ({ variables: ShopsInGeoPolygonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<ShopsInGeoPolygonQuery, ShopsInGeoPolygonQueryVariables>(ShopsInGeoPolygonDocument, options)
}
export function useShopsInGeoPolygonLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<ShopsInGeoPolygonQuery, ShopsInGeoPolygonQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<ShopsInGeoPolygonQuery, ShopsInGeoPolygonQueryVariables>(ShopsInGeoPolygonDocument, options)
}
export function useShopsInGeoPolygonSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShopsInGeoPolygonQuery, ShopsInGeoPolygonQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<ShopsInGeoPolygonQuery, ShopsInGeoPolygonQueryVariables>(ShopsInGeoPolygonDocument, options)
}
export type ShopsInGeoPolygonQueryHookResult = ReturnType<typeof useShopsInGeoPolygonQuery>;
export type ShopsInGeoPolygonLazyQueryHookResult = ReturnType<typeof useShopsInGeoPolygonLazyQuery>;
export type ShopsInGeoPolygonSuspenseQueryHookResult = ReturnType<typeof useShopsInGeoPolygonSuspenseQuery>;
export type ShopsInGeoPolygonQueryResult = Apollo.QueryResult<ShopsInGeoPolygonQuery, ShopsInGeoPolygonQueryVariables>;
export const GetBarcodeDocument = gql`
    query GetBarcode {
  getBarcode {
    code
    type
  }
}
    `

/**
 * __useGetBarcodeQuery__
 *
 * To run a query within a React component, call `useGetBarcodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBarcodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBarcodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBarcodeQuery (baseOptions?: Apollo.QueryHookOptions<GetBarcodeQuery, GetBarcodeQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetBarcodeQuery, GetBarcodeQueryVariables>(GetBarcodeDocument, options)
}
export function useGetBarcodeLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<GetBarcodeQuery, GetBarcodeQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetBarcodeQuery, GetBarcodeQueryVariables>(GetBarcodeDocument, options)
}
export function useGetBarcodeSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBarcodeQuery, GetBarcodeQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<GetBarcodeQuery, GetBarcodeQueryVariables>(GetBarcodeDocument, options)
}
export type GetBarcodeQueryHookResult = ReturnType<typeof useGetBarcodeQuery>;
export type GetBarcodeLazyQueryHookResult = ReturnType<typeof useGetBarcodeLazyQuery>;
export type GetBarcodeSuspenseQueryHookResult = ReturnType<typeof useGetBarcodeSuspenseQuery>;
export type GetBarcodeQueryResult = Apollo.QueryResult<GetBarcodeQuery, GetBarcodeQueryVariables>;
export const InitializeOrderWithCartDocument = gql`
    query InitializeOrderWithCart($shopId: ID!, $cart: CartInfoInput) {
  initializeOrderWithCart(shop_id: $shopId, cart: $cart) {
    id
    business_profile_id
    uuid
    shop_id
    status
    step
    total
    delivery_total
    address
    comment
    customer_phone
    address_appartments
    address_intercom
    address_porch
    address_floor
    door_delivery
    receipt_email
    assembly_method
    slot_id
    deliveryType
    recipientInfo {
      phone
      firstName
      lastName
    }
    totalCashback
    totalDiscount
    customerCourierMessage
    payment_id
    paymentMethod {
      id
      type
      card
      last
      country
    }
  }
}
    `

/**
 * __useInitializeOrderWithCartQuery__
 *
 * To run a query within a React component, call `useInitializeOrderWithCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitializeOrderWithCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitializeOrderWithCartQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      cart: // value for 'cart'
 *   },
 * });
 */
export function useInitializeOrderWithCartQuery (baseOptions: Apollo.QueryHookOptions<InitializeOrderWithCartQuery, InitializeOrderWithCartQueryVariables> & ({ variables: InitializeOrderWithCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<InitializeOrderWithCartQuery, InitializeOrderWithCartQueryVariables>(InitializeOrderWithCartDocument, options)
}
export function useInitializeOrderWithCartLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<InitializeOrderWithCartQuery, InitializeOrderWithCartQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<InitializeOrderWithCartQuery, InitializeOrderWithCartQueryVariables>(InitializeOrderWithCartDocument, options)
}
export function useInitializeOrderWithCartSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InitializeOrderWithCartQuery, InitializeOrderWithCartQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<InitializeOrderWithCartQuery, InitializeOrderWithCartQueryVariables>(InitializeOrderWithCartDocument, options)
}
export type InitializeOrderWithCartQueryHookResult = ReturnType<typeof useInitializeOrderWithCartQuery>;
export type InitializeOrderWithCartLazyQueryHookResult = ReturnType<typeof useInitializeOrderWithCartLazyQuery>;
export type InitializeOrderWithCartSuspenseQueryHookResult = ReturnType<typeof useInitializeOrderWithCartSuspenseQuery>;
export type InitializeOrderWithCartQueryResult = Apollo.QueryResult<InitializeOrderWithCartQuery, InitializeOrderWithCartQueryVariables>;
export const InitializeOrderDocument = gql`
    query InitializeOrder($shopId: ID!) {
  initializeOrder(shop_id: $shopId) {
    id
    business_profile_id
    uuid
    shop_id
    status
    step
    total
    delivery_total
    address
    comment
    customer_phone
    customer_geoposition {
      latitude
      longitude
    }
    address_appartments
    address_intercom
    address_porch
    address_floor
    door_delivery
    receipt_email
    assembly_method
    slot_id
    deliveryType
    recipientInfo {
      phone
      firstName
      lastName
    }
    totalCashback
    totalDiscount
    customerCourierMessage
    payment_id
    paymentMethod {
      id
      type
      card
      last
      country
    }
  }
}
    `

/**
 * __useInitializeOrderQuery__
 *
 * To run a query within a React component, call `useInitializeOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitializeOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitializeOrderQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useInitializeOrderQuery (baseOptions: Apollo.QueryHookOptions<InitializeOrderQuery, InitializeOrderQueryVariables> & ({ variables: InitializeOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<InitializeOrderQuery, InitializeOrderQueryVariables>(InitializeOrderDocument, options)
}
export function useInitializeOrderLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<InitializeOrderQuery, InitializeOrderQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<InitializeOrderQuery, InitializeOrderQueryVariables>(InitializeOrderDocument, options)
}
export function useInitializeOrderSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InitializeOrderQuery, InitializeOrderQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<InitializeOrderQuery, InitializeOrderQueryVariables>(InitializeOrderDocument, options)
}
export type InitializeOrderQueryHookResult = ReturnType<typeof useInitializeOrderQuery>;
export type InitializeOrderLazyQueryHookResult = ReturnType<typeof useInitializeOrderLazyQuery>;
export type InitializeOrderSuspenseQueryHookResult = ReturnType<typeof useInitializeOrderSuspenseQuery>;
export type InitializeOrderQueryResult = Apollo.QueryResult<InitializeOrderQuery, InitializeOrderQueryVariables>;
export const PlaceOrderDocument = gql`
    mutation PlaceOrder($orderId: ID!) {
  placeOrder(order_id: $orderId) {
    error_code
    order_id
    placed
    message
  }
}
    `
export type PlaceOrderMutationFn = Apollo.MutationFunction<PlaceOrderMutation, PlaceOrderMutationVariables>;

/**
 * __usePlaceOrderMutation__
 *
 * To run a mutation, you first call `usePlaceOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeOrderMutation, { data, loading, error }] = usePlaceOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function usePlaceOrderMutation (baseOptions?: Apollo.MutationHookOptions<PlaceOrderMutation, PlaceOrderMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<PlaceOrderMutation, PlaceOrderMutationVariables>(PlaceOrderDocument, options)
}
export type PlaceOrderMutationHookResult = ReturnType<typeof usePlaceOrderMutation>;
export type PlaceOrderMutationResult = Apollo.MutationResult<PlaceOrderMutation>;
export type PlaceOrderMutationOptions = Apollo.BaseMutationOptions<PlaceOrderMutation, PlaceOrderMutationVariables>;
export const UpdateOrderInfoWithSlotCheckDocument = gql`
    mutation UpdateOrderInfoWithSlotCheck($orderId: ID!, $orderInfo: OrderInfoInput) {
  updateOrderInfoWithSlotCheck(order_id: $orderId, orderInfo: $orderInfo) {
    isOk
    notifySlotChanged
    orderInfo {
      id
      status
      courier_phone
      slot_id
    }
  }
}
    `
export type UpdateOrderInfoWithSlotCheckMutationFn = Apollo.MutationFunction<UpdateOrderInfoWithSlotCheckMutation, UpdateOrderInfoWithSlotCheckMutationVariables>;

/**
 * __useUpdateOrderInfoWithSlotCheckMutation__
 *
 * To run a mutation, you first call `useUpdateOrderInfoWithSlotCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderInfoWithSlotCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderInfoWithSlotCheckMutation, { data, loading, error }] = useUpdateOrderInfoWithSlotCheckMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      orderInfo: // value for 'orderInfo'
 *   },
 * });
 */
export function useUpdateOrderInfoWithSlotCheckMutation (baseOptions?: Apollo.MutationHookOptions<UpdateOrderInfoWithSlotCheckMutation, UpdateOrderInfoWithSlotCheckMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateOrderInfoWithSlotCheckMutation, UpdateOrderInfoWithSlotCheckMutationVariables>(UpdateOrderInfoWithSlotCheckDocument, options)
}
export type UpdateOrderInfoWithSlotCheckMutationHookResult = ReturnType<typeof useUpdateOrderInfoWithSlotCheckMutation>;
export type UpdateOrderInfoWithSlotCheckMutationResult = Apollo.MutationResult<UpdateOrderInfoWithSlotCheckMutation>;
export type UpdateOrderInfoWithSlotCheckMutationOptions = Apollo.BaseMutationOptions<UpdateOrderInfoWithSlotCheckMutation, UpdateOrderInfoWithSlotCheckMutationVariables>;
export const AllMyOrdersDocument = gql`
    query AllMyOrders($pager: CommonPagerInput) {
  allMyOrders(pager: $pager) {
    edges {
      id
      shop_id
      shop {
        id
        name
        address
        status
      }
      created_at
      status
      total
      customerFinalCost
      deliveryCost
      address
      deliverySlot {
        id
        slotTime
        slotDate
        shop_id
        availableUntil
        zone_id
      }
      paymentMethod {
        id
        type
        card
        last
        isDefault
      }
      meta {
        id
        product_id
        shop_id
        name
        price
        count
        weight
        total_weight
        total
        status
        assembly_method
        assembled_count
        assembled_total
        cashback
        unit_multiplier
        changedBy {
          id
          product_id
          shop_id
          name
          price
          unit_multiplier
          count
          weight
          total_weight
          total
          status
          assembly_method
          assembled_count
          assembled_weight
          assembled_total
          cashback
        }
        isChangeTo {
          id
          product_id
          shop_id
          name
          price
          unit_multiplier
          count
          weight
          total_weight
          total
          status
          assembly_method
          assembled_count
          assembled_weight
          assembled_total
          cashback
        }
        product {
          ...ProductBaseFields
        }
      }
      totalCashback
      totalDiscount
      deliveryType
      deliveryClaim {
        id
        packagePickupCode
        customerPickupCode
      }
    }
    pageInfo {
      page
      perPage
      lastPage
      next
      total
    }
  }
}
    ${ProductBaseFieldsFragmentDoc}`

/**
 * __useAllMyOrdersQuery__
 *
 * To run a query within a React component, call `useAllMyOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMyOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMyOrdersQuery({
 *   variables: {
 *      pager: // value for 'pager'
 *      style: // value for 'style'
 *   },
 * });
 */
export function useAllMyOrdersQuery (baseOptions?: Apollo.QueryHookOptions<AllMyOrdersQuery, AllMyOrdersQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<AllMyOrdersQuery, AllMyOrdersQueryVariables>(AllMyOrdersDocument, options)
}
export function useAllMyOrdersLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<AllMyOrdersQuery, AllMyOrdersQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<AllMyOrdersQuery, AllMyOrdersQueryVariables>(AllMyOrdersDocument, options)
}
export function useAllMyOrdersSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllMyOrdersQuery, AllMyOrdersQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<AllMyOrdersQuery, AllMyOrdersQueryVariables>(AllMyOrdersDocument, options)
}
export type AllMyOrdersQueryHookResult = ReturnType<typeof useAllMyOrdersQuery>;
export type AllMyOrdersLazyQueryHookResult = ReturnType<typeof useAllMyOrdersLazyQuery>;
export type AllMyOrdersSuspenseQueryHookResult = ReturnType<typeof useAllMyOrdersSuspenseQuery>;
export type AllMyOrdersQueryResult = Apollo.QueryResult<AllMyOrdersQuery, AllMyOrdersQueryVariables>;
export const OfflinePurchasesDocument = gql`
    query OfflinePurchases($limit: Int, $offset: Int, $style: String) {
  offlinePurchases(limit: $limit, offset: $offset) {
    id
    shop_id
    created_at
    placed_at
    status
    total
    saledCost
    customerFinalCost
    deliveryCost
    weight
    address
    comment
    slot_id
    deliverySlot {
      id
      slotTime
      slotDate
      shop_id
      availableUntil
      zone_id
      period {
        from
        to
      }
    }
    payment_status
    payment_type
    cash_change
    payment_token_id
    payment_id
    paymentMethod {
      id
      type
      card
      last
      country
      pluginId
      isDefault
    }
    assembled_total
    meta {
      id
      product_id
      shop_id
      name
      price
      unit_multiplier
      count
      weight
      total_weight
      total
      status
      assembly_method
      assembled_count
      assembled_weight
      assembled_total
      product {
        ...ProductWithOffer
      }
      cashback
    }
    totalCashback
    totalDiscount
    saleInfo {
      type
      name
      discount
    }
    receipts {
      id
      type
      status
      receiptQueryString
      receiptPreviewUrl
    }
    reviewInvite
    pickup_code
    deliveryType
    placedAt
    assemblingFinishedAt
    deliveryFinishedAt
    paymentReceivedAt
    recipientInfo {
      phone
      firstName
      lastName
    }
  }
}
    ${ProductWithOfferFragmentDoc}`

/**
 * __useOfflinePurchasesQuery__
 *
 * To run a query within a React component, call `useOfflinePurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfflinePurchasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfflinePurchasesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      style: // value for 'style'
 *   },
 * });
 */
export function useOfflinePurchasesQuery (baseOptions?: Apollo.QueryHookOptions<OfflinePurchasesQuery, OfflinePurchasesQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<OfflinePurchasesQuery, OfflinePurchasesQueryVariables>(OfflinePurchasesDocument, options)
}
export function useOfflinePurchasesLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<OfflinePurchasesQuery, OfflinePurchasesQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<OfflinePurchasesQuery, OfflinePurchasesQueryVariables>(OfflinePurchasesDocument, options)
}
export function useOfflinePurchasesSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OfflinePurchasesQuery, OfflinePurchasesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<OfflinePurchasesQuery, OfflinePurchasesQueryVariables>(OfflinePurchasesDocument, options)
}
export type OfflinePurchasesQueryHookResult = ReturnType<typeof useOfflinePurchasesQuery>;
export type OfflinePurchasesLazyQueryHookResult = ReturnType<typeof useOfflinePurchasesLazyQuery>;
export type OfflinePurchasesSuspenseQueryHookResult = ReturnType<typeof useOfflinePurchasesSuspenseQuery>;
export type OfflinePurchasesQueryResult = Apollo.QueryResult<OfflinePurchasesQuery, OfflinePurchasesQueryVariables>;
export const MyAddressesDocument = gql`
    query MyAddresses($showPickupShops: Boolean) {
  myAddresses(showPickupShops: $showPickupShops) {
    id
    label
    shop_id
    shop {
      id
      name
      address
      geo_point {
        latitude
        longitude
      }
      shopGeoPoint {
        latitude
        longitude
      }
      brand {
        id
        name
      }
      firstAvailableSlot {
        id
        slotTime
        slotDate
        period {
          from
          to
        }
        shop_id
        availableUntil
        zone_id
      }
      shopTags {
        id
        name
        icon {
          url
        }
      }
      images {
        url
      }
      deliveryZones {
        id
        name
        shop_id
        zoneGeoDeliveryZone {
          latitude
          longitude
        }
        firstAvailableSlot {
          id
          slotTime
          slotDate
          shop_id
          availableUntil
          zone_id
        }
      }
      distance
    }
    address
    address_appartments
    address_intercom
    address_porch
    address_floor
    door_delivery
    no_door_call
    customerGeoPoint {
      latitude
      longitude
    }
    other_recipient
    recipient_phone
    recipient_name
    recipient_last_name
    comment
  }
}
    `

/**
 * __useMyAddressesQuery__
 *
 * To run a query within a React component, call `useMyAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAddressesQuery({
 *   variables: {
 *      showPickupShops: // value for 'showPickupShops'
 *   },
 * });
 */
export function useMyAddressesQuery (baseOptions?: Apollo.QueryHookOptions<MyAddressesQuery, MyAddressesQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<MyAddressesQuery, MyAddressesQueryVariables>(MyAddressesDocument, options)
}
export function useMyAddressesLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<MyAddressesQuery, MyAddressesQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<MyAddressesQuery, MyAddressesQueryVariables>(MyAddressesDocument, options)
}
export function useMyAddressesSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyAddressesQuery, MyAddressesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<MyAddressesQuery, MyAddressesQueryVariables>(MyAddressesDocument, options)
}
export type MyAddressesQueryHookResult = ReturnType<typeof useMyAddressesQuery>;
export type MyAddressesLazyQueryHookResult = ReturnType<typeof useMyAddressesLazyQuery>;
export type MyAddressesSuspenseQueryHookResult = ReturnType<typeof useMyAddressesSuspenseQuery>;
export type MyAddressesQueryResult = Apollo.QueryResult<MyAddressesQuery, MyAddressesQueryVariables>;
export const MyBonusTotalDocument = gql`
    query MyBonusTotal {
  myBonus {
    bonusBalance
    bonusCards {
      id
      cardNumber
      barCode
      status
    }
    activeBonuses
    pendingBonuses {
      amount
      nextActivationAmount
      activationDate
    }
    nearestExpiringBonus {
      expireAmount
      expireAt
    }
  }
}
    `

/**
 * __useMyBonusTotalQuery__
 *
 * To run a query within a React component, call `useMyBonusTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyBonusTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyBonusTotalQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyBonusTotalQuery (baseOptions?: Apollo.QueryHookOptions<MyBonusTotalQuery, MyBonusTotalQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<MyBonusTotalQuery, MyBonusTotalQueryVariables>(MyBonusTotalDocument, options)
}
export function useMyBonusTotalLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<MyBonusTotalQuery, MyBonusTotalQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<MyBonusTotalQuery, MyBonusTotalQueryVariables>(MyBonusTotalDocument, options)
}
export function useMyBonusTotalSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyBonusTotalQuery, MyBonusTotalQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<MyBonusTotalQuery, MyBonusTotalQueryVariables>(MyBonusTotalDocument, options)
}
export type MyBonusTotalQueryHookResult = ReturnType<typeof useMyBonusTotalQuery>;
export type MyBonusTotalLazyQueryHookResult = ReturnType<typeof useMyBonusTotalLazyQuery>;
export type MyBonusTotalSuspenseQueryHookResult = ReturnType<typeof useMyBonusTotalSuspenseQuery>;
export type MyBonusTotalQueryResult = Apollo.QueryResult<MyBonusTotalQuery, MyBonusTotalQueryVariables>;
export const MyBonusHistoryDocument = gql`
    query MyBonusHistory {
  bonusHistory {
    id
    accountType
    type
    amount
    saledAt
    operationAt
    activationAt
    expireAt
    purchaseId
    comment
  }
}
    `

/**
 * __useMyBonusHistoryQuery__
 *
 * To run a query within a React component, call `useMyBonusHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyBonusHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyBonusHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyBonusHistoryQuery (baseOptions?: Apollo.QueryHookOptions<MyBonusHistoryQuery, MyBonusHistoryQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<MyBonusHistoryQuery, MyBonusHistoryQueryVariables>(MyBonusHistoryDocument, options)
}
export function useMyBonusHistoryLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<MyBonusHistoryQuery, MyBonusHistoryQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<MyBonusHistoryQuery, MyBonusHistoryQueryVariables>(MyBonusHistoryDocument, options)
}
export function useMyBonusHistorySuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyBonusHistoryQuery, MyBonusHistoryQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<MyBonusHistoryQuery, MyBonusHistoryQueryVariables>(MyBonusHistoryDocument, options)
}
export type MyBonusHistoryQueryHookResult = ReturnType<typeof useMyBonusHistoryQuery>;
export type MyBonusHistoryLazyQueryHookResult = ReturnType<typeof useMyBonusHistoryLazyQuery>;
export type MyBonusHistorySuspenseQueryHookResult = ReturnType<typeof useMyBonusHistorySuspenseQuery>;
export type MyBonusHistoryQueryResult = Apollo.QueryResult<MyBonusHistoryQuery, MyBonusHistoryQueryVariables>;
export const AvailableSlotsDocument = gql`
    query AvailableSlots($shopId: ID, $zoneId: ID) {
  availableSlots(shop_id: $shopId, zone_id: $zoneId) {
    id
    shop {
      id
      name
      address
    }
    slotTime
    slotDate
    period {
      from
      to
    }
    shop_id
    availableUntil
    zone_id
  }
}
    `

/**
 * __useAvailableSlotsQuery__
 *
 * To run a query within a React component, call `useAvailableSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableSlotsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      zoneId: // value for 'zoneId'
 *   },
 * });
 */
export function useAvailableSlotsQuery (baseOptions?: Apollo.QueryHookOptions<AvailableSlotsQuery, AvailableSlotsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<AvailableSlotsQuery, AvailableSlotsQueryVariables>(AvailableSlotsDocument, options)
}
export function useAvailableSlotsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<AvailableSlotsQuery, AvailableSlotsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<AvailableSlotsQuery, AvailableSlotsQueryVariables>(AvailableSlotsDocument, options)
}
export function useAvailableSlotsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableSlotsQuery, AvailableSlotsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<AvailableSlotsQuery, AvailableSlotsQueryVariables>(AvailableSlotsDocument, options)
}
export type AvailableSlotsQueryHookResult = ReturnType<typeof useAvailableSlotsQuery>;
export type AvailableSlotsLazyQueryHookResult = ReturnType<typeof useAvailableSlotsLazyQuery>;
export type AvailableSlotsSuspenseQueryHookResult = ReturnType<typeof useAvailableSlotsSuspenseQuery>;
export type AvailableSlotsQueryResult = Apollo.QueryResult<AvailableSlotsQuery, AvailableSlotsQueryVariables>;
